//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
} from 'axios';
import {
  VifModuleInfo,
  EntityLevel,
  SpecialGradeLevel,
  PermissionChangeType,
  GymMode,
  JtfMode,
  KnowAndShowLevel,
  GradeLevel,
  LoginType,
  MetaKey,
  ModuleInfo,
  MembershipCardType,
  TimeOnTaskProgressType,
  ArithmeticOperation,
  GoalsIndexPhase,
  Locale,
  NotificationType,
  TeamTopPlayersType,
  PrePostMode,
  Mode,
  ModuleAreaId,
} from '@suntex.fim/enums';
import { PlayerId, TeamId, SchoolId, LoginId, UserId } from './tagged-scalars';

export class Client {
  public static DEFAULT_API_VERSION = '1';
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @return OK
   */
  get_Admin_States(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_States_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/states?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_States(_response);
      });
  }

  protected processGet_Admin_States(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_States_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_States_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_States_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_Regions(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_Regions_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/regions?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_Regions(_response);
      });
  }

  protected processGet_Admin_Regions(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_Regions_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_Regions_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_Regions_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_Districts(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_Districts_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/districts?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_Districts(_response);
      });
  }

  protected processGet_Admin_Districts(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_Districts_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_Districts_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_Districts_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_Schools(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_Schools_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/schools?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_Schools(_response);
      });
  }

  protected processGet_Admin_Schools(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_Schools_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_Schools_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_Schools_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_Teams(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_Teams_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/teams?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_Teams(_response);
      });
  }

  protected processGet_Admin_Teams(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_Teams_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_Teams_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_Teams_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_Players(
    {
      text,
      page,
    }: {
      text: string;
      page: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_Players_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/players?';
    if (text === undefined || text === null)
      throw new Error(
        "The parameter 'text' must be defined and cannot be null.",
      );
    else url_ += 'Text=' + encodeURIComponent('' + text) + '&';
    if (page === undefined || page === null)
      throw new Error(
        "The parameter 'page' must be defined and cannot be null.",
      );
    else url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_Players(_response);
      });
  }

  protected processGet_Admin_Players(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_Players_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_Players_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_Players_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin(
    {
      year,
    }: {
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_StatesByLogin_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin?';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin(_response);
      });
  }

  protected processGet_Admin(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_StatesByLogin_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_StatesByLogin_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_StatesByLogin_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Admin_RegionsByState(
    {
      parentEntityId,
      year,
    }: {
      parentEntityId: number;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_RegionsByState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/regions-by-state?';
    if (parentEntityId === undefined || parentEntityId === null)
      throw new Error(
        "The parameter 'parentEntityId' must be defined and cannot be null.",
      );
    else
      url_ += 'ParentEntityId=' + encodeURIComponent('' + parentEntityId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_RegionsByState(_response);
      });
  }

  protected processGet_Admin_RegionsByState(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_RegionsByState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_RegionsByState_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_RegionsByState_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Admin_DistrictsByRegion(
    {
      parentEntityId,
      year,
    }: {
      parentEntityId: number;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_DistrictsByRegion_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/districts-by-region?';
    if (parentEntityId === undefined || parentEntityId === null)
      throw new Error(
        "The parameter 'parentEntityId' must be defined and cannot be null.",
      );
    else
      url_ += 'ParentEntityId=' + encodeURIComponent('' + parentEntityId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_DistrictsByRegion(_response);
      });
  }

  protected processGet_Admin_DistrictsByRegion(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_DistrictsByRegion_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_DistrictsByRegion_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_DistrictsByRegion_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Admin_SchoolsByDistrict(
    {
      parentEntityId,
      year,
    }: {
      parentEntityId: number;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_SchoolsByDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/schools-by-district?';
    if (parentEntityId === undefined || parentEntityId === null)
      throw new Error(
        "The parameter 'parentEntityId' must be defined and cannot be null.",
      );
    else
      url_ += 'ParentEntityId=' + encodeURIComponent('' + parentEntityId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_SchoolsByDistrict(_response);
      });
  }

  protected processGet_Admin_SchoolsByDistrict(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_SchoolsByDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_SchoolsByDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_SchoolsByDistrict_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Admin_TeamsBySchool(
    {
      parentEntityId,
      year,
    }: {
      parentEntityId: number;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Models_Api_Admin_TeamsBySchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/teams-by-school?';
    if (parentEntityId === undefined || parentEntityId === null)
      throw new Error(
        "The parameter 'parentEntityId' must be defined and cannot be null.",
      );
    else
      url_ += 'ParentEntityId=' + encodeURIComponent('' + parentEntityId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_TeamsBySchool(_response);
      });
  }

  protected processGet_Admin_TeamsBySchool(
    response: AxiosResponse,
  ): Promise<Models_Api_Admin_TeamsBySchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Models_Api_Admin_TeamsBySchool_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Models_Api_Admin_TeamsBySchool_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Admin_AppFeedback(
    {
      pageNumber,
      pageSize,
    }: {
      pageNumber: number;
      pageSize: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Admin_AppFeedback_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/app-feedback?';
    if (pageNumber === undefined || pageNumber === null)
      throw new Error(
        "The parameter 'pageNumber' must be defined and cannot be null.",
      );
    else url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === undefined || pageSize === null)
      throw new Error(
        "The parameter 'pageSize' must be defined and cannot be null.",
      );
    else url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_AppFeedback(_response);
      });
  }

  protected processGet_Admin_AppFeedback(
    response: AxiosResponse,
  ): Promise<Entities_Admin_AppFeedback_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Admin_AppFeedback_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Admin_AppFeedback_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Admin_UserFeedback(
    {
      pageNumber,
      pageSize,
    }: {
      pageNumber: number;
      pageSize: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Admin_UserFeedback_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/admin/user-feedback?';
    if (pageNumber === undefined || pageNumber === null)
      throw new Error(
        "The parameter 'pageNumber' must be defined and cannot be null.",
      );
    else url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === undefined || pageSize === null)
      throw new Error(
        "The parameter 'pageSize' must be defined and cannot be null.",
      );
    else url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Admin_UserFeedback(_response);
      });
  }

  protected processGet_Admin_UserFeedback(
    response: AxiosResponse,
  ): Promise<Entities_Admin_UserFeedback_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Admin_UserFeedback_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Admin_UserFeedback_Response>(null as any);
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param phase GoalsIndexPhase

    - `1` = Early
    - `2` = Elementary
    - `3` = Intermediate
    - `4` = Advanced
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsIndex(
    {
      id,
      level,
      year,
      phase,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string | undefined;
      phase: GoalsIndexPhase;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsIndex_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-index?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (phase === undefined || phase === null)
      throw new Error(
        "The parameter 'phase' must be defined and cannot be null.",
      );
    else url_ += 'Phase=' + encodeURIComponent('' + phase) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsIndex(_response);
      });
  }

  protected processGet_Assessment_GoalsIndex(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsIndex_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsIndex_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsIndex_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_AlgebraGoalsMetric(
    {
      id,
      level,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_AlgebraGoalsMetric_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/algebra-goals-metric?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_AlgebraGoalsMetric(_response);
      });
  }

  protected processGet_Assessment_AlgebraGoalsMetric(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_AlgebraGoalsMetric_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_AlgebraGoalsMetric_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_AlgebraGoalsMetric_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_SummaryTeam(
    {
      entityId,
    }: {
      entityId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_TeamSummary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/summary/team?';
    if (entityId === undefined || entityId === null)
      throw new Error(
        "The parameter 'entityId' must be defined and cannot be null.",
      );
    else url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_SummaryTeam(_response);
      });
  }

  protected processGet_Assessment_SummaryTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_TeamSummary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_TeamSummary_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_TeamSummary_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade (optional) SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsInfoGyms(
    {
      id,
      level,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string | undefined;
      grade: SpecialGradeLevel | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsInfoGyms_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-info-gyms?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === null)
      throw new Error("The parameter 'grade' cannot be null.");
    else if (grade !== undefined)
      url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsInfoGyms(_response);
      });
  }

  protected processGet_Assessment_GoalsInfoGyms(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsInfoGyms_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsInfoGyms_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsInfoGyms_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_VeryImportantFactsAggregatedByLevel(
    {
      id,
      level,
      year,
      aggregateLevel,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string;
      aggregateLevel: EntityLevel;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_VeryImportantFactsAggregatedByLevel_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl +
      '/api/assessment/very-important-facts-aggregated-by-level?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_VeryImportantFactsAggregatedByLevel(
          _response,
        );
      });
  }

  protected processGet_Assessment_VeryImportantFactsAggregatedByLevel(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_VeryImportantFactsAggregatedByLevel_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_VeryImportantFactsAggregatedByLevel_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_VeryImportantFactsAggregatedByLevel_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_EntitySummaryByAggregateLevel(
    {
      entityId,
      level,
      year,
      grade,
    }: {
      entityId: number;
      level: EntityLevel;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_EntitySummaryByAggregateLevel_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl + '/api/assessment/entity-summary-by-aggregate-level?';
    if (entityId === undefined || entityId === null)
      throw new Error(
        "The parameter 'entityId' must be defined and cannot be null.",
      );
    else url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_EntitySummaryByAggregateLevel(
          _response,
        );
      });
  }

  protected processGet_Assessment_EntitySummaryByAggregateLevel(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_EntitySummaryByAggregateLevel_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_EntitySummaryByAggregateLevel_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_EntitySummaryByAggregateLevel_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsInfoKas(
    {
      id,
      level,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsInfoKAS_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-info-kas?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsInfoKas(_response);
      });
  }

  protected processGet_Assessment_GoalsInfoKas(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsInfoKAS_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsInfoKAS_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsInfoKAS_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsInfoSkillset(
    {
      id,
      level,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsInfoSkillSet_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-info-skillset?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsInfoSkillset(_response);
      });
  }

  protected processGet_Assessment_GoalsInfoSkillset(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsInfoSkillSet_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsInfoSkillSet_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsInfoSkillSet_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_VeryImportantFactsTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_VeryImportantFactsTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/very-important-facts/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_VeryImportantFactsTeam(_response);
      });
  }

  protected processGet_Assessment_VeryImportantFactsTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_VeryImportantFactsTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_VeryImportantFactsTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_VeryImportantFactsTeam_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_SkillSetsTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_SkillSetsTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/skill-sets/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_SkillSetsTeam(_response);
      });
  }

  protected processGet_Assessment_SkillSetsTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_SkillSetsTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_SkillSetsTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_SkillSetsTeam_Response>(
      null as any,
    );
  }

  /**
     * @param mode GymMode

    - `0` = WholeNumbers
    - `1` = Fractions
    - `2` = Decimals
    - `3` = Integers
    - `4` = K2
     * @return OK
     */
  get_Assessment_GymsFactFluencyTeam(
    {
      teamId,
      mode,
    }: {
      teamId: TeamId;
      mode: GymMode;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GymsFactFluencyTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/gyms-fact-fluency/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (mode === undefined || mode === null)
      throw new Error(
        "The parameter 'mode' must be defined and cannot be null.",
      );
    else url_ += 'Mode=' + encodeURIComponent('' + mode) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GymsFactFluencyTeam(_response);
      });
  }

  protected processGet_Assessment_GymsFactFluencyTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GymsFactFluencyTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GymsFactFluencyTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GymsFactFluencyTeam_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_SkillSetsPercentAggregateByLevel(
    {
      id,
      level,
      year,
      aggregateLevel,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string | undefined;
      aggregateLevel: EntityLevel;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_SkillSetsPercentAggregateByLevel_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl + '/api/assessment/skill-sets-percent-aggregate-by-level?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_SkillSetsPercentAggregateByLevel(
          _response,
        );
      });
  }

  protected processGet_Assessment_SkillSetsPercentAggregateByLevel(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_SkillSetsPercentAggregateByLevel_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_SkillSetsPercentAggregateByLevel_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_SkillSetsPercentAggregateByLevel_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GymsFactFluencyPerformanceAggregateByLevels(
    {
      id,
      level,
      year,
      aggregateLevel,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string | undefined;
      aggregateLevel: EntityLevel;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GymsFactFluencyPerformanceAggregateByLevels_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl +
      '/api/assessment/gyms-fact-fluency-performance-aggregate-by-levels?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GymsFactFluencyPerformanceAggregateByLevels(
          _response,
        );
      });
  }

  protected processGet_Assessment_GymsFactFluencyPerformanceAggregateByLevels(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GymsFactFluencyPerformanceAggregateByLevels_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GymsFactFluencyPerformanceAggregateByLevels_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GymsFactFluencyPerformanceAggregateByLevels_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_KnowAndShowPercentAggregateByLevels(
    {
      id,
      level,
      year,
      aggregateLevel,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      year: string | undefined;
      aggregateLevel: EntityLevel;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_KnowAndShowPercentAggregateByLevels_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl +
      '/api/assessment/know-and-show-percent-aggregate-by-levels?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_KnowAndShowPercentAggregateByLevels(
          _response,
        );
      });
  }

  protected processGet_Assessment_KnowAndShowPercentAggregateByLevels(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_KnowAndShowPercentAggregateByLevels_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_KnowAndShowPercentAggregateByLevels_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_KnowAndShowPercentAggregateByLevels_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_KnowAndShowTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_KnowAndShowTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/know-and-show/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_KnowAndShowTeam(_response);
      });
  }

  protected processGet_Assessment_KnowAndShowTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_KnowAndShowTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_KnowAndShowTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_KnowAndShowTeam_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param jtfMode JtfMode

    - `0` = WholeNumbers
    - `1` = Fractions
    - `2` = Decimals
    - `3` = Integers
     * @param operation ArithmeticOperation

    - `1` = Addition
    - `2` = Subtraction
    - `3` = Multiplication
    - `4` = Division
     * @param grade (optional) SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @return OK
     */
  get_Assessment_JustTheFactsAggregateByLevels(
    {
      id,
      level,
      jtfMode,
      operation,
      year,
      grade,
      aggregateLevel,
    }: {
      id: number;
      level: EntityLevel;
      jtfMode: JtfMode;
      operation: ArithmeticOperation;
      year: string;
      grade: SpecialGradeLevel | undefined;
      aggregateLevel: EntityLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_JustTheFactsAggregateByLevels_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl + '/api/assessment/just-the-facts-aggregate-by-levels?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (jtfMode === undefined || jtfMode === null)
      throw new Error(
        "The parameter 'jtfMode' must be defined and cannot be null.",
      );
    else url_ += 'JtfMode=' + encodeURIComponent('' + jtfMode) + '&';
    if (operation === undefined || operation === null)
      throw new Error(
        "The parameter 'operation' must be defined and cannot be null.",
      );
    else url_ += 'Operation=' + encodeURIComponent('' + operation) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === null)
      throw new Error("The parameter 'grade' cannot be null.");
    else if (grade !== undefined)
      url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_JustTheFactsAggregateByLevels(
          _response,
        );
      });
  }

  protected processGet_Assessment_JustTheFactsAggregateByLevels(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_JustTheFactsAggregateByLevels_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_JustTheFactsAggregateByLevels_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_JustTheFactsAggregateByLevels_Response>(
      null as any,
    );
  }

  /**
     * @param jtfMode JtfMode

    - `0` = WholeNumbers
    - `1` = Fractions
    - `2` = Decimals
    - `3` = Integers
     * @return OK
     */
  get_Assessment_JustTheFactsTeam(
    {
      teamId,
      jtfMode,
    }: {
      teamId: TeamId;
      jtfMode: JtfMode;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_JustTheFactsTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/just-the-facts/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (jtfMode === undefined || jtfMode === null)
      throw new Error(
        "The parameter 'jtfMode' must be defined and cannot be null.",
      );
    else url_ += 'JtfMode=' + encodeURIComponent('' + jtfMode) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_JustTheFactsTeam(_response);
      });
  }

  protected processGet_Assessment_JustTheFactsTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_JustTheFactsTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_JustTheFactsTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_JustTheFactsTeam_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param jtfMode JtfMode

    - `0` = WholeNumbers
    - `1` = Fractions
    - `2` = Decimals
    - `3` = Integers
     * @param operation ArithmeticOperation

    - `1` = Addition
    - `2` = Subtraction
    - `3` = Multiplication
    - `4` = Division
     * @param grade (optional) SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_JustTheFactsSummary(
    {
      id,
      level,
      jtfMode,
      operation,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      jtfMode: JtfMode;
      operation: ArithmeticOperation;
      year: string | undefined;
      grade: SpecialGradeLevel | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_JustTheFactsSummary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/just-the-facts-summary?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (jtfMode === undefined || jtfMode === null)
      throw new Error(
        "The parameter 'jtfMode' must be defined and cannot be null.",
      );
    else url_ += 'JtfMode=' + encodeURIComponent('' + jtfMode) + '&';
    if (operation === undefined || operation === null)
      throw new Error(
        "The parameter 'operation' must be defined and cannot be null.",
      );
    else url_ += 'Operation=' + encodeURIComponent('' + operation) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === null)
      throw new Error("The parameter 'grade' cannot be null.");
    else if (grade !== undefined)
      url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_JustTheFactsSummary(_response);
      });
  }

  protected processGet_Assessment_JustTheFactsSummary(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_JustTheFactsSummary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_JustTheFactsSummary_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_JustTheFactsSummary_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_BonusTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_TeamBonusGames_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/bonus/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_BonusTeam(_response);
      });
  }

  protected processGet_Assessment_BonusTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_TeamBonusGames_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_TeamBonusGames_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_TeamBonusGames_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_ActivityTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_TeamStickerCountActivity_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/activity/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_ActivityTeam(_response);
      });
  }

  protected processGet_Assessment_ActivityTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_TeamStickerCountActivity_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_TeamStickerCountActivity_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_TeamStickerCountActivity_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade (optional) SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_Activity(
    {
      id,
      year,
      level,
      grade,
    }: {
      id: number;
      year: string;
      level: EntityLevel;
      grade: SpecialGradeLevel | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_StickerCountActivity_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/activity?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (grade === null)
      throw new Error("The parameter 'grade' cannot be null.");
    else if (grade !== undefined)
      url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_Activity(_response);
      });
  }

  protected processGet_Assessment_Activity(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_StickerCountActivity_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_StickerCountActivity_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_StickerCountActivity_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_WdykTestBatchesTeam(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GetWDYKTestBatchesByTeams_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/get-wdyk-test-batches/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_WdykTestBatchesTeam(_response);
      });
  }

  protected processGet_Assessment_WdykTestBatchesTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GetWDYKTestBatchesByTeams_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GetWDYKTestBatchesByTeams_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GetWDYKTestBatchesByTeams_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_WdykTestAssessmentByBatch(
    {
      batchId,
    }: {
      batchId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GetWDYKTestAssessmentByBatch_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl + '/api/assessment/get-wdyk-test-assessment-by-batch?';
    if (batchId === undefined || batchId === null)
      throw new Error(
        "The parameter 'batchId' must be defined and cannot be null.",
      );
    else url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_WdykTestAssessmentByBatch(_response);
      });
  }

  protected processGet_Assessment_WdykTestAssessmentByBatch(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GetWDYKTestAssessmentByBatch_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GetWDYKTestAssessmentByBatch_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GetWDYKTestAssessmentByBatch_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_WdykTemplateHeadings(
    {
      templateId,
    }: {
      templateId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GetWDYKTemplateHeadings_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/get-wdyk-template-headings?';
    if (templateId === undefined || templateId === null)
      throw new Error(
        "The parameter 'templateId' must be defined and cannot be null.",
      );
    else url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_WdykTemplateHeadings(_response);
      });
  }

  protected processGet_Assessment_WdykTemplateHeadings(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GetWDYKTemplateHeadings_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GetWDYKTemplateHeadings_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GetWDYKTemplateHeadings_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @return OK
     */
  get_Assessment_FluencyGames(
    {
      id,
      year,
      grade,
      level,
    }: {
      id: number;
      year: string | undefined;
      grade: SpecialGradeLevel;
      level: EntityLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_FluencyGames_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/fluency-games?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_FluencyGames(_response);
      });
  }

  protected processGet_Assessment_FluencyGames(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_FluencyGames_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_FluencyGames_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_FluencyGames_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param aggregateLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_AllGames(
    {
      id,
      level,
      aggregateLevel,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      aggregateLevel: EntityLevel;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_AllGames_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/all-games?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (aggregateLevel === undefined || aggregateLevel === null)
      throw new Error(
        "The parameter 'aggregateLevel' must be defined and cannot be null.",
      );
    else
      url_ += 'AggregateLevel=' + encodeURIComponent('' + aggregateLevel) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_AllGames(_response);
      });
  }

  protected processGet_Assessment_AllGames(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_AllGames_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_AllGames_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_AllGames_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Assessment_GoalsAlgebraByPlayer(
    {
      id,
    }: {
      id: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_AlgebraGoalsByPlayer_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-algebra-by-player?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsAlgebraByPlayer(_response);
      });
  }

  protected processGet_Assessment_GoalsAlgebraByPlayer(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_AlgebraGoalsByPlayer_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_AlgebraGoalsByPlayer_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_AlgebraGoalsByPlayer_Response>(
      null as any,
    );
  }

  /**
     * @param phase GoalsIndexPhase

    - `1` = Early
    - `2` = Elementary
    - `3` = Intermediate
    - `4` = Advanced
     * @return OK
     */
  get_Assessment_GoalsIndexByPlayer(
    {
      entityId,
      phase,
    }: {
      entityId: number;
      phase: GoalsIndexPhase;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsIndexByPlayer_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-index-by-player?';
    if (entityId === undefined || entityId === null)
      throw new Error(
        "The parameter 'entityId' must be defined and cannot be null.",
      );
    else url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (phase === undefined || phase === null)
      throw new Error(
        "The parameter 'phase' must be defined and cannot be null.",
      );
    else url_ += 'Phase=' + encodeURIComponent('' + phase) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsIndexByPlayer(_response);
      });
  }

  protected processGet_Assessment_GoalsIndexByPlayer(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsIndexByPlayer_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsIndexByPlayer_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsIndexByPlayer_Response>(
      null as any,
    );
  }

  /**
     * @param grade (optional) SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_SummarySchool(
    {
      entityId,
      year,
      grade,
    }: {
      entityId: number;
      year: string;
      grade: SpecialGradeLevel | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_SchoolSummary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/summary/school?';
    if (entityId === undefined || entityId === null)
      throw new Error(
        "The parameter 'entityId' must be defined and cannot be null.",
      );
    else url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === null)
      throw new Error("The parameter 'grade' cannot be null.");
    else if (grade !== undefined)
      url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_SummarySchool(_response);
      });
  }

  protected processGet_Assessment_SummarySchool(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_SchoolSummary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_SchoolSummary_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_SchoolSummary_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param phase GoalsIndexPhase

    - `1` = Early
    - `2` = Elementary
    - `3` = Intermediate
    - `4` = Advanced
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsByTeam(
    {
      id,
      level,
      phase,
      year,
      grade,
    }: {
      id: number;
      level: EntityLevel;
      phase: GoalsIndexPhase;
      year: string | undefined;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsByTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-by-team?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (phase === undefined || phase === null)
      throw new Error(
        "The parameter 'phase' must be defined and cannot be null.",
      );
    else url_ += 'Phase=' + encodeURIComponent('' + phase) + '&';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsByTeam(_response);
      });
  }

  protected processGet_Assessment_GoalsByTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsByTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsByTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsByTeam_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Assessment_GoalsAlgebraByTeam(
    {
      id,
      year,
      level,
      grade,
    }: {
      id: number;
      year: string;
      level: EntityLevel;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_GoalsAlgebraByTeam_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/goals-algebra-by-team?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_GoalsAlgebraByTeam(_response);
      });
  }

  protected processGet_Assessment_GoalsAlgebraByTeam(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_GoalsAlgebraByTeam_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_GoalsAlgebraByTeam_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_GoalsAlgebraByTeam_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_PlayerSummary(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_PlayerSummary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/player-summary?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_PlayerSummary(_response);
      });
  }

  protected processGet_Assessment_PlayerSummary(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_PlayerSummary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_PlayerSummary_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_PlayerSummary_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Assessment_CertificateData(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Assessment_CertificateData_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/assessment/certificate-data?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Assessment_CertificateData(_response);
      });
  }

  protected processGet_Assessment_CertificateData(
    response: AxiosResponse,
  ): Promise<Entities_Assessment_CertificateData_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Assessment_CertificateData_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Assessment_CertificateData_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Authorization_Grant(
    body: Entities_Authorization_Grant_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/authorization/grant?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Authorization_Grant(_response);
      });
  }

  protected processPost_Authorization_Grant(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Authorization_Revoke(
    body: Entities_Authorization_Revoke_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/authorization/revoke?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Authorization_Revoke(_response);
      });
  }

  protected processPost_Authorization_Revoke(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  put_Contact_UpdateName(
    body: Entities_Contact_UpdateName_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/contact/update-name?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Contact_UpdateName(_response);
      });
  }

  protected processPut_Contact_UpdateName(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  put_Contact_UpdateEmail(
    body: Entities_Contact_UpdateEmail_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/contact/update-email?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Contact_UpdateEmail(_response);
      });
  }

  protected processPut_Contact_UpdateEmail(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  delete_Contact(
    contactIds: number[],
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/contact/delete?';
    if (contactIds === undefined || contactIds === null)
      throw new Error(
        "The parameter 'contactIds' must be defined and cannot be null.",
      );
    else
      contactIds &&
        contactIds.forEach((item) => {
          url_ += 'ContactIds=' + encodeURIComponent('' + item) + '&';
        });
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete_Contact(_response);
      });
  }

  protected processDelete_Contact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Contact_TeamAssignmentChange(
    body: Entities_Contact_TeamAssignmentChange_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/contact/team-assignment-change?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Contact_TeamAssignmentChange(_response);
      });
  }

  protected processPost_Contact_TeamAssignmentChange(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Contact_Insert(
    body: Entities_Contact_Insert_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Contact_Insert_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/contact/insert?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Contact_Insert(_response);
      });
  }

  protected processPost_Contact_Insert(
    response: AxiosResponse,
  ): Promise<Entities_Contact_Insert_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Contact_Insert_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Contact_Insert_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Debug_Test(
    {
      grade,
    }: {
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Debug_Test_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/debug/test?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Debug_Test(_response);
      });
  }

  protected processGet_Debug_Test(
    response: AxiosResponse,
  ): Promise<Entities_Debug_Test_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Debug_Test_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Debug_Test_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Debug_Version(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Debug_Version_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/debug/version?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Debug_Version(_response);
      });
  }

  protected processGet_Debug_Version(
    response: AxiosResponse,
  ): Promise<Entities_Debug_Version_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Debug_Version_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Debug_Version_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Debug_ThrowException({}: {}, cancelToken?: CancelToken): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/debug/throw-exception?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Debug_ThrowException(_response);
      });
  }

  protected processGet_Debug_ThrowException(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Debug_ConnectionStats({}: {}, cancelToken?: CancelToken): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/debug/connection-stats?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Debug_ConnectionStats(_response);
      });
  }

  protected processGet_Debug_ConnectionStats(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Debug_ConnectionStatsReset(cancelToken?: CancelToken): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/debug/connection-stats/reset?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Debug_ConnectionStatsReset(_response);
      });
  }

  protected processPost_Debug_ConnectionStatsReset(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_CheckLogin(
    body: Entities_Login_GetInfo_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_GetInfo_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/check-login?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_CheckLogin(_response);
      });
  }

  protected processPost_Login_CheckLogin(
    response: AxiosResponse,
  ): Promise<Entities_Login_GetInfo_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_GetInfo_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_GetInfo_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_ByUserIdAndPassword(
    body: Entities_Login_ByUserIdAndPassword_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_ByUserIdAndPassword_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/by-user-id-and-password?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_ByUserIdAndPassword(_response);
      });
  }

  protected processPost_Login_ByUserIdAndPassword(
    response: AxiosResponse,
  ): Promise<Entities_Login_ByUserIdAndPassword_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_ByUserIdAndPassword_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_ByUserIdAndPassword_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Login_RequestPasswordReset(
    body: Entities_Login_RequestPasswordReset_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_RequestPasswordReset_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/request-password-reset?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_RequestPasswordReset(_response);
      });
  }

  protected processPost_Login_RequestPasswordReset(
    response: AxiosResponse,
  ): Promise<Entities_Login_RequestPasswordReset_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_RequestPasswordReset_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_RequestPasswordReset_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  put_Login_UpdateDisplayName(
    body: Entities_Login_UpdateDisplayName_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_UpdateDisplayName_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/update-display-name?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Login_UpdateDisplayName(_response);
      });
  }

  protected processPut_Login_UpdateDisplayName(
    response: AxiosResponse,
  ): Promise<Entities_Login_UpdateDisplayName_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_UpdateDisplayName_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_UpdateDisplayName_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Login_IsCredentialInUseByAnyoneElse(
    {
      loginId,
      userId,
      password,
    }: {
      loginId: LoginId;
      userId: UserId;
      password: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_IsCredentialInUseByAnyoneElse_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/is-credential-in-use-by-anyone-else?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null.",
      );
    else url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (password === undefined || password === null)
      throw new Error(
        "The parameter 'password' must be defined and cannot be null.",
      );
    else url_ += 'Password=' + encodeURIComponent('' + password) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_IsCredentialInUseByAnyoneElse(_response);
      });
  }

  protected processGet_Login_IsCredentialInUseByAnyoneElse(
    response: AxiosResponse,
  ): Promise<Entities_Login_IsCredentialInUseByAnyoneElse_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_IsCredentialInUseByAnyoneElse_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_IsCredentialInUseByAnyoneElse_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Login_IsIdInUseByAnyoneElseInDistrict(
    {
      loginId,
      districtId,
      id,
    }: {
      loginId: LoginId;
      districtId: number;
      id: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_IsIdInUseByAnyoneElseInDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ =
      this.baseUrl + '/api/login/is-id-in-use-by-anyone-else-in-district?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (districtId === undefined || districtId === null)
      throw new Error(
        "The parameter 'districtId' must be defined and cannot be null.",
      );
    else url_ += 'DistrictId=' + encodeURIComponent('' + districtId) + '&';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_IsIdInUseByAnyoneElseInDistrict(_response);
      });
  }

  protected processGet_Login_IsIdInUseByAnyoneElseInDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Login_IsIdInUseByAnyoneElseInDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_IsIdInUseByAnyoneElseInDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_IsIdInUseByAnyoneElseInDistrict_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Login_RegeneratePassword(
    body: Entities_Login_RegeneratePassword_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_RegeneratePassword_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/regenerate-password?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_RegeneratePassword(_response);
      });
  }

  protected processPost_Login_RegeneratePassword(
    response: AxiosResponse,
  ): Promise<Entities_Login_RegeneratePassword_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_RegeneratePassword_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_RegeneratePassword_Response>(
      null as any,
    );
  }

  /**
     * @param loginType LoginType

    - `0` = NotLoggedIn
    - `1` = SalesRep
    - `2` = RegionAdmin
    - `3` = DistrictAdmin
    - `4` = TeamLeader
    - `5` = StudentPlayer
    - `6` = SchoolPrincipal
    - `8` = IndividualPlayer
    - `19` = Multi
    - `98` = LimitedAdmin
    - `99` = Admin
     * @return OK
     */
  get_Login_StateInfo(
    {
      loginType,
      loginId,
    }: {
      loginType: LoginType;
      loginId: LoginId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_StateInfo_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/state-info?';
    if (loginType === undefined || loginType === null)
      throw new Error(
        "The parameter 'loginType' must be defined and cannot be null.",
      );
    else url_ += 'LoginType=' + encodeURIComponent('' + loginType) + '&';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_StateInfo(_response);
      });
  }

  protected processGet_Login_StateInfo(
    response: AxiosResponse,
  ): Promise<Entities_Login_StateInfo_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_StateInfo_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_StateInfo_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_CreateTeacher(
    body: Entities_Login_CreateTeacher_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_CreateTeacher_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/create-teacher?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_CreateTeacher(_response);
      });
  }

  protected processPost_Login_CreateTeacher(
    response: AxiosResponse,
  ): Promise<Entities_Login_CreateTeacher_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_CreateTeacher_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_CreateTeacher_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_Consolidate(
    body: Entities_Login_Consolidate_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/consolidate?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_Consolidate(_response);
      });
  }

  protected processPost_Login_Consolidate(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Login_Profile(
    {
      loginId,
    }: {
      loginId: LoginId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_Profile_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/profile?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_Profile(_response);
      });
  }

  protected processGet_Login_Profile(
    response: AxiosResponse,
  ): Promise<Entities_Login_Profile_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_Profile_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_Profile_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_UpdateLoginGroup(
    body: Entities_Login_UpdateLoginGroup_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/update-login-group?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_UpdateLoginGroup(_response);
      });
  }

  protected processPost_Login_UpdateLoginGroup(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_UpsertContact(
    body: Entities_Login_UpsertContact_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_UpsertContact_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/upsert-contact?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_UpsertContact(_response);
      });
  }

  protected processPost_Login_UpsertContact(
    response: AxiosResponse,
  ): Promise<Entities_Login_UpsertContact_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_UpsertContact_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_UpsertContact_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Login_EncryptUserid(
    {
      userId,
    }: {
      userId: UserId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_EncryptUserId_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/encrypt-userid?';
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null.",
      );
    else url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_EncryptUserid(_response);
      });
  }

  protected processGet_Login_EncryptUserid(
    response: AxiosResponse,
  ): Promise<Entities_Login_EncryptUserId_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_EncryptUserId_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_EncryptUserId_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_ByToken(
    body: Entities_Login_ByToken_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_ByToken_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/by-token?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_ByToken(_response);
      });
  }

  protected processPost_Login_ByToken(
    response: AxiosResponse,
  ): Promise<Entities_Login_ByToken_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_ByToken_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_ByToken_Response>(null as any);
  }

  /**
     * @param metaKey MetaKey

    - `0` = DashboardConfig
    - `1` = AvatarConfig
    - `2` = FavoriteModules
    - `3` = PlayerAvatar
     * @return OK
     */
  get_Login_LoginMeta(
    {
      loginId,
      metaKey,
    }: {
      loginId: LoginId;
      metaKey: MetaKey;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_LoginMeta_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/login-meta?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (metaKey === undefined || metaKey === null)
      throw new Error(
        "The parameter 'metaKey' must be defined and cannot be null.",
      );
    else url_ += 'MetaKey=' + encodeURIComponent('' + metaKey) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_LoginMeta(_response);
      });
  }

  protected processGet_Login_LoginMeta(
    response: AxiosResponse,
  ): Promise<Entities_Login_LoginMeta_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_LoginMeta_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_LoginMeta_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Login_UpsertLoginMeta(
    body: Entities_Login_UpsertLoginMeta_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/upsert-login-meta?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Login_UpsertLoginMeta(_response);
      });
  }

  protected processPost_Login_UpsertLoginMeta(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Login_Refresh(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Login_RefreshJwt_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/login/refresh?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Login_Refresh(_response);
      });
  }

  protected processGet_Login_Refresh(
    response: AxiosResponse,
  ): Promise<Entities_Login_RefreshJwt_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Login_RefreshJwt_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Login_RefreshJwt_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_LoginGroup_Upsert(
    body: Entities_LoginGroup_Upsert_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/logingroup/upsert?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_LoginGroup_Upsert(_response);
      });
  }

  protected processPost_LoginGroup_Upsert(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Modules_SuggestAssign(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_Assign_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/suggest/assign?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_SuggestAssign(_response);
      });
  }

  protected processGet_Modules_SuggestAssign(
    response: AxiosResponse,
  ): Promise<Entities_Modules_Assign_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_Assign_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_Assign_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Modules_ById(
    {
      id,
    }: {
      id: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_ById_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/by-id?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_ById(_response);
      });
  }

  protected processGet_Modules_ById(
    response: AxiosResponse,
  ): Promise<Entities_Modules_ById_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_ById_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_ById_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Modules_All(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_All_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/all?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_All(_response);
      });
  }

  protected processGet_Modules_All(
    response: AxiosResponse,
  ): Promise<Entities_Modules_All_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_All_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_All_Response>(null as any);
  }

  /**
   * @return OK
   */
  delete_Modules_Cache(cancelToken?: CancelToken): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/cache?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete_Modules_Cache(_response);
      });
  }

  protected processDelete_Modules_Cache(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Modules_ModuleTags(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_ModuleTags_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/module-tags?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_ModuleTags(_response);
      });
  }

  protected processGet_Modules_ModuleTags(
    response: AxiosResponse,
  ): Promise<Entities_Modules_ModuleTags_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_ModuleTags_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_ModuleTags_Response>(null as any);
  }

  /**
     * @param locale Locale

    - `0` = US
    - `1` = IN
     * @return OK
     */
  get_Modules_ModuleModuleTags(
    {
      locale,
    }: {
      locale: Locale;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_ModuleModuleTags_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/module-module-tags?';
    if (locale === undefined || locale === null)
      throw new Error(
        "The parameter 'locale' must be defined and cannot be null.",
      );
    else url_ += 'Locale=' + encodeURIComponent('' + locale) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_ModuleModuleTags(_response);
      });
  }

  protected processGet_Modules_ModuleModuleTags(
    response: AxiosResponse,
  ): Promise<Entities_Modules_ModuleModuleTags_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_ModuleModuleTags_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_ModuleModuleTags_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Modules_SlugLinks(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_SlugLinks_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/slug-links?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_SlugLinks(_response);
      });
  }

  protected processGet_Modules_SlugLinks(
    response: AxiosResponse,
  ): Promise<Entities_Modules_SlugLinks_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_SlugLinks_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_SlugLinks_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Modules_VifData(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Modules_VifData_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/vif-data?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Modules_VifData(_response);
      });
  }

  protected processGet_Modules_VifData(
    response: AxiosResponse,
  ): Promise<Entities_Modules_VifData_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Modules_VifData_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Modules_VifData_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Modules_CreateWdyk(
    body: Entities_Modules_CreateWdyk_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/modules/create-wdyk?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Modules_CreateWdyk(_response);
      });
  }

  protected processPost_Modules_CreateWdyk(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Notification_Count(
    {
      loginId,
    }: {
      loginId: LoginId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Notification_Count_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/count?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Notification_Count(_response);
      });
  }

  protected processGet_Notification_Count(
    response: AxiosResponse,
  ): Promise<Entities_Notification_Count_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Notification_Count_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Notification_Count_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Notification_InvalidateCache(
    body: Entities_Notification_InvalidateCache_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/invalidate-cache?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Notification_InvalidateCache(_response);
      });
  }

  protected processPost_Notification_InvalidateCache(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Notification_InsertTeam(
    body: Entities_Notification_InsertTeam_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/insert/team?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Notification_InsertTeam(_response);
      });
  }

  protected processPost_Notification_InsertTeam(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
     * @param notificationType NotificationType

    - `0` = All
    - `1` = Unread
    - `2` = Read
     * @return OK
     */
  get_Notification_Notifications(
    {
      loginId,
      notificationType,
      pageNumber,
      pageSize,
      searchQuery,
    }: {
      loginId: LoginId;
      notificationType: NotificationType;
      pageNumber: number;
      pageSize: number;
      searchQuery: string | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Notification_Get_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/get-notifications?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (notificationType === undefined || notificationType === null)
      throw new Error(
        "The parameter 'notificationType' must be defined and cannot be null.",
      );
    else
      url_ +=
        'NotificationType=' + encodeURIComponent('' + notificationType) + '&';
    if (pageNumber === undefined || pageNumber === null)
      throw new Error(
        "The parameter 'pageNumber' must be defined and cannot be null.",
      );
    else url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === undefined || pageSize === null)
      throw new Error(
        "The parameter 'pageSize' must be defined and cannot be null.",
      );
    else url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (searchQuery === null)
      throw new Error("The parameter 'searchQuery' cannot be null.");
    else if (searchQuery !== undefined)
      url_ += 'SearchQuery=' + encodeURIComponent('' + searchQuery) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Notification_Notifications(_response);
      });
  }

  protected processGet_Notification_Notifications(
    response: AxiosResponse,
  ): Promise<Entities_Notification_Get_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Notification_Get_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Notification_Get_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Notification_MarkRead(
    body: Entities_Notification_MarkAsRead_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/mark-read?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Notification_MarkRead(_response);
      });
  }

  protected processPost_Notification_MarkRead(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Notification_InsertDirect(
    body: Entities_Notification_InsertDirect_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/insert/direct?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Notification_InsertDirect(_response);
      });
  }

  protected processPost_Notification_InsertDirect(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Notification_Sent(
    {
      loginId,
      pageNumber,
      pageSize,
      searchQuery,
    }: {
      loginId: LoginId;
      pageNumber: number;
      pageSize: number;
      searchQuery: string | undefined;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Notification_Sent_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/sent?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (pageNumber === undefined || pageNumber === null)
      throw new Error(
        "The parameter 'pageNumber' must be defined and cannot be null.",
      );
    else url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === undefined || pageSize === null)
      throw new Error(
        "The parameter 'pageSize' must be defined and cannot be null.",
      );
    else url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (searchQuery === null)
      throw new Error("The parameter 'searchQuery' cannot be null.");
    else if (searchQuery !== undefined)
      url_ += 'SearchQuery=' + encodeURIComponent('' + searchQuery) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Notification_Sent(_response);
      });
  }

  protected processGet_Notification_Sent(
    response: AxiosResponse,
  ): Promise<Entities_Notification_Sent_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Notification_Sent_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Notification_Sent_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Notification_Delete(
    body: Entities_Notification_Delete_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/notification/delete?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Notification_Delete(_response);
      });
  }

  protected processPost_Notification_Delete(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Pdf_GeneratePdf(
    body: Entities_Pdf_GeneratePdf_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/pdf/generate-pdf?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: 'blob',
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Pdf_GeneratePdf(_response);
      });
  }

  protected processPost_Pdf_GeneratePdf(
    response: AxiosResponse,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: (response.headers['content-type'] ??
            response.headers['Content-Type']) as string | undefined,
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * @return OK
   */
  post_Pdf_MembershipCardsPdf(
    body: Entities_Pdf_MembershipCardsPdf_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/pdf/membership-cards-pdf?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: 'blob',
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Pdf_MembershipCardsPdf(_response);
      });
  }

  protected processPost_Pdf_MembershipCardsPdf(
    response: AxiosResponse,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: (response.headers['content-type'] ??
            response.headers['Content-Type']) as string | undefined,
        }),
        headers: _headers,
      });
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = JSON.parse(resultData400);
      return throwException(
        'Bad Request',
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_AssignToSchool(
    body: Entities_Player_AssignToSchool_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/assign-to-school?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_AssignToSchool(_response);
      });
  }

  protected processPost_Player_AssignToSchool(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_SkillSetProgress(
    {
      playerId,
      skillSet,
      game,
    }: {
      playerId: PlayerId;
      skillSet: number;
      game: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_SkillSetProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-skill-set-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (skillSet === undefined || skillSet === null)
      throw new Error(
        "The parameter 'skillSet' must be defined and cannot be null.",
      );
    else url_ += 'SkillSet=' + encodeURIComponent('' + skillSet) + '&';
    if (game === undefined || game === null)
      throw new Error(
        "The parameter 'game' must be defined and cannot be null.",
      );
    else url_ += 'Game=' + encodeURIComponent('' + game) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_SkillSetProgress(_response);
      });
  }

  protected processGet_Player_SkillSetProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_SkillSetProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_SkillSetProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_SkillSetProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_SkillSetProgress2(
    {
      playerId,
      skillSet,
      game,
    }: {
      playerId: PlayerId;
      skillSet: number;
      game: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_SkillSetProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/skill-set-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (skillSet === undefined || skillSet === null)
      throw new Error(
        "The parameter 'skillSet' must be defined and cannot be null.",
      );
    else url_ += 'SkillSet=' + encodeURIComponent('' + skillSet) + '&';
    if (game === undefined || game === null)
      throw new Error(
        "The parameter 'game' must be defined and cannot be null.",
      );
    else url_ += 'Game=' + encodeURIComponent('' + game) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_SkillSetProgress2(_response);
      });
  }

  protected processGet_Player_SkillSetProgress2(
    response: AxiosResponse,
  ): Promise<Entities_Player_SkillSetProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_SkillSetProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_SkillSetProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Player_UpdateSkillSetProgress(
    body: Entities_Player_UpdateSkillSetProgress_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_UpdateSkillSetProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-skill-set-progress?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateSkillSetProgress(_response);
      });
  }

  protected processPost_Player_UpdateSkillSetProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_UpdateSkillSetProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_UpdateSkillSetProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_UpdateSkillSetProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_Activity(
    {
      playerId,
      top,
      skip,
    }: {
      playerId: PlayerId;
      top: number;
      skip: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Activity_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/activity?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (top === undefined || top === null)
      throw new Error(
        "The parameter 'top' must be defined and cannot be null.",
      );
    else url_ += 'Top=' + encodeURIComponent('' + top) + '&';
    if (skip === undefined || skip === null)
      throw new Error(
        "The parameter 'skip' must be defined and cannot be null.",
      );
    else url_ += 'Skip=' + encodeURIComponent('' + skip) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Activity(_response);
      });
  }

  protected processGet_Player_Activity(
    response: AxiosResponse,
  ): Promise<Entities_Player_Activity_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Activity_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Activity_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_Reset(
    body: Entities_Player_Reset_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/reset?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_Reset(_response);
      });
  }

  protected processPost_Player_Reset(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  put_Player_AssignToUnassignedTeam(
    body: Entities_Player_AssignToUnassignedTeam_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/assign-to-unassigned-team?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Player_AssignToUnassignedTeam(_response);
      });
  }

  protected processPut_Player_AssignToUnassignedTeam(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_AssignToUnassignedTeam(
    body: Entities_Player_AssignToUnassignedTeam_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/assign-to-unassigned-team?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_AssignToUnassignedTeam(_response);
      });
  }

  protected processPost_Player_AssignToUnassignedTeam(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdatePrimaryTeam(
    body: Entities_Player_UpdatePrimaryTeam_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-primary-team?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdatePrimaryTeam(_response);
      });
  }

  protected processPost_Player_UpdatePrimaryTeam(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Focus(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Focus_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/focus?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Focus(_response);
      });
  }

  protected processGet_Player_Focus(
    response: AxiosResponse,
  ): Promise<Entities_Player_Focus_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Focus_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Focus_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_Focus(
    body: Entities_Player_UpdateFocus_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/focus?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_Focus(_response);
      });
  }

  protected processPost_Player_Focus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
     * @param type TeamTopPlayersType

    - `0` = AllTime
    - `1` = Today
    - `2` = Yesterday
    - `3` = Week
    - `4` = Month
     * @param loginType LoginType

    - `0` = NotLoggedIn
    - `1` = SalesRep
    - `2` = RegionAdmin
    - `3` = DistrictAdmin
    - `4` = TeamLeader
    - `5` = StudentPlayer
    - `6` = SchoolPrincipal
    - `8` = IndividualPlayer
    - `19` = Multi
    - `98` = LimitedAdmin
    - `99` = Admin
     * @return OK
     */
  get_Player_Index(
    {
      playerId,
      teamId,
      type,
      loginType,
      loginId,
    }: {
      playerId: PlayerId;
      teamId: TeamId;
      type: TeamTopPlayersType;
      loginType: LoginType;
      loginId: LoginId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Index_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/index?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (type === undefined || type === null)
      throw new Error(
        "The parameter 'type' must be defined and cannot be null.",
      );
    else url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (loginType === undefined || loginType === null)
      throw new Error(
        "The parameter 'loginType' must be defined and cannot be null.",
      );
    else url_ += 'LoginType=' + encodeURIComponent('' + loginType) + '&';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Index(_response);
      });
  }

  protected processGet_Player_Index(
    response: AxiosResponse,
  ): Promise<Entities_Player_Index_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Index_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Index_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Achievements(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Achievements_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/achievements?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Achievements(_response);
      });
  }

  protected processGet_Player_Achievements(
    response: AxiosResponse,
  ): Promise<Entities_Player_Achievements_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Achievements_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Achievements_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_PlayerMeta(
    {
      playerId,
      metaKey,
    }: {
      playerId: PlayerId;
      metaKey: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_PlayerMeta_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/player-meta?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (metaKey === undefined || metaKey === null)
      throw new Error(
        "The parameter 'metaKey' must be defined and cannot be null.",
      );
    else url_ += 'MetaKey=' + encodeURIComponent('' + metaKey) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_PlayerMeta(_response);
      });
  }

  protected processGet_Player_PlayerMeta(
    response: AxiosResponse,
  ): Promise<Entities_Player_PlayerMeta_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_PlayerMeta_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_PlayerMeta_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_PlayerMeta2(
    {
      playerId,
      metaKey,
    }: {
      playerId: PlayerId;
      metaKey: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_PlayerMeta_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-player-meta?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (metaKey === undefined || metaKey === null)
      throw new Error(
        "The parameter 'metaKey' must be defined and cannot be null.",
      );
    else url_ += 'MetaKey=' + encodeURIComponent('' + metaKey) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_PlayerMeta2(_response);
      });
  }

  protected processGet_Player_PlayerMeta2(
    response: AxiosResponse,
  ): Promise<Entities_Player_PlayerMeta_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_PlayerMeta_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_PlayerMeta_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdateMeta(
    body: Entities_Player_UpdateMeta_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-meta?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateMeta(_response);
      });
  }

  protected processPost_Player_UpdateMeta(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Contest(
    {
      secureLink,
    }: {
      secureLink: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Contest_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/contest?';
    if (secureLink === undefined || secureLink === null)
      throw new Error(
        "The parameter 'secureLink' must be defined and cannot be null.",
      );
    else url_ += 'SecureLink=' + encodeURIComponent('' + secureLink) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Contest(_response);
      });
  }

  protected processGet_Player_Contest(
    response: AxiosResponse,
  ): Promise<Entities_Player_Contest_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Contest_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Contest_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdateContest(
    body: Entities_Player_UpdateContest_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-contest?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateContest(_response);
      });
  }

  protected processPost_Player_UpdateContest(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Avatar(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Avatar_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/avatar?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Avatar(_response);
      });
  }

  protected processGet_Player_Avatar(
    response: AxiosResponse,
  ): Promise<Entities_Player_Avatar_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Avatar_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Avatar_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdateBadge(
    body: Entities_Player_UpdateBadge_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-badge?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateBadge(_response);
      });
  }

  protected processPost_Player_UpdateBadge(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_WordProblems(
    {
      level,
      category,
      problemNumber,
    }: {
      level: number;
      category: number;
      problemNumber: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_WordProblems_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/word-problems?';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (category === undefined || category === null)
      throw new Error(
        "The parameter 'category' must be defined and cannot be null.",
      );
    else url_ += 'Category=' + encodeURIComponent('' + category) + '&';
    if (problemNumber === undefined || problemNumber === null)
      throw new Error(
        "The parameter 'problemNumber' must be defined and cannot be null.",
      );
    else
      url_ += 'ProblemNumber=' + encodeURIComponent('' + problemNumber) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_WordProblems(_response);
      });
  }

  protected processGet_Player_WordProblems(
    response: AxiosResponse,
  ): Promise<Entities_Player_WordProblems_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_WordProblems_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_WordProblems_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_WordProblems2(
    {
      level,
      category,
      problemNumber,
    }: {
      level: number;
      category: number;
      problemNumber: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_WordProblems_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-word-problems?';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (category === undefined || category === null)
      throw new Error(
        "The parameter 'category' must be defined and cannot be null.",
      );
    else url_ += 'Category=' + encodeURIComponent('' + category) + '&';
    if (problemNumber === undefined || problemNumber === null)
      throw new Error(
        "The parameter 'problemNumber' must be defined and cannot be null.",
      );
    else
      url_ += 'ProblemNumber=' + encodeURIComponent('' + problemNumber) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_WordProblems2(_response);
      });
  }

  protected processGet_Player_WordProblems2(
    response: AxiosResponse,
  ): Promise<Entities_Player_WordProblems_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_WordProblems_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_WordProblems_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_WdykTemplateQuestions(
    {
      testTemplateId,
      questionNumber,
    }: {
      testTemplateId: number;
      questionNumber: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_WDYKTemplateQuestions_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/wdyk-template-questions?';
    if (testTemplateId === undefined || testTemplateId === null)
      throw new Error(
        "The parameter 'testTemplateId' must be defined and cannot be null.",
      );
    else
      url_ += 'TestTemplateId=' + encodeURIComponent('' + testTemplateId) + '&';
    if (questionNumber === undefined || questionNumber === null)
      throw new Error(
        "The parameter 'questionNumber' must be defined and cannot be null.",
      );
    else
      url_ += 'QuestionNumber=' + encodeURIComponent('' + questionNumber) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_WdykTemplateQuestions(_response);
      });
  }

  protected processGet_Player_WdykTemplateQuestions(
    response: AxiosResponse,
  ): Promise<Entities_Player_WDYKTemplateQuestions_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_WDYKTemplateQuestions_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_WDYKTemplateQuestions_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_WdykTest(
    {
      secureLink,
    }: {
      secureLink: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_WDYKTest_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/wdyk-test?';
    if (secureLink === undefined || secureLink === null)
      throw new Error(
        "The parameter 'secureLink' must be defined and cannot be null.",
      );
    else url_ += 'SecureLink=' + encodeURIComponent('' + secureLink) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_WdykTest(_response);
      });
  }

  protected processGet_Player_WdykTest(
    response: AxiosResponse,
  ): Promise<Entities_Player_WDYKTest_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_WDYKTest_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_WDYKTest_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdateWdykTestAnswers(
    body: Entities_Player_UpdateWdykTestAnswers_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-wdyk-test-answers?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateWdykTestAnswers(_response);
      });
  }

  protected processPost_Player_UpdateWdykTestAnswers(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_JustTheFactsProgress(
    {
      playerId,
      moduleId,
    }: {
      playerId: PlayerId;
      moduleId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_JustTheFactsProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/just-the-facts-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_JustTheFactsProgress(_response);
      });
  }

  protected processGet_Player_JustTheFactsProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_JustTheFactsProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_JustTheFactsProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_JustTheFactsProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_JustTheFactsProgress2(
    {
      playerId,
      moduleId,
    }: {
      playerId: PlayerId;
      moduleId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_JustTheFactsProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-just-the-facts-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_JustTheFactsProgress2(_response);
      });
  }

  protected processGet_Player_JustTheFactsProgress2(
    response: AxiosResponse,
  ): Promise<Entities_Player_JustTheFactsProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_JustTheFactsProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_JustTheFactsProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Player_UpdateJustTheFactsProgress(
    body: Entities_Player_UpdateJustTheFactsProgress_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_UpdateJustTheFactsProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-just-the-facts-progress?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateJustTheFactsProgress(_response);
      });
  }

  protected processPost_Player_UpdateJustTheFactsProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_UpdateJustTheFactsProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_UpdateJustTheFactsProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_UpdateJustTheFactsProgress_Response>(
      null as any,
    );
  }

  /**
     * @param jtfMode JtfMode

    - `0` = WholeNumbers
    - `1` = Fractions
    - `2` = Decimals
    - `3` = Integers
     * @param arithmeticOperation ArithmeticOperation

    - `1` = Addition
    - `2` = Subtraction
    - `3` = Multiplication
    - `4` = Division
     * @param prePostMode PrePostMode

    - `0` = Pre
    - `1` = Post
    - `2` = Best
     * @return OK
     */
  get_Player_JustTheFactsPlayerProgress(
    {
      playerId,
      jtfMode,
      arithmeticOperation,
      prePostMode,
    }: {
      playerId: PlayerId;
      jtfMode: JtfMode;
      arithmeticOperation: ArithmeticOperation;
      prePostMode: PrePostMode;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_JustTheFactsPlayerProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/just-the-facts/player-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (jtfMode === undefined || jtfMode === null)
      throw new Error(
        "The parameter 'jtfMode' must be defined and cannot be null.",
      );
    else url_ += 'JtfMode=' + encodeURIComponent('' + jtfMode) + '&';
    if (arithmeticOperation === undefined || arithmeticOperation === null)
      throw new Error(
        "The parameter 'arithmeticOperation' must be defined and cannot be null.",
      );
    else
      url_ +=
        'ArithmeticOperation=' +
        encodeURIComponent('' + arithmeticOperation) +
        '&';
    if (prePostMode === undefined || prePostMode === null)
      throw new Error(
        "The parameter 'prePostMode' must be defined and cannot be null.",
      );
    else url_ += 'PrePostMode=' + encodeURIComponent('' + prePostMode) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_JustTheFactsPlayerProgress(_response);
      });
  }

  protected processGet_Player_JustTheFactsPlayerProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_JustTheFactsPlayerProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_JustTheFactsPlayerProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_JustTheFactsPlayerProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  put_Player_UpdateVifStage(
    body: Entities_Player_UpdateVIFStage_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_UpdateVIFStage_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-vif-stage?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Player_UpdateVifStage(_response);
      });
  }

  protected processPut_Player_UpdateVifStage(
    response: AxiosResponse,
  ): Promise<Entities_Player_UpdateVIFStage_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_UpdateVIFStage_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_UpdateVIFStage_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_Progress(
    {
      playerId,
      moduleId,
      moduleVariant,
    }: {
      playerId: PlayerId;
      moduleId: number;
      moduleVariant: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Progress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (moduleVariant === undefined || moduleVariant === null)
      throw new Error(
        "The parameter 'moduleVariant' must be defined and cannot be null.",
      );
    else
      url_ += 'ModuleVariant=' + encodeURIComponent('' + moduleVariant) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Progress(_response);
      });
  }

  protected processGet_Player_Progress(
    response: AxiosResponse,
  ): Promise<Entities_Player_Progress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Progress_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Progress_Response>(null as any);
  }

  /**
     * @param operation ArithmeticOperation

    - `1` = Addition
    - `2` = Subtraction
    - `3` = Multiplication
    - `4` = Division
     * @return OK
     */
  get_Player_VifStage(
    {
      playerId,
      operation,
    }: {
      playerId: PlayerId;
      operation: ArithmeticOperation;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_VIFStage_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-vif-stage?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (operation === undefined || operation === null)
      throw new Error(
        "The parameter 'operation' must be defined and cannot be null.",
      );
    else url_ += 'Operation=' + encodeURIComponent('' + operation) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_VifStage(_response);
      });
  }

  protected processGet_Player_VifStage(
    response: AxiosResponse,
  ): Promise<Entities_Player_VIFStage_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_VIFStage_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_VIFStage_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_ActivateFamilyLink(
    body: Entities_Player_ActivateFamilyLink_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_ActivateFamilyLink_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/activate-family-link?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_ActivateFamilyLink(_response);
      });
  }

  protected processPost_Player_ActivateFamilyLink(
    response: AxiosResponse,
  ): Promise<Entities_Player_ActivateFamilyLink_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_ActivateFamilyLink_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_ActivateFamilyLink_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_KnowAndShowProgress(
    {
      playerId,
      moduleId,
    }: {
      playerId: PlayerId;
      moduleId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_KnowAndShowProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/know-and-show-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_KnowAndShowProgress(_response);
      });
  }

  protected processGet_Player_KnowAndShowProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_KnowAndShowProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_KnowAndShowProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_KnowAndShowProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_Player_KnowAndShowProgress2(
    {
      playerId,
      moduleId,
    }: {
      playerId: PlayerId;
      moduleId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_KnowAndShowProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-know-and-show-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_KnowAndShowProgress2(_response);
      });
  }

  protected processGet_Player_KnowAndShowProgress2(
    response: AxiosResponse,
  ): Promise<Entities_Player_KnowAndShowProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_KnowAndShowProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_KnowAndShowProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Player_UpdateKnowAndShowProgress(
    body: Entities_Player_UpdateKnowAndShowProgress_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-know-and-show-progress?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateKnowAndShowProgress(_response);
      });
  }

  protected processPost_Player_UpdateKnowAndShowProgress(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_GymProgress(
    {
      playerId,
      moduleId,
      gn,
    }: {
      playerId: PlayerId;
      moduleId: number;
      gn: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_GymProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/gym-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (gn === undefined || gn === null)
      throw new Error("The parameter 'gn' must be defined and cannot be null.");
    else url_ += 'Gn=' + encodeURIComponent('' + gn) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_GymProgress(_response);
      });
  }

  protected processGet_Player_GymProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_GymProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_GymProgress_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_GymProgress_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_GymProgress2(
    {
      playerId,
      moduleId,
      gn,
    }: {
      playerId: PlayerId;
      moduleId: number;
      gn: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_GymProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/get-gym-progress?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (moduleId === undefined || moduleId === null)
      throw new Error(
        "The parameter 'moduleId' must be defined and cannot be null.",
      );
    else url_ += 'ModuleId=' + encodeURIComponent('' + moduleId) + '&';
    if (gn === undefined || gn === null)
      throw new Error("The parameter 'gn' must be defined and cannot be null.");
    else url_ += 'Gn=' + encodeURIComponent('' + gn) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_GymProgress2(_response);
      });
  }

  protected processGet_Player_GymProgress2(
    response: AxiosResponse,
  ): Promise<Entities_Player_GymProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_GymProgress_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_GymProgress_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_UpdateGymProgress(
    body: Entities_Player_UpdateGymProgress_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-gym-progress?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateGymProgress(_response);
      });
  }

  protected processPost_Player_UpdateGymProgress(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_ProgressSummary(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_ProgressSummary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/progress-summary?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_ProgressSummary(_response);
      });
  }

  protected processGet_Player_ProgressSummary(
    response: AxiosResponse,
  ): Promise<Entities_Player_ProgressSummary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_ProgressSummary_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_ProgressSummary_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Player_UpdateProgress(
    body: Entities_Player_UpdateProgress_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_UpdateProgress_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/update-progress?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_UpdateProgress(_response);
      });
  }

  protected processPost_Player_UpdateProgress(
    response: AxiosResponse,
  ): Promise<Entities_Player_UpdateProgress_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_UpdateProgress_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_UpdateProgress_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Player_TimeOnTask(
    body: Entities_Player_TimeOnTask_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/time-on-task?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_TimeOnTask(_response);
      });
  }

  protected processPost_Player_TimeOnTask(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_AssignGrade(
    body: Entities_Player_AssignGrade_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/assign-grade?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_AssignGrade(_response);
      });
  }

  protected processPost_Player_AssignGrade(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Badges(
    {
      playerId,
    }: {
      playerId: PlayerId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Badges_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/badges?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Badges(_response);
      });
  }

  protected processGet_Player_Badges(
    response: AxiosResponse,
  ): Promise<Entities_Player_Badges_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Badges_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Badges_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_Quests(
    {
      playerId,
      includeCompletedQuests,
    }: {
      playerId: PlayerId;
      includeCompletedQuests: boolean;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_Quests_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/quests?';
    if (playerId === undefined || playerId === null)
      throw new Error(
        "The parameter 'playerId' must be defined and cannot be null.",
      );
    else url_ += 'PlayerId=' + encodeURIComponent('' + playerId) + '&';
    if (includeCompletedQuests === undefined || includeCompletedQuests === null)
      throw new Error(
        "The parameter 'includeCompletedQuests' must be defined and cannot be null.",
      );
    else
      url_ +=
        'IncludeCompletedQuests=' +
        encodeURIComponent('' + includeCompletedQuests) +
        '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_Quests(_response);
      });
  }

  protected processGet_Player_Quests(
    response: AxiosResponse,
  ): Promise<Entities_Player_Quests_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_Quests_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_Quests_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Player_AllQuests(
    {
      categoryId,
    }: {
      categoryId: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Player_AllQuests_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/all-quests?';
    if (categoryId === undefined || categoryId === null)
      throw new Error(
        "The parameter 'categoryId' must be defined and cannot be null.",
      );
    else url_ += 'CategoryId=' + encodeURIComponent('' + categoryId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Player_AllQuests(_response);
      });
  }

  protected processGet_Player_AllQuests(
    response: AxiosResponse,
  ): Promise<Entities_Player_AllQuests_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Player_AllQuests_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Player_AllQuests_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Player_EvaluateQuestBadge(
    body: Entities_Player_EvaluateQuestBadge_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/player/evaluate-quest-badge?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Player_EvaluateQuestBadge(_response);
      });
  }

  protected processPost_Player_EvaluateQuestBadge(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_SchoolInternational(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_SchoolInternational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/school-international?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_SchoolInternational(_response);
      });
  }

  protected processGet_Rankings_SchoolInternational(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_SchoolInternational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_SchoolInternational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_SchoolInternational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_SchoolNation(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_SchoolNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/school-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_SchoolNation(_response);
      });
  }

  protected processGet_Rankings_SchoolNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_SchoolNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_SchoolNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_SchoolNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_SchoolState(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_SchoolState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/school-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_SchoolState(_response);
      });
  }

  protected processGet_Rankings_SchoolState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_SchoolState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_SchoolState_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_SchoolState_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_SchoolDistrict(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_SchoolDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/school-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_SchoolDistrict(_response);
      });
  }

  protected processGet_Rankings_SchoolDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_SchoolDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_SchoolDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_SchoolDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_SchoolSystem(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_SchoolSystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/school-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_SchoolSystem(_response);
      });
  }

  protected processGet_Rankings_SchoolSystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_SchoolSystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_SchoolSystem_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_SchoolSystem_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamInternational(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamInternational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-international?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamInternational(_response);
      });
  }

  protected processGet_Rankings_TeamInternational(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamInternational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamInternational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamInternational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamNation(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamNation(_response);
      });
  }

  protected processGet_Rankings_TeamNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamState(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamState(_response);
      });
  }

  protected processGet_Rankings_TeamState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamState_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamState_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamDistrict(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamDistrict(_response);
      });
  }

  protected processGet_Rankings_TeamDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamSchool(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamSchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-school?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamSchool(_response);
      });
  }

  protected processGet_Rankings_TeamSchool(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamSchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamSchool_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamSchool_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_TeamSystem(
    {
      grade,
      year,
      level,
    }: {
      grade: SpecialGradeLevel;
      year: string;
      level: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_TeamSystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/team-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_TeamSystem(_response);
      });
  }

  protected processGet_Rankings_TeamSystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_TeamSystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_TeamSystem_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_TeamSystem_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerInternational(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerInternational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-international?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerInternational(_response);
      });
  }

  protected processGet_Rankings_PlayerInternational(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerInternational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerInternational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerInternational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerNation(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerNation(_response);
      });
  }

  protected processGet_Rankings_PlayerNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerState(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerState(_response);
      });
  }

  protected processGet_Rankings_PlayerState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerState_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerState_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerDistrict(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerDistrict(_response);
      });
  }

  protected processGet_Rankings_PlayerDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerSchool(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerSchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-school?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerSchool(_response);
      });
  }

  protected processGet_Rankings_PlayerSchool(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerSchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerSchool_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerSchool_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_PlayerSystem(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_PlayerSystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/player-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_PlayerSystem(_response);
      });
  }

  protected processGet_Rankings_PlayerSystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_PlayerSystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_PlayerSystem_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_PlayerSystem_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_EducatorNation(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_EducatorNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/educator-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_EducatorNation(_response);
      });
  }

  protected processGet_Rankings_EducatorNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_EducatorNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_EducatorNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_EducatorNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_EducatorState(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_EducatorState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/educator-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_EducatorState(_response);
      });
  }

  protected processGet_Rankings_EducatorState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_EducatorState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_EducatorState_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_EducatorState_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_EducatorDistrict(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_EducatorDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/educator-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_EducatorDistrict(_response);
      });
  }

  protected processGet_Rankings_EducatorDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_EducatorDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_EducatorDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_EducatorDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_EducatorSchool(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_EducatorSchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/educator-school?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_EducatorSchool(_response);
      });
  }

  protected processGet_Rankings_EducatorSchool(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_EducatorSchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_EducatorSchool_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_EducatorSchool_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_EducatorSystem(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_EducatorSystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/educator-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_EducatorSystem(_response);
      });
  }

  protected processGet_Rankings_EducatorSystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_EducatorSystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_EducatorSystem_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_EducatorSystem_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_FamilyNation(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_FamilyNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/family-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_FamilyNation(_response);
      });
  }

  protected processGet_Rankings_FamilyNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_FamilyNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_FamilyNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_FamilyNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_FamilyState(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_FamilyState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/family-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_FamilyState(_response);
      });
  }

  protected processGet_Rankings_FamilyState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_FamilyState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_FamilyState_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_FamilyState_Response>(null as any);
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_FamilyDistrict(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_FamilyDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/family-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_FamilyDistrict(_response);
      });
  }

  protected processGet_Rankings_FamilyDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_FamilyDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_FamilyDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_FamilyDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_FamilySchool(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_FamilySchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/family-school?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_FamilySchool(_response);
      });
  }

  protected processGet_Rankings_FamilySchool(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_FamilySchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_FamilySchool_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_FamilySchool_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_FamilySystem(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_FamilySystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/family-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_FamilySystem(_response);
      });
  }

  protected processGet_Rankings_FamilySystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_FamilySystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_FamilySystem_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_FamilySystem_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_CombinedFamilyNation(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_CombinedFamilyNational_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/combined-family-nation?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_CombinedFamilyNation(_response);
      });
  }

  protected processGet_Rankings_CombinedFamilyNation(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_CombinedFamilyNational_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_CombinedFamilyNational_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_CombinedFamilyNational_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_CombinedFamilyState(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_CombinedFamilyState_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/combined-family-state?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_CombinedFamilyState(_response);
      });
  }

  protected processGet_Rankings_CombinedFamilyState(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_CombinedFamilyState_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_CombinedFamilyState_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_CombinedFamilyState_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_CombinedFamilyDistrict(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_CombinedFamilyDistrict_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/combined-family-district?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_CombinedFamilyDistrict(_response);
      });
  }

  protected processGet_Rankings_CombinedFamilyDistrict(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_CombinedFamilyDistrict_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_CombinedFamilyDistrict_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_CombinedFamilyDistrict_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_CombinedFamilySchool(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_CombinedFamilySchool_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/combined-family-school?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_CombinedFamilySchool(_response);
      });
  }

  protected processGet_Rankings_CombinedFamilySchool(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_CombinedFamilySchool_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_CombinedFamilySchool_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_CombinedFamilySchool_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_Rankings_CombinedFamilySystem(
    {
      grade,
      year,
    }: {
      grade: SpecialGradeLevel;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Rankings_CombinedFamilySystem_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/rankings/combined-family-system?';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Rankings_CombinedFamilySystem(_response);
      });
  }

  protected processGet_Rankings_CombinedFamilySystem(
    response: AxiosResponse,
  ): Promise<Entities_Rankings_CombinedFamilySystem_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Rankings_CombinedFamilySystem_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Rankings_CombinedFamilySystem_Response>(
      null as any,
    );
  }

  /**
     * @param level EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @return OK
     */
  get_Savings_Index(
    {
      id,
      year,
      level,
    }: {
      id: number;
      year: string;
      level: EntityLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Savings_Index_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/savings/index?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (level === undefined || level === null)
      throw new Error(
        "The parameter 'level' must be defined and cannot be null.",
      );
    else url_ += 'Level=' + encodeURIComponent('' + level) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Savings_Index(_response);
      });
  }

  protected processGet_Savings_Index(
    response: AxiosResponse,
  ): Promise<Entities_Savings_Index_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Savings_Index_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Savings_Index_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_WallOfFame(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_WallOfFame_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/wall-of-fame?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_WallOfFame(_response);
      });
  }

  protected processGet_School_WallOfFame(
    response: AxiosResponse,
  ): Promise<Entities_School_WallOfFame_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_WallOfFame_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_WallOfFame_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Edit(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Edit_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/edit?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Edit(_response);
      });
  }

  protected processGet_School_Edit(
    response: AxiosResponse,
  ): Promise<Entities_School_Edit_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Edit_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Edit_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_School_UpdateContact(
    body: Entities_School_UpdateContact_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/update-contact?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_School_UpdateContact(_response);
      });
  }

  protected processPost_School_UpdateContact(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Teams(
    {
      schoolId,
      year,
    }: {
      schoolId: SchoolId;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Teams_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/teams?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Teams(_response);
      });
  }

  protected processGet_School_Teams(
    response: AxiosResponse,
  ): Promise<Entities_School_Teams_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Teams_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Teams_Response>(null as any);
  }

  /**
     * @param loginType LoginType

    - `0` = NotLoggedIn
    - `1` = SalesRep
    - `2` = RegionAdmin
    - `3` = DistrictAdmin
    - `4` = TeamLeader
    - `5` = StudentPlayer
    - `6` = SchoolPrincipal
    - `8` = IndividualPlayer
    - `19` = Multi
    - `98` = LimitedAdmin
    - `99` = Admin
     * @return OK
     */
  get_School_Index(
    {
      loginType,
      loginId,
      schoolId,
      userId,
    }: {
      loginType: LoginType;
      loginId: LoginId;
      schoolId: SchoolId;
      userId: UserId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Index_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/index?';
    if (loginType === undefined || loginType === null)
      throw new Error(
        "The parameter 'loginType' must be defined and cannot be null.",
      );
    else url_ += 'LoginType=' + encodeURIComponent('' + loginType) + '&';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null.",
      );
    else url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Index(_response);
      });
  }

  protected processGet_School_Index(
    response: AxiosResponse,
  ): Promise<Entities_School_Index_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Index_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Index_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_MovePlayers(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_MovePlayers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/move-players?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_MovePlayers(_response);
      });
  }

  protected processGet_School_MovePlayers(
    response: AxiosResponse,
  ): Promise<Entities_School_MovePlayers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_MovePlayers_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_MovePlayers_Response>(null as any);
  }

  /**
     * @param mode Mode

    - `1` = Daily
    - `2` = Weekly
    - `3` = Monthly
     * @return OK
     */
  get_School_SchoolHistory(
    {
      schoolId,
      mode,
    }: {
      schoolId: SchoolId;
      mode: Mode;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_SchoolHistory_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/school-history?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (mode === undefined || mode === null)
      throw new Error(
        "The parameter 'mode' must be defined and cannot be null.",
      );
    else url_ += 'Mode=' + encodeURIComponent('' + mode) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_SchoolHistory(_response);
      });
  }

  protected processGet_School_SchoolHistory(
    response: AxiosResponse,
  ): Promise<Entities_School_SchoolHistory_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_SchoolHistory_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_SchoolHistory_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Players(
    {
      schoolId,
      year,
    }: {
      schoolId: SchoolId;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Players_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/players?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Players(_response);
      });
  }

  protected processGet_School_Players(
    response: AxiosResponse,
  ): Promise<Entities_School_Players_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Players_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Players_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Staff(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Staff_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/staff?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Staff(_response);
      });
  }

  protected processGet_School_Staff(
    response: AxiosResponse,
  ): Promise<Entities_School_Staff_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Staff_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Staff_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_AssignTeachers(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_AssignTeachers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/assign-teachers?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_AssignTeachers(_response);
      });
  }

  protected processGet_School_AssignTeachers(
    response: AxiosResponse,
  ): Promise<Entities_School_AssignTeachers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_AssignTeachers_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_AssignTeachers_Response>(
      null as any,
    );
  }

  /**
     * @param grade SpecialGradeLevel

    - `0` = Kindergarten
    - `1` = Grade1
    - `2` = Grade2
    - `3` = Grade3
    - `4` = Grade4
    - `5` = Grade5
    - `6` = Grade6
    - `7` = Grade7
    - `8` = Grade8
    - `9` = Grade9
    - `10` = Grade10
    - `11` = Grade11
    - `12` = Grade12
    - `50` = Other
    - `100` = AllGrades
    - `108` = Grades3To8
    - `109` = Top10Teachers
    - `110` = Top10FamilyLink
    - `111` = Top100Students
    - `112` = Top200Students
    - `113` = Top500Students
    - `115` = Top100StudentsUpTo200
    - `-9999` = Null
    - `-1` = Unassigned
     * @return OK
     */
  get_School_Summary(
    {
      schoolId,
      year,
      grade,
    }: {
      schoolId: SchoolId;
      year: string;
      grade: SpecialGradeLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Summary_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/summary?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (grade === undefined || grade === null)
      throw new Error(
        "The parameter 'grade' must be defined and cannot be null.",
      );
    else url_ += 'Grade=' + encodeURIComponent('' + grade) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Summary(_response);
      });
  }

  protected processGet_School_Summary(
    response: AxiosResponse,
  ): Promise<Entities_School_Summary_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Summary_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Summary_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_School_Update(
    body: Entities_School_Update_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/update?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_School_Update(_response);
      });
  }

  protected processPost_School_Update(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Meta(
    {
      schoolId,
      key,
    }: {
      schoolId: SchoolId;
      key: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Meta_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/meta?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (key === undefined || key === null)
      throw new Error(
        "The parameter 'key' must be defined and cannot be null.",
      );
    else url_ += 'Key=' + encodeURIComponent('' + key) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Meta(_response);
      });
  }

  protected processGet_School_Meta(
    response: AxiosResponse,
  ): Promise<Entities_School_Meta_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Meta_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Meta_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Teachers(
    {
      schoolId,
    }: {
      schoolId: SchoolId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Teachers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/teachers?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Teachers(_response);
      });
  }

  protected processGet_School_Teachers(
    response: AxiosResponse,
  ): Promise<Entities_School_Teachers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Teachers_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Teachers_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_School_Top(
    {
      schoolId,
      year,
    }: {
      schoolId: SchoolId;
      year: string;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_School_Top_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/school/top?';
    if (schoolId === undefined || schoolId === null)
      throw new Error(
        "The parameter 'schoolId' must be defined and cannot be null.",
      );
    else url_ += 'SchoolId=' + encodeURIComponent('' + schoolId) + '&';
    if (year === undefined || year === null)
      throw new Error(
        "The parameter 'year' must be defined and cannot be null.",
      );
    else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_School_Top(_response);
      });
  }

  protected processGet_School_Top(
    response: AxiosResponse,
  ): Promise<Entities_School_Top_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_School_Top_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_School_Top_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Speech_Token(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_Speech_GetSpeechToken_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/speech/token?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Speech_Token(_response);
      });
  }

  protected processGet_Speech_Token(
    response: AxiosResponse,
  ): Promise<Entities_Speech_GetSpeechToken_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Speech_GetSpeechToken_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Speech_GetSpeechToken_Response>(
      null as any,
    );
  }

  /**
     * @param type TeamTopPlayersType

    - `0` = AllTime
    - `1` = Today
    - `2` = Yesterday
    - `3` = Week
    - `4` = Month
     * @return OK
     */
  get_Team_Index(
    {
      loginId,
      teamId,
      type,
    }: {
      loginId: LoginId;
      teamId: TeamId;
      type: TeamTopPlayersType;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_Index_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/index?';
    if (loginId === undefined || loginId === null)
      throw new Error(
        "The parameter 'loginId' must be defined and cannot be null.",
      );
    else url_ += 'LoginId=' + encodeURIComponent('' + loginId) + '&';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (type === undefined || type === null)
      throw new Error(
        "The parameter 'type' must be defined and cannot be null.",
      );
    else url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Index(_response);
      });
  }

  protected processGet_Team_Index(
    response: AxiosResponse,
  ): Promise<Entities_Team_Index_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_Index_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_Index_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_Info(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_TeamInformation_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/info?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Info(_response);
      });
  }

  protected processGet_Team_Info(
    response: AxiosResponse,
  ): Promise<Entities_Team_TeamInformation_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_TeamInformation_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_TeamInformation_Response>(null as any);
  }

  /**
   * @return OK
   */
  put_Team_Update(
    body: Entities_Team_UpdateInfo_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/update?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Team_Update(_response);
      });
  }

  protected processPut_Team_Update(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  put_Team_UpdateContact(
    body: Entities_Team_UpdateContact_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/update-contact?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Team_UpdateContact(_response);
      });
  }

  protected processPut_Team_UpdateContact(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_Teachers(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_Teachers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/teachers?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Teachers(_response);
      });
  }

  protected processGet_Team_Teachers(
    response: AxiosResponse,
  ): Promise<Entities_Team_Teachers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_Teachers_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_Teachers_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_Team(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_Team_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/team?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Team(_response);
      });
  }

  protected processGet_Team_Team(
    response: AxiosResponse,
  ): Promise<Entities_Team_Team_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_Team_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_Team_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_Roster(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_Roster_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/roster?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Roster(_response);
      });
  }

  protected processGet_Team_Roster(
    response: AxiosResponse,
  ): Promise<Entities_Team_Roster_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_Roster_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_Roster_Response>(null as any);
  }

  /**
   * @return OK
   */
  put_Team_UpdatePlayer(
    body: Entities_Team_UpdatePlayer_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_UpdatePlayer_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/update-player?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPut_Team_UpdatePlayer(_response);
      });
  }

  protected processPut_Team_UpdatePlayer(
    response: AxiosResponse,
  ): Promise<Entities_Team_UpdatePlayer_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_UpdatePlayer_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_UpdatePlayer_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_MovePlayer(
    body: Entities_Team_MovePlayer_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_MovePlayer_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/move-player?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_MovePlayer(_response);
      });
  }

  protected processPost_Team_MovePlayer(
    response: AxiosResponse,
  ): Promise<Entities_Team_MovePlayer_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_MovePlayer_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_MovePlayer_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_MovePlayers(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_MovePlayers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/move-players?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_MovePlayers(_response);
      });
  }

  protected processGet_Team_MovePlayers(
    response: AxiosResponse,
  ): Promise<Entities_Team_MovePlayers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_MovePlayers_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_MovePlayers_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_Focus(
    {
      teamId,
    }: {
      teamId: TeamId;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_Focus_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/focus?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_Focus(_response);
      });
  }

  protected processGet_Team_Focus(
    response: AxiosResponse,
  ): Promise<Entities_Team_Focus_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_Focus_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_Focus_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_Focus(
    body: Entities_Team_UpdateFocus_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/focus?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_Focus(_response);
      });
  }

  protected processPost_Team_Focus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  get_Team_RecentActivity(
    {
      teamId,
      batchSize,
    }: {
      teamId: TeamId;
      batchSize: number;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_RecentActivity_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/recent-activity?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (batchSize === undefined || batchSize === null)
      throw new Error(
        "The parameter 'batchSize' must be defined and cannot be null.",
      );
    else url_ += 'BatchSize=' + encodeURIComponent('' + batchSize) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_RecentActivity(_response);
      });
  }

  protected processGet_Team_RecentActivity(
    response: AxiosResponse,
  ): Promise<Entities_Team_RecentActivity_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_RecentActivity_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_RecentActivity_Response>(null as any);
  }

  /**
     * @param mode Mode

    - `1` = Daily
    - `2` = Weekly
    - `3` = Monthly
     * @return OK
     */
  get_Team_TeamHistory(
    {
      teamId,
      mode,
    }: {
      teamId: TeamId;
      mode: Mode;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_TeamHistory_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/team-history?';
    if (teamId === undefined || teamId === null)
      throw new Error(
        "The parameter 'teamId' must be defined and cannot be null.",
      );
    else url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    if (mode === undefined || mode === null)
      throw new Error(
        "The parameter 'mode' must be defined and cannot be null.",
      );
    else url_ += 'Mode=' + encodeURIComponent('' + mode) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_TeamHistory(_response);
      });
  }

  protected processGet_Team_TeamHistory(
    response: AxiosResponse,
  ): Promise<Entities_Team_TeamHistory_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_TeamHistory_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_TeamHistory_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_GenerateNewUserId(
    body: Entities_Team_GenerateNewUserId_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_GenerateNewUserId_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/generate-new-user-id?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_GenerateNewUserId(_response);
      });
  }

  protected processPost_Team_GenerateNewUserId(
    response: AxiosResponse,
  ): Promise<Entities_Team_GenerateNewUserId_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_GenerateNewUserId_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_GenerateNewUserId_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Team_Upload(
    body: Entities_Team_UploadFile_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_UploadFile_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/upload?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_Upload(_response);
      });
  }

  protected processPost_Team_Upload(
    response: AxiosResponse,
  ): Promise<Entities_Team_UploadFile_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_UploadFile_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_UploadFile_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_AddAppFeedback(
    body: Entities_Team_AddAppFeedback_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/add-app-feedback?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_AddAppFeedback(_response);
      });
  }

  protected processPost_Team_AddAppFeedback(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_AddUserFeedback(
    body: Entities_Team_AddUserFeedback_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<void> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/add-user-feedback?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_AddUserFeedback(_response);
      });
  }

  protected processPost_Team_AddUserFeedback(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_ValidateMultiplePlayers(
    body: Entities_Team_ValidateMultiplePlayers_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_ValidateMultiplePlayers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/validate-multiple-players?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_ValidateMultiplePlayers(_response);
      });
  }

  protected processPost_Team_ValidateMultiplePlayers(
    response: AxiosResponse,
  ): Promise<Entities_Team_ValidateMultiplePlayers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_ValidateMultiplePlayers_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_ValidateMultiplePlayers_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  post_Team_CreateMultiplePlayers(
    body: Entities_Team_CreateMultiplePlayers_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_CreateMultiplePlayers_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/create-multiple-players?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_CreateMultiplePlayers(_response);
      });
  }

  protected processPost_Team_CreateMultiplePlayers(
    response: AxiosResponse,
  ): Promise<Entities_Team_CreateMultiplePlayers_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_CreateMultiplePlayers_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_CreateMultiplePlayers_Response>(
      null as any,
    );
  }

  /**
     * @param entityLevel EntityLevel

    - `0` = Player
    - `1` = Team
    - `2` = School
    - `3` = District
    - `4` = Region
    - `5` = State
    - `99` = All
    - `-1` = None
     * @return OK
     */
  get_Team_MembershipCards(
    {
      entityId,
      entityLevel,
    }: {
      entityId: number;
      entityLevel: EntityLevel;
    },
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_MembershipCards_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/membership-cards?';
    if (entityId === undefined || entityId === null)
      throw new Error(
        "The parameter 'entityId' must be defined and cannot be null.",
      );
    else url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (entityLevel === undefined || entityLevel === null)
      throw new Error(
        "The parameter 'entityLevel' must be defined and cannot be null.",
      );
    else url_ += 'EntityLevel=' + encodeURIComponent('' + entityLevel) + '&';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_Team_MembershipCards(_response);
      });
  }

  protected processGet_Team_MembershipCards(
    response: AxiosResponse,
  ): Promise<Entities_Team_MembershipCards_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_MembershipCards_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_MembershipCards_Response>(null as any);
  }

  /**
   * @return OK
   */
  post_Team_EnsureTeacherPlayer(
    body: Entities_Team_EnsureTeacherPlayer_Request | undefined,
    cancelToken?: CancelToken,
  ): Promise<Entities_Team_EnsureTeacherPlayer_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/team/ensure-teacher-player?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPost_Team_EnsureTeacherPlayer(_response);
      });
  }

  protected processPost_Team_EnsureTeacherPlayer(
    response: AxiosResponse,
  ): Promise<Entities_Team_EnsureTeacherPlayer_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_Team_EnsureTeacherPlayer_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_Team_EnsureTeacherPlayer_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_WebFlow_Resources(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<{ [key: string]: Entities_WebFlow_Resources_ResourceItem[] }> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/resources?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_Resources(_response);
      });
  }

  protected processGet_WebFlow_Resources(
    response: AxiosResponse,
  ): Promise<{ [key: string]: Entities_WebFlow_Resources_ResourceItem[] }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<{
        [key: string]: Entities_WebFlow_Resources_ResourceItem[];
      }>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<{
      [key: string]: Entities_WebFlow_Resources_ResourceItem[];
    }>(null as any);
  }

  /**
   * @return OK
   */
  get_WebFlow_TutorialsAdditionalLinks(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_TutorialsAdditionalLinks_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/tutorials-additional-links?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_TutorialsAdditionalLinks(_response);
      });
  }

  protected processGet_WebFlow_TutorialsAdditionalLinks(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_TutorialsAdditionalLinks_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_TutorialsAdditionalLinks_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_TutorialsAdditionalLinks_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_WebFlow_TutorialsLearningTools(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_TutorialsLearningTools_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/tutorials-learning-tools?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_TutorialsLearningTools(_response);
      });
  }

  protected processGet_WebFlow_TutorialsLearningTools(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_TutorialsLearningTools_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_TutorialsLearningTools_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_TutorialsLearningTools_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_WebFlow_TutorialsGameExamples(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_TutorialsGameExamples_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/tutorials-game-examples?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_TutorialsGameExamples(_response);
      });
  }

  protected processGet_WebFlow_TutorialsGameExamples(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_TutorialsGameExamples_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_TutorialsGameExamples_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_TutorialsGameExamples_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_WebFlow_TutorialsVpd(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_TutorialsVPD_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/tutorials-vpd?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_TutorialsVpd(_response);
      });
  }

  protected processGet_WebFlow_TutorialsVpd(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_TutorialsVPD_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_TutorialsVPD_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_TutorialsVPD_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_WebFlow_Recognition(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_Recognition_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/recognition?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_Recognition(_response);
      });
  }

  protected processGet_WebFlow_Recognition(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_Recognition_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_Recognition_Response>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_Recognition_Response>(null as any);
  }

  /**
   * @return OK
   */
  get_WebFlow_HomeConnectionInfo(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_HomeConnectionInfo_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/home-connection-info?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_HomeConnectionInfo(_response);
      });
  }

  protected processGet_WebFlow_HomeConnectionInfo(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_HomeConnectionInfo_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_HomeConnectionInfo_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_HomeConnectionInfo_Response>(
      null as any,
    );
  }

  /**
   * @return OK
   */
  get_WebFlow_HomeConnectionFamilyLink(
    {}: {},
    cancelToken?: CancelToken,
  ): Promise<Entities_WebFlow_HomeConnectionFamilyLink_Response> {
    const api_version = Client.DEFAULT_API_VERSION;
    let url_ = this.baseUrl + '/api/webflow/home-connection-family-link?';
    if (api_version === null)
      throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined)
      url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet_WebFlow_HomeConnectionFamilyLink(_response);
      });
  }

  protected processGet_WebFlow_HomeConnectionFamilyLink(
    response: AxiosResponse,
  ): Promise<Entities_WebFlow_HomeConnectionFamilyLink_Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JSON.parse(resultData200);
      return Promise.resolve<Entities_WebFlow_HomeConnectionFamilyLink_Response>(
        result200,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<Entities_WebFlow_HomeConnectionFamilyLink_Response>(
      null as any,
    );
  }
}

export interface Common_VifModule {
  name: string | undefined;
  filename: string | undefined;
  slug: string | undefined;
  isMilestone: boolean;
  moduleId: VifModuleInfo;
  moduleVariant: number;
}

export interface Database_Procs_ActivityAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  stickers: number;
  students: number;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers4D: number;
  stickers5D: number;
  stickers6D: number;
  stickers7D: number;
  stickers1W: number;
  stickers2W: number;
  stickers3W: number;
  stickers4W: number;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
}

export interface Database_Procs_AdminGetDistricts_Item {
  id: number;
  name: string | undefined;
  address1: string | undefined;
  address2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zip: string | undefined;
  county: string | undefined;
  phone: string | undefined;
  bpcode: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
  schoolCount: number;
  teamCount: number;
  activeTeamCount: number;
  stickers: number;
  numberOfLicenses: number;
  activePlayers: number;
  averageStickers: number;
}

export interface Database_Procs_AdminGetRegions_Item {
  name: string | undefined;
  id: number;
  loginId: LoginId;
  stateId: number;
  bpCode: string | undefined;
  districtCount: number;
  schoolCount: number;
  teamCount: number;
  activeTeamCount: number;
  stickers: number;
  stateName: string | undefined;
  numberOfLicenses: number;
  activePlayers: number;
}

export interface Database_Procs_AdminGetSchools_Item {
  id: number;
  name: string | undefined;
  schoolContact: string | undefined;
  address1: string | undefined;
  address2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zip: string | undefined;
  phone: string | undefined;
  email: string | undefined;
  numberOfLicenses: number;
  teamCount: number;
  activeTeamCount: number;
  stickers: number;
  studentsPlaying: number;
  userId: UserId | undefined;
  password: string | undefined;
  principalName: string | undefined;
  principalEmail: string | undefined;
  bpCode: string | undefined;
  averageStickers: number;
}

export interface Database_Procs_AdminGetStates_Item {
  name: string | undefined;
  id: number;
  regionCount: number;
  teamCount: number;
  activeTeamCount: number;
  stickers: number;
  numberOfLicenses: number;
  studentsPlaying: number;
}

export interface Database_Procs_AdminGetTeams_Item {
  id: number;
  schoolId: SchoolId;
  loginId: LoginId;
  focusGroupId: number;
  teamName: string | undefined;
  year: string | undefined;
  grade: number;
  className: string | undefined;
  sectionNumber: string | undefined;
  state: string | undefined;
  programBegins: Date;
  programEnds: Date;
  studentsPlaying: number;
  winnerCircleCount: number;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers4D: number;
  stickers5D: number;
  stickers6D: number;
  stickers7D: number;
  stickers1W: number;
  stickers2W: number;
  stickers3W: number;
  stickers4W: number;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
  poNumber: string | undefined;
  orderNumber: number;
  docEntry: number;
  excludeRankings: boolean;
  isImport: boolean;
  isPlaceHolder: boolean;
  vendorId: string | undefined;
  vendorType: number;
  status: string | undefined;
  rowGUID: string;
  created: Date;
  lastModified: Date;
  contactId: number;
  bpCode: string | undefined;
  teacherName: string | undefined;
  email: string | undefined;
  position: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
  assignedplayers: number;
  playerCount: number;
  numberOfLicenses: number;
  activeTeamCount: number;
  teamCount: number;
  stickers: number;
  averageStickers: number;
}

export interface Database_Procs_AdminMoveGetSchoolTeams_Item {
  districtName: string | undefined;
  schoolName: string | undefined;
  teamID: number;
  teamName: string | undefined;
  className: string | undefined;
  programBegins: Date;
  programEnds: Date;
  grade: number;
  students: number;
  excludeRankings: boolean;
  userID: string | undefined;
  password: string | undefined;
  displayName: string | undefined;
  teamContactId: number;
  teamContact: string | undefined;
  teamEmail: string | undefined;
  loginId: LoginId;
}

export interface Database_Procs_EntitySummaryByAggregateLevel_Item {
  id: number;
  name: string | undefined;
  grade: number;
  stickers: number;
  timeOnTask: number;
  problemsSolved: number;
  teamCount: number;
  stickersPerTeam: number;
  stickersPerStudent: number;
  students: number;
  totalLicenses: number;
  numberMathematicians: number;
  percentMathematicians: number;
  numberChampions: number;
  percentChampions: number;
  numberGrandChampions: number;
  percentGrandChampions: number;
}

export interface Database_Procs_ExportSchool_Item {
  loginId: LoginId;
  playerId: PlayerId;
  userID: string | undefined;
  displayName: string | undefined;
  studentID: string | undefined;
  altuser: string | undefined;
  lastlogin: string | undefined;
  group: string | undefined;
  teamName: string | undefined;
  className: string | undefined;
  teamLeader: string | undefined;
  grade: string | undefined;
  stickers: number;
  estTimeOnTaskH: number;
  activityEarly: number;
  factEarly: number;
  wordProblemEarly: number;
  proceduralEarly: number;
  compositeEarly: number;
  activityElementary: number;
  factElementary: number;
  wordProblemElementary: number;
  proceduralElementary: number;
  compositeElementary: number;
  activityIntermediate: number;
  factIntermediate: number;
  wordProblemIntermediate: number;
  proceduralIntermediate: number;
  compositeIntermediate: number;
  activityAdvanced: number;
  factAdvanced: number;
  wordProblemAdvanced: number;
  proceduralAdvanced: number;
  compositeAdvanced: number;
  jtF100AddPretestDt: Date;
  jtF100AddPostTestDt: Date;
  jtF100AddPretest: number;
  jtF100AddCurrent: number;
  jtF100AddBest: number;
  jtF100SubPretestDt: Date;
  jtF100SubPostTestDt: Date;
  jtF100SubPretest: number;
  jtF100SubCurrent: number;
  jtF100SubBest: number;
  jtF100MulPretestDt: Date;
  jtF100MulPosttestDt: Date;
  jtF100MulPretest: number;
  jtF100MulCurrent: number;
  jtF100MulBest: number;
  jtF100DivPretestDt: Date;
  jtF100DivPosttestDt: Date;
  jtF100DivPretest: number;
  jtF100DivCurrent: number;
  jtF100DivBest: number;
  sS1G1: number;
  sS1G2: number;
  sS1G3: number;
  sS2G1: number;
  sS2G2: number;
  sS2G3: number;
  sS3G1: number;
  sS3G2: number;
  sS3G3: number;
  sS4G1: number;
  sS4G2: number;
  sS4G3: number;
  sS5G1: number;
  sS5G2: number;
  sS5G3: number;
  sS6G1: number;
  sS6G2: number;
  sS6G3: number;
  sS7G1: number;
  sS7G2: number;
  sS7G3: number;
  sS8G1: number;
  sS8G2: number;
  sS8G3: number;
  gyM_ADD_NUM: number;
  gyM_SUB_NUM: number;
  gyM_MUL_NUM: number;
  gyM_DIV_NUM: number;
  gyM_ADD_INT: number;
  gyM_SUB_INT: number;
  gyM_MUL_INT: number;
  gyM_DIV_INT: number;
  gyM_ADD_FRC: number;
  gyM_SUB_FRC: number;
  gyM_MUL_FRC: number;
  gyM_DIV_FRC: number;
  gyM_ADD_DEC: number;
  gyM_SUB_DEC: number;
  gyM_MUL_DEC: number;
  gyM_DIV_DEC: number;
  gyM_ADD_K2: number;
  gyM_SUB_K2: number;
  vifAdd10KFacts: number;
  vifSub10KFacts: number;
  vifMul10KFacts: number;
  vifDiv10KFacts: number;
  earned1DAgo: number;
  earned2DAgo: number;
  earned3DAgo: number;
  earned4DAgo: number;
  earned5DAgo: number;
  earned1WKAgo: number;
  earned2WKAgo: number;
  earned3WKAgo: number;
  earned4WKAgo: number;
  earned1MAgo: number;
  earned2MAgo: number;
  earned3MAgo: number;
  earned4MAgo: number;
  earned5MAgo: number;
  rowGUID: string;
}

export interface Database_Procs_GetAlgebraGoalsMetricPlayers_Item {
  playerId: PlayerId;
  playerName: string | undefined;
  refName: string | undefined;
  algebraOverall: number;
  factFluency: number;
  equivalentFractions: number;
  fractions: number;
  decimals: number;
  integers: number;
  exponents: number;
  orderOfOperations: number;
}

export interface Database_Procs_GetAlgebraGoalsMetricTeams_Item {
  teamId: TeamId;
  teamName: string | undefined;
  className: string | undefined;
  algebraOverall: number;
  factFluency: number;
  equivalentFractions: number;
  fractions: number;
  decimals: number;
  integers: number;
  exponents: number;
  orderOfOperations: number;
}

export interface Database_Procs_GetAlgebraGoalsMetric_Item {
  algebraOverall: number;
  factFluency: number;
  equivalentFractions: number;
  fractions: number;
  decimals: number;
  integers: number;
  exponents: number;
  orderOfOperations: number;
}

export interface Database_Procs_GetAllQuest_Item {
  id: number;
  categoryName: string | undefined;
  slug: string | undefined;
  questName: string | undefined;
  description: string | undefined;
  stickerReward: number;
  difficultyLevel: number;
  maxCompletions: number;
  questType: string | undefined;
  tag: string | undefined;
}

export interface Database_Procs_GetBonusPercent_Item {
  playerId: PlayerId;
  loginId: LoginId;
  teamId: TeamId;
  userId: UserId | undefined;
  displayName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  ten_wheels: number;
  first_in_tens_add: number;
  first_in_tens_sub: number;
  mol: number;
  shape_shuffle: number;
  deep_seaquence: number;
  grand_slam_add_sub: number;
  first_to_twenty_add: number;
  first_to_twenty_sub: number;
  speed_shuffle: number;
  touchdown_100_add: number;
  touchdown_100_sub: number;
  factor_wheels: number;
  grand_slam_mul_div: number;
  skip_game: number;
  decimals_mol: number;
  xyz_shuffle: number;
  estimation: number;
  _24_wheels: number;
  monus_path: number;
  the_hex_factor: number;
  fractions_mol: number;
  pundis_puzzle: number;
  rps: number;
  equivalents: number;
  fraction_wheels: number;
  pattern_puzzle: number;
  monujis_path: number;
  pattern_power: number;
  grand_slam_integers: number;
  xtreme_algebra: number;
  algebra_mol: number;
  rps_master: number;
  into_the_vortex: number;
  grand_slam_frc_add_sub: number;
  grand_slam_frc_mul_div: number;
  grand_slam_frc_all: number;
  grand_slam_dec_add_sub: number;
  grand_slam_dec_mul_div: number;
  grand_slam_dec_all: number;
  equal_length: number;
  equal_length_1: number;
  equal_length_2: number;
  time_more_or_less: number;
  equal_time: number;
  passing_time: number;
  equal_pay: number;
  equal_pay_india: number;
  making_change: number;
  making_change_india: number;
  equal_weight: number;
  equal_weight_1: number;
  equal_weight_2: number;
  area_perimeter_square: number;
  area_perimeter_square_1: number;
  area_perimeter_square_2: number;
  area_perimeter_circle: number;
  area_perimeter_circle_1: number;
  area_perimeter_circle_2: number;
  area_perimeter_rectangle: number;
  area_perimeter_rectangle_1: number;
  area_perimeter_rectangle_2: number;
  area_perimeter_triangle: number;
  area_perimeter_triangle_1: number;
  area_perimeter_triangle_2: number;
  k2_rps: number;
  _3_to_9_add: number;
  _3_to_9_sub: number;
  k2_mol: number;
  k2_skip_game: number;
  k2_pundis_puzzle: number;
  see_3: number;
  rps_newb_ct: number;
  rps_ct: number;
  rps_master_ct: number;
  k2_how_many: number;
  pundis_puzzle_ct: number;
  misfits_newb: number;
  misfits: number;
  misfits_master: number;
  zero_sum: number;
  k2_five_at_a_time: number;
  misfits_num: number;
  misfits_frc: number;
  misfits_dec: number;
  grand_slam_alg: number;
  estimation_dec: number;
  k2_misfits: number;
  k2_misfits_num: number;
  misfits_37: number;
  misfits_37_num: number;
  jtf_k2_add: number;
  jtf_k2_sub: number;
  jtf_k2_mul: number;
  jtf_k2_div: number;
  k2_triplets: number;
  _3_moves_to_0: number;
  _3_moves_to_0_quantum: number;
  k2_undo: number;
  pk_three_at_a_time: number;
  k2_four_at_a_time: number;
  pk_how_many: number;
  k2_before_and_after: number;
  pk_before_and_after: number;
  pk_mol: number;
  pk_missing_icons: number;
  k2_missing_icons_ct: number;
  k2_pundis_puzzle_ct: number;
  k2_rps_ct: number;
  k2_misfits_num_ct: number;
  zero_sum_newb: number;
  k2_monus_path_ct: number;
  undo_fractions: number;
  factor_wheels_ct: number;
  k2_jennies_jewels: number;
  jennies_jewels: number;
  k2_what_belongs_ct: number;
  link_n_lock_as: number;
  link_n_lock_md: number;
  link_n_lock_frc: number;
  link_n_lock_mosaic: number;
  link_n_lock_jewels: number;
  gems_to_zero: number;
  jeweled_tiles: number;
  equivalent_fraction_tiles: number;
  algebra_tiles: number;
  decimal_tiles: number;
  vif_tiles: number;
  exponent_tiles: number;
  integer_tiles: number;
  order_of_operations_tiles: number;
  fraction_tiles: number;
  early_algebra_tiles: number;
  pk_memory_tiles: number;
  elementary_algebra_tiles: number;
  geometry_tiles: number;
  money_tiles: number;
  quantum_algebra: number;
  dii_fractions: number;
  abc: number;
  letter_memory: number;
  matching_letters: number;
  alphabet: number;
  high_fq_words: number;
  rhyme_time: number;
  misfits_spelling: number;
  missing_letters: number;
  verb_tenses: number;
  building_sentences: number;
  consonant_blends: number;
  math_words: number;
  cb_sounds: number;
  phonemes_alpha: number;
  phonemes_pi: number;
  sound_of_letters: number;
  change_one_letter: number;
  word_wheels: number;
  finding_words_4x4: number;
  ten_wheels_elite: number;
  write_a_sentence: number;
  number_circles: number;
  epic_circles: number;
}

export interface Database_Procs_GetContest_Item {
  id: number;
  playerId: PlayerId;
  timeAllowed: number;
  secureLink: string | undefined;
  dateRequested: Date;
  dateStarted: Date;
  dateCompleted: Date;
  senderLoginId: LoginId;
  round1Score: number;
  round2Score: number;
  round3Score: number;
  totalScore: number;
  round1Time: number;
  round2Time: number;
  round3Time: number;
  currentRound: number;
  grade: number;
}

export interface Database_Procs_GetGoalsIndexPlayers_Item {
  playerId: PlayerId;
  playerName: string | undefined;
  refName: string | undefined;
  activity: number;
  fact: number;
  wordProblem: number;
  procedural: number;
  composite: number;
}

export interface Database_Procs_GetGoalsIndexTeams_Item {
  teamId: TeamId;
  teamName: string | undefined;
  className: string | undefined;
  activity: number;
  fact: number;
  wordProblem: number;
  procedural: number;
  composite: number;
}

export interface Database_Procs_GetGoalsIndex_Item {
  activity: number;
  fact: number;
  wordProblem: number;
  procedural: number;
  composite: number;
}

export interface Database_Procs_GetIndividualSubscriptionExpiration_Item {
  loginId: LoginId;
  userId: UserId | undefined;
  password: string | undefined;
  loginType: number;
  active: boolean;
  leaderReg: string | undefined;
  idnumber: string | undefined;
  siteId: number;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  displayName: string | undefined;
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  identifier: string | undefined;
  schoolName: string | undefined;
  schoolDistrict: string | undefined;
  address1: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zipcode: string | undefined;
  indivTypeId: number;
  campaignID: number;
  referralID: number;
  pid: string | undefined;
  districtpid: string | undefined;
  phone: string | undefined;
  source: string | undefined;
  other: string | undefined;
  teamSent: boolean;
  stickers: number;
  playEnds: Date;
}

export interface Database_Procs_GetJTFPercent_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  isPrimaryTeam: boolean;
  played: number;
  addPercentInitial100Num: number;
  subPercentInitial100Num: number;
  mulPercentInitial100Num: number;
  divPercentInitial100Num: number;
  addPercentCurrent100Num: number;
  subPercentCurrent100Num: number;
  mulPercentCurrent100Num: number;
  divPercentCurrent100Num: number;
  addPercentCurrentBest100Num: number;
  subPercentCurrentBest100Num: number;
  mulPercentCurrentBest100Num: number;
  divPercentCurrentBest100Num: number;
  addPercentInitial100Dec: number;
  subPercentInitial100Dec: number;
  mulPercentInitial100Dec: number;
  divPercentInitial100Dec: number;
  addPercentCurrent100Dec: number;
  subPercentCurrent100Dec: number;
  mulPercentCurrent100Dec: number;
  divPercentCurrent100Dec: number;
  addPercentCurrentBest100Dec: number;
  subPercentCurrentBest100Dec: number;
  mulPercentCurrentBest100Dec: number;
  divPercentCurrentBest100Dec: number;
  addPercentInitial100Int: number;
  subPercentInitial100Int: number;
  mulPercentInitial100Int: number;
  divPercentInitial100Int: number;
  addPercentCurrent100Int: number;
  subPercentCurrent100Int: number;
  mulPercentCurrent100Int: number;
  divPercentCurrent100Int: number;
  addPercentCurrentBest100Int: number;
  subPercentCurrentBest100Int: number;
  mulPercentCurrentBest100Int: number;
  divPercentCurrentBest100Int: number;
  addPercentInitial100Frc: number;
  subPercentInitial100Frc: number;
  mulPercentInitial100Frc: number;
  divPercentInitial100Frc: number;
  addPercentCurrent100Frc: number;
  subPercentCurrent100Frc: number;
  mulPercentCurrent100Frc: number;
  divPercentCurrent100Frc: number;
  addPercentCurrentBest100Frc: number;
  subPercentCurrentBest100Frc: number;
  mulPercentCurrentBest100Frc: number;
  divPercentCurrentBest100Frc: number;
}

export interface Database_Procs_GetLinkedSchools_Item {
  id: number;
  schoolName: string | undefined;
  contactName: string | undefined;
  districtId: number;
  districtName: string | undefined;
}

export interface Database_Procs_GetLinkedTeams_Item {
  id: number;
  teamName: string | undefined;
  grade: number;
  year: string | undefined;
  className: string | undefined;
  teacherName: string | undefined;
  loginId: LoginId;
  schoolId: SchoolId;
  schoolName: string | undefined;
}

export interface Database_Procs_GetPlayerBadge_Item {
  id: number;
  slug: string | undefined;
  awardedDate: Date;
  timesCompleted: number;
  badgeName: string | undefined;
  description: string | undefined;
}

export interface Database_Procs_GetPlayerDetails_Item {
  loginId: LoginId;
  playerId: PlayerId;
  userId: UserId | undefined;
  password: string | undefined;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  idNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  displayName: string | undefined;
  stickers: number;
  lastlogin: string | undefined;
  teamName: string | undefined;
  schoolName: string | undefined;
  schoolId: SchoolId;
  className: string | undefined;
  year: string | undefined;
  grade: number;
  teacherName: string | undefined;
}

export interface Database_Procs_GetPlayerFamily_Item {
  primaryUserId: string | undefined;
  primaryPassword: string | undefined;
  primaryPlayerId: number;
  primaryStickers: number;
  familyUserId: string | undefined;
  familyPassword: string | undefined;
  familyLoginId: number;
  familyPlayerId: number;
  familyStickers: number;
  isFamily: boolean;
  isTeacher: boolean;
}

export interface Database_Procs_GetPlayerHubInfo_Item {
  stickers: number;
  stickers1D: number;
  stickers1W: number;
  stickers2W: number;
  currentStreak: number;
  bestStreak: number;
  winnerCircleCount: number;
}

export interface Database_Procs_GetPlayerMonth_Item {
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  stickers: number;
  contactName: string | undefined;
  teamName: string | undefined;
  className: string | undefined;
  grade: number;
  schoolName: string | undefined;
}

export interface Database_Procs_GetPlayerQuest_Item {
  id: number;
  categoryName: string | undefined;
  slug: string | undefined;
  questName: string | undefined;
  description: string | undefined;
  stickerReward: number;
  difficultyLevel: number;
  maxCompletions: number;
  questType: string | undefined;
  tag: string | undefined;
  startDate: Date;
  completionDate: Date;
  status: string | undefined;
  currentProgress: number;
  timesCompleted: number;
  badgeName: string | undefined;
  badgeDescription: string | undefined;
  awardedDate: Date;
}

export interface Database_Procs_GetPlayerStickersByPlayerId_Item {
  userId: UserId | undefined;
  stickers: number;
  badgeIcon: number;
  badgeBackground: number;
  isFamily: number;
  isTeacher: number;
  grade: number;
}

export interface Database_Procs_GetPlayerWeek_Item {
  userid: string | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  badgeIcon: number;
  badgeBackground: number;
  stickers: number;
  name: string | undefined;
  grade: number;
  teamName: string | undefined;
  className: string | undefined;
  schoolName: string | undefined;
}

export interface Database_Procs_GetRecentActivityByTeam_Item {
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  gameName: string | undefined;
  stickersAwarded: number;
  created: Date;
  slug: string | undefined;
  descriptionFull: string | undefined;
  moduleAreaName: string | undefined;
}

export interface Database_Procs_GetSchoolContacts_Item {
  id: number;
  bpCode: string | undefined;
  name: string | undefined;
  position: string | undefined;
  address: string | undefined;
  phone1: string | undefined;
  phone2: string | undefined;
  cell: string | undefined;
  fax: string | undefined;
  eMail: string | undefined;
  pager: string | undefined;
  notes1: string | undefined;
  notes2: string | undefined;
  birthday: Date;
  gender: string | undefined;
  title: string | undefined;
  personnelPIN: string | undefined;
  b1CntctCode: number;
  dontEmailMarketing: boolean;
  dontEmailTransactions: boolean;
  emailValidated: boolean;
  vendorId: string | undefined;
  vendorType: number;
  created: Date;
  lastModified: Date;
  refCountTeam: number;
  refCountSchool: number;
  isAdminOfSpecifiedSchool: boolean;
  displayName: string | undefined;
  idNumber: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
  loginId: LoginId;
  loginType: number;
  entityId: number;
  entityLevel: number;
  latestLogin: Date;
}

export interface Database_Procs_GetSchoolHistory_Item {
  historicPoint0: number;
  historicPoint1: number;
  historicPoint2: number;
  historicPoint3: number;
  historicPoint4: number;
  historicPoint5: number;
  historicPoint6: number;
}

export interface Database_Procs_GetSchoolInfoWithContact_Item {
  id: number;
  districtId: number;
  loginId: LoginId;
  name: string | undefined;
  address1: string | undefined;
  address2: string | undefined;
  city: string | undefined;
  county: string | undefined;
  state: string | undefined;
  zip: string | undefined;
  country: string | undefined;
  phone: string | undefined;
  fax: string | undefined;
  poNumber: string | undefined;
  bpCode: string | undefined;
  emailSent: Date;
  emailPrincipalInfo: boolean;
  slpCode: number;
  pid: string | undefined;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers4D: number;
  stickers5D: number;
  stickers6D: number;
  stickers7D: number;
  stickers1W: number;
  stickers2W: number;
  stickers3W: number;
  stickers4W: number;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
  excludeRankings: boolean;
  winnerCircleCount: number;
  vendorId: string | undefined;
  vendorType: number;
  rowGUID: string;
  created: Date;
  lastModified: Date;
  dontEmailMarketing: boolean;
  dontEmailTransactions: boolean;
  districtName: string | undefined;
  mathCoordName: string | undefined;
  mathCoordEmail: string | undefined;
  position: string | undefined;
  contactId: number;
  userId: UserId | undefined;
  password: string | undefined;
  principalName: string | undefined;
  principalEmail: string | undefined;
}

export interface Database_Procs_GetSchoolPlayers_Item {
  loginId: LoginId;
  userId: UserId | undefined;
  badgeIcon: number;
  badgeBackground: number;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  playerId: PlayerId;
  teamId: TeamId;
  teamName: string | undefined;
  className: string | undefined;
  teamLoginId: number;
  schoolId: SchoolId;
  year: string | undefined;
  grade: number;
  stickers: number;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers1W: number;
  stickers2W: number;
  stickers1M: number;
  activity: number;
  activity1W: number;
  activity2W: number;
}

export interface Database_Procs_GetSchoolStats_Item {
  year: string | undefined;
  schoolName: string | undefined;
  schoolId: SchoolId;
  stickers: number;
  teamCount: number;
  stickersPerTeams: number;
  stickersPerStudent: number;
  activatedLicenses: number;
  numberOfLicenses: number;
}

export interface Database_Procs_GetSkillSetHistory_Item {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  loginId: LoginId;
  teamId: TeamId;
  skillSet: number;
  game: number;
  round: number;
  score: number;
  bestScore: number;
  currentTime: number;
  initialTime: number;
  bestTime: number;
  cumulativeTime: number;
  created: Date;
  completed: Date;
  totalCompetions: number;
}

export interface Database_Procs_GetTeamHistory_Item {
  historicPoint0: number;
  historicPoint1: number;
  historicPoint2: number;
  historicPoint3: number;
  historicPoint4: number;
  historicPoint5: number;
  historicPoint6: number;
}

export interface Database_Procs_GetTeamInfo_Item {
  schoolName: string | undefined;
  id: number;
  schoolId: SchoolId;
  loginId: LoginId;
  focusGroupId: number;
  name: string | undefined;
  year: string | undefined;
  grade: number;
  className: string | undefined;
  sectionNumber: string | undefined;
  state: string | undefined;
  programBegins: Date;
  programEnds: Date;
  studentsPlaying: number;
  winnerCircleCount: number;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers4D: number;
  stickers5D: number;
  stickers6D: number;
  stickers7D: number;
  stickers1W: number;
  stickers2W: number;
  stickers3W: number;
  stickers4W: number;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
  poNumber: string | undefined;
  orderNumber: number;
  docEntry: number;
  excludeRankings: boolean;
  isImport: boolean;
  isPlaceHolder: boolean;
  vendorId: string | undefined;
  vendorType: number;
  status: string | undefined;
  rowGUID: string;
  created: Date;
  lastModified: Date;
  displayName: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
}

export interface Database_Procs_GetTeamMonth_Item {
  teamName: string | undefined;
  className: string | undefined;
  schoolName: string | undefined;
  stickers: number;
  name: string | undefined;
  grade: number;
}

export interface Database_Procs_GetTeamPotD_Item {
  userId: UserId | undefined;
  playerId: PlayerId;
  loginId: LoginId;
  displayName: string | undefined;
  badgeIcon: number;
  badgeBg: number;
  stickers: number;
  stickerDelta: number;
  notificationSent: number;
}

export interface Database_Procs_GetTeamWeek_Item {
  teamName: string | undefined;
  className: string | undefined;
  schoolName: string | undefined;
  stickers: number;
  stickers1W: number;
  name: string | undefined;
  grade: number;
  studentsPlaying: number;
}

export interface Database_Procs_GetTopPlayers_Item {
  teamId: TeamId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  name: string | undefined;
  grade: number;
  badgeIcon: number;
  badgeBackground: number;
  stickers: number;
  stickers1D: number;
}

export interface Database_Procs_GetTopTeams_Item {
  teamName: string | undefined;
  className: string | undefined;
  stickers: number;
  studentsPlaying: number;
}

export interface Database_Procs_GetWDYKTemplateHeadings_Item {
  id: number;
  testTemplateId: number;
  wordProblemId: number;
  questionNumber: number;
  skillLevel: number;
  category: number;
  problemNumber: number;
  heading: string | undefined;
  oldCategory: number;
}

export interface Database_Procs_GetWDYKTestAssessmentByBatch_Item {
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  playerId: PlayerId;
  stickers: number;
  _1: number;
  _2: number;
  _3: number;
  _4: number;
  _5: number;
  _6: number;
  _7: number;
  _8: number;
  _9: number;
  _10: number;
  givenChoice1: number;
  givenChoice2: number;
  givenChoice3: number;
  givenChoice4: number;
  givenChoice5: number;
  givenChoice6: number;
  givenChoice7: number;
  givenChoice8: number;
  givenChoice9: number;
  givenChoice10: number;
}

export interface Database_Procs_GetWDYKTest_Item {
  id: number;
  senderLoginId: LoginId;
  playerId: PlayerId;
  testBatchId: number;
  testTemplateId: number;
  timeAllowed: number;
  secureLink: string | undefined;
  dateRequested: Date;
  dateStarted: Date;
  dateCompleted: Date;
  currentQuestionNumber: number;
  cumulativeTime: number;
  permutationId: number;
  grade: number;
  topic: string | undefined;
  numberOfQuestions: number;
}

export interface Database_Procs_GymPercentAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  stickers: number;
  students: number;
  gym_k2_add: number;
  gym_k2_sub: number;
  gym_k2_mul: number;
  gym_k2_div: number;
  gym_num_add: number;
  gym_num_sub: number;
  gym_num_mul: number;
  gym_num_div: number;
  gym_frc_add: number;
  gym_frc_sub: number;
  gym_frc_mul: number;
  gym_frc_div: number;
  gym_dec_add: number;
  gym_dec_sub: number;
  gym_dec_mul: number;
  gym_dec_div: number;
  gym_int_add: number;
  gym_int_sub: number;
  gym_int_mul: number;
  gym_int_div: number;
}

export interface Database_Procs_JTFAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  activeStudents: number;
  numberPretest: number;
  numberPosttest: number;
  numberProficientPretest: number;
  numberFluentPretest: number;
  numberProficient: number;
  numberFluent: number;
}

export interface Database_Procs_JTFByEntityAllOps_Item {
  moduleId: number;
  totalstudentsplaying: number;
  totalnumberpre: number;
  totalnumberpost: number;
  tieR1NUMBERPRE: number;
  tieR1NUMBERPCTPRE: number;
  tieR2NUMBERPRE: number;
  tieR2NUMBERPCTPRE: number;
  tieR3NUMBERPRE: number;
  tieR3NUMBERPCTPRE: number;
  tieR4NUMBERPRE: number;
  tieR4NUMBERPCTPRE: number;
  tieR1NUMBERPOST: number;
  tieR1NUMBERPCTPOST: number;
  tieR2NUMBERPOST: number;
  tieR2NUMBERPCTPOST: number;
  tieR3NUMBERPOST: number;
  tieR3NUMBERPCTPOST: number;
  tieR4NUMBERPOST: number;
  tieR4NUMBERPCTPOST: number;
}

export interface Database_Procs_JTFByEntity_Item {
  tier: string | undefined;
  tierid: number;
  totalstudentsplaying: number;
  totalstudentsbothprepost: number;
  numberpretest: number;
  percentpretest: number;
  numberposttest: number;
  percentposttest: number;
}

export interface Database_Procs_KASPercentAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  stickers: number;
  students: number;
  ks_1_1: number;
  ks_1_2: number;
  ks_1_3: number;
  ks_1_4: number;
  ks_2_1: number;
  ks_2_2: number;
  ks_2_3: number;
  ks_2_4: number;
  ks_3_1: number;
  ks_3_2: number;
  ks_3_3: number;
  ks_3_4: number;
  ks_3_5: number;
  ks_3_6: number;
  ks_3_7: number;
  ks_3_8: number;
  ks_3_9: number;
  ks_4_1: number;
  ks_4_2: number;
  ks_4_3: number;
  ks_4_4: number;
  ks_4_5: number;
  ks_4_6: number;
  ks_4_7: number;
  ks_4_8: number;
  ks_4_9: number;
  ks_5_1: number;
  ks_5_2: number;
  ks_5_3: number;
  ks_5_4: number;
  ks_5_5: number;
  ks_5_6: number;
  ks_5_7: number;
  ks_5_8: number;
  ks_5_9: number;
  ks_6_1: number;
  ks_6_2: number;
  ks_6_3: number;
  ks_6_4: number;
  ks_6_5: number;
  ks_6_6: number;
  ks_6_7: number;
  ks_6_8: number;
  ks_6_9: number;
  ks_7_1: number;
  ks_7_2: number;
  ks_7_3: number;
  ks_7_4: number;
  ks_7_5: number;
  ks_7_6: number;
  ks_7_7: number;
  ks_7_8: number;
  ks_7_9: number;
  ks_8_1: number;
  ks_8_2: number;
  ks_8_3: number;
  ks_8_4: number;
  ks_8_5: number;
  ks_8_6: number;
  ks_8_7: number;
  ks_8_8: number;
  ks_8_9: number;
}

export interface Database_Procs_LoginCheckBasic_Item {
  id: number;
  userId: UserId | undefined;
  password: string | undefined;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  loginType: number;
}

export interface Database_Procs_PlayerJTF_Item {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  loginId: LoginId;
  teamId: TeamId;
  played: number;
  add_quad_pre: number;
  sub_quad_pre: number;
  mul_quad_pre: number;
  div_quad_pre: number;
  add_percent_pre: number;
  sub_percent_pre: number;
  mul_percent_pre: number;
  div_percent_pre: number;
  add_pre_date: Date;
  sub_pre_date: Date;
  mul_pre_date: Date;
  div_pre_date: Date;
  add_quad_post: number;
  sub_quad_post: number;
  mul_quad_post: number;
  div_quad_post: number;
  add_post_date: Date;
  sub_post_date: Date;
  mul_post_date: Date;
  div_post_date: Date;
  add_percent_post: number;
  sub_percent_post: number;
  mul_percent_post: number;
  div_percent_post: number;
  add_percent_best: number;
  sub_percent_best: number;
  mul_percent_best: number;
  div_percent_best: number;
}

export interface Database_Procs_PlayerKnowAndShow_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  ks_1_1: number;
  ks_1_2: number;
  ks_1_3: number;
  ks_1_4: number;
  ks_2_1: number;
  ks_2_2: number;
  ks_2_3: number;
  ks_2_4: number;
  ks_3_1: number;
  ks_3_2: number;
  ks_3_3: number;
  ks_3_4: number;
  ks_3_5: number;
  ks_3_6: number;
  ks_3_7: number;
  ks_3_8: number;
  ks_3_9: number;
  ks_4_1: number;
  ks_4_2: number;
  ks_4_3: number;
  ks_4_4: number;
  ks_4_5: number;
  ks_4_6: number;
  ks_4_7: number;
  ks_4_8: number;
  ks_4_9: number;
  ks_5_1: number;
  ks_5_2: number;
  ks_5_3: number;
  ks_5_4: number;
  ks_5_5: number;
  ks_5_6: number;
  ks_5_7: number;
  ks_5_8: number;
  ks_5_9: number;
  ks_6_1: number;
  ks_6_2: number;
  ks_6_3: number;
  ks_6_4: number;
  ks_6_5: number;
  ks_6_6: number;
  ks_6_7: number;
  ks_6_8: number;
  ks_6_9: number;
  ks_7_1: number;
  ks_7_2: number;
  ks_7_3: number;
  ks_7_4: number;
  ks_7_5: number;
  ks_7_6: number;
  ks_7_7: number;
  ks_7_8: number;
  ks_7_9: number;
  ks_8_1: number;
  ks_8_2: number;
  ks_8_3: number;
  ks_8_4: number;
  ks_8_5: number;
  ks_8_6: number;
  ks_8_7: number;
  ks_8_8: number;
  ks_8_9: number;
}

export interface Database_Procs_PlayerSkillSet_Item {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  loginId: LoginId;
  ss_1_1: number;
  ss_1_2: number;
  ss_1_3: number;
  ss_2_1: number;
  ss_2_2: number;
  ss_2_3: number;
  ss_3_1: number;
  ss_3_2: number;
  ss_3_3: number;
  ss_4_1: number;
  ss_4_2: number;
  ss_4_3: number;
  ss_5_1: number;
  ss_5_2: number;
  ss_5_3: number;
  ss_6_1: number;
  ss_6_2: number;
  ss_6_3: number;
  ss_7_1: number;
  ss_7_2: number;
  ss_7_3: number;
  ss_8_1: number;
  ss_8_2: number;
  ss_8_3: number;
}

export interface Database_Procs_PlayerVIF_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  vif_add: number;
  vif_sub: number;
  vif_mul: number;
  vif_div: number;
  vif_add_rules: number;
  vif_sub_rules: number;
  vif_mul_rules: number;
  vif_div_rules: number;
  vif_add_rules_1: number;
  vif_sub_rules_1: number;
  vif_mul_rules_1: number;
  vif_div_rules_1: number;
  vif_add_rules_2: number;
  vif_sub_rules_2: number;
  vif_mul_rules_2: number;
  vif_div_rules_2: number;
  vif_add_redo: number;
  vif_sub_redo: number;
  vif_add_redo_1: number;
  vif_sub_redo_1: number;
  vif_add_redo_2: number;
  vif_sub_redo_2: number;
  vif_add_rules_dd: number;
  vif_sub_rules_dd: number;
  vif_mul_rules_dd: number;
  vif_div_rules_dd: number;
  vif_add_rules_dd_1: number;
  vif_sub_rules_dd_1: number;
  vif_mul_rules_dd_1: number;
  vif_div_rules_dd_1: number;
  vif_add_1: number;
  vif_sub_1: number;
  vif_mul_rules_dd_2: number;
  vif_div_rules_dd_2: number;
  vif_sub_2: number;
  vif_mul_rules_dd_3: number;
  vif_div_rules_dd_3: number;
  vif_mul_1: number;
  vif_div_1: number;
  vif_mul_rules_dd_4: number;
  vif_div_rules_dd_4: number;
  vif_mul_rules_dd_5: number;
  vif_div_rules_dd_5: number;
  vif_add_time: number;
  vif_sub_time: number;
  vif_mul_time: number;
  vif_div_time: number;
  vif_add_rules_time: number;
  vif_sub_rules_time: number;
  vif_mul_rules_time: number;
  vif_div_rules_time: number;
  vif_add_rules_1_time: number;
  vif_sub_rules_1_time: number;
  vif_mul_rules_1_time: number;
  vif_div_rules_1_time: number;
  vif_add_rules_2_time: number;
  vif_sub_rules_2_time: number;
  vif_mul_rules_2_time: number;
  vif_div_rules_2_time: number;
  vif_add_redo_time: number;
  vif_sub_redo_time: number;
  vif_add_redo_1_time: number;
  vif_sub_redo_1_time: number;
  vif_add_redo_2_time: number;
  vif_sub_redo_2_time: number;
  vif_add_rules_dd_time: number;
  vif_sub_rules_dd_time: number;
  vif_mul_rules_dd_time: number;
  vif_div_rules_dd_time: number;
  vif_add_rules_dd_1_time: number;
  vif_sub_rules_dd_1_time: number;
  vif_mul_rules_dd_1_time: number;
  vif_div_rules_dd_1_time: number;
  vif_add_1_time: number;
  vif_sub_1_time: number;
  vif_mul_rules_dd_2_time: number;
  vif_div_rules_dd_2_time: number;
  vif_sub_2_time: number;
  vif_mul_rules_dd_3_time: number;
  vif_div_rules_dd_3_time: number;
  vif_mul_1_time: number;
  vif_div_1_time: number;
  vif_mul_rules_dd_4_time: number;
  vif_div_rules_dd_4_time: number;
  vif_mul_rules_dd_5_time: number;
  vif_div_rules_dd_5_time: number;
  vif_add_date: Date;
  vif_sub_date: Date;
  vif_mul_date: Date;
  vif_div_date: Date;
  vif_add_rules_date: Date;
  vif_sub_rules_date: Date;
  vif_mul_rules_date: Date;
  vif_div_rules_date: Date;
  vif_add_rules_1_date: Date;
  vif_sub_rules_1_date: Date;
  vif_mul_rules_1_date: Date;
  vif_div_rules_1_date: Date;
  vif_add_rules_2_date: Date;
  vif_sub_rules_2_date: Date;
  vif_mul_rules_2_date: Date;
  vif_div_rules_2_date: Date;
  vif_add_redo_date: Date;
  vif_sub_redo_date: Date;
  vif_add_redo_1_date: Date;
  vif_sub_redo_1_date: Date;
  vif_add_redo_2_date: Date;
  vif_sub_redo_2_date: Date;
  vif_add_rules_dd_date: Date;
  vif_sub_rules_dd_date: Date;
  vif_mul_rules_dd_date: Date;
  vif_div_rules_dd_date: Date;
  vif_add_rules_dd_1_date: Date;
  vif_sub_rules_dd_1_date: Date;
  vif_mul_rules_dd_1_date: Date;
  vif_div_rules_dd_1_date: Date;
  vif_add_1_date: Date;
  vif_sub_1_date: Date;
  vif_mul_rules_dd_2_date: Date;
  vif_div_rules_dd_2_date: Date;
  vif_sub_2_date: Date;
  vif_mul_rules_dd_3_date: Date;
  vif_div_rules_dd_3_date: Date;
  vif_mul_rules_dd_4_date: Date;
  vif_div_rules_dd_4_date: Date;
  vif_mul_rules_dd_5_date: Date;
  vif_div_rules_dd_5_date: Date;
  vif_mul_1_date: Date;
  vif_div_1_date: Date;
}

export interface Database_Procs_PrintMembershipCards_Item {
  id: number;
  schoolName: string | undefined;
  teamName: string | undefined;
  className: string | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
  altLogin: string | undefined;
  qrCode: string | undefined;
}

export interface Database_Procs_RankingsPlayerInternational_Item {
  state: string | undefined;
  districtName: string | undefined;
  schoolName: string | undefined;
  teamName: string | undefined;
  player: string | undefined;
  stickers: number;
  topRanking: number;
}

export interface Database_Procs_RankingsPlayerLocal_Item {
  districtName: string | undefined;
  schoolName: string | undefined;
  player: string | undefined;
  displayName: string | undefined;
  teamName: string | undefined;
  stickers: number;
  topRanking: number;
}

export interface Database_Procs_RankingsPlayerNation_Item {
  topRanking: number;
  player: string | undefined;
  stickers: number;
  districtName: string | undefined;
  schoolName: string | undefined;
  teamName: string | undefined;
  state: string | undefined;
  grade: number;
  year: string | undefined;
}

export interface Database_Procs_RankingsPlayerState_Item {
  districtName: string | undefined;
  schoolName: string | undefined;
  teamName: string | undefined;
  player: string | undefined;
  stickers: number;
  topRanking: number;
}

export interface Database_Procs_RankingsSchoolInternational_Item {
  schoolId: SchoolId;
  schoolName: string | undefined;
  districtName: string | undefined;
  state: string | undefined;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  topRanking: number;
}

export interface Database_Procs_RankingsSchoolLocal_Item {
  schoolId: SchoolId;
  schoolName: string | undefined;
  districtName: string | undefined;
  state: string | undefined;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  topRanking: number;
}

export interface Database_Procs_RankingsSchoolNation_Item {
  topRanking: number;
  schoolName: string | undefined;
  districtName: string | undefined;
  state: string | undefined;
  stickersPerStudent: number;
  stickers: number;
  studentsPlaying: number;
  schoolId: SchoolId;
}

export interface Database_Procs_RankingsSchoolState_Item {
  schoolId: SchoolId;
  schoolName: string | undefined;
  districtName: string | undefined;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  topRanking: number;
}

export interface Database_Procs_RankingsTeamInternational_Item {
  teamName: string | undefined;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  schoolName: string | undefined;
  districtName: string | undefined;
  state: string | undefined;
  topRanking: number;
}

export interface Database_Procs_RankingsTeamLocal_Item {
  state: string | undefined;
  districtName: string | undefined;
  schoolName: string | undefined;
  teamName: string | undefined;
  tlName: string | undefined;
  grade: number;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  topRanking: number;
}

export interface Database_Procs_RankingsTeamNation_Item {
  topRanking: number;
  stickersPerStudent: number;
  studentsPlaying: number;
  teamName: string | undefined;
  schoolName: string | undefined;
  districtName: string | undefined;
  state: string | undefined;
  stickers: number;
}

export interface Database_Procs_RankingsTeamState_Item {
  state: string | undefined;
  districtName: string | undefined;
  schoolName: string | undefined;
  teamName: string | undefined;
  stickers: number;
  studentsPlaying: number;
  stickersPerStudent: number;
  topRanking: number;
}

export interface Database_Procs_SchoolPlayersPotD_Item {
  userId: UserId | undefined;
  stickers: number;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  name: string | undefined;
  grade: number;
}

export interface Database_Procs_SchoolSummaryByTeam_Item {
  teamId: TeamId;
  teamName: string | undefined;
  teamClassName: string | undefined;
  teamGrade: number;
  loginId: LoginId;
  students: number;
  teamProgramBegins: Date;
  teamProgramEnds: Date;
  stickers: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  userId: UserId | undefined;
  userPassword: string | undefined;
  educatorUserId: string | undefined;
  educatorUserPassword: string | undefined;
  stickersPerStudent: number;
  timeOnTask: number;
  problemsSolved: number;
  mathematicians: number;
  champions: number;
  grandChampions: number;
  percentMathematicians: number;
  percentChampions: number;
  percentGrandChampions: number;
}

export interface Database_Procs_SkillSetPercentAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  stickers: number;
  students: number;
  ss_1_1: number;
  ss_1_2: number;
  ss_1_3: number;
  ss_2_1: number;
  ss_2_2: number;
  ss_2_3: number;
  ss_3_1: number;
  ss_3_2: number;
  ss_3_3: number;
  ss_4_1: number;
  ss_4_2: number;
  ss_4_3: number;
  ss_5_1: number;
  ss_5_2: number;
  ss_5_3: number;
  ss_6_1: number;
  ss_6_2: number;
  ss_6_3: number;
  ss_7_1: number;
  ss_7_2: number;
  ss_7_3: number;
  ss_8_1: number;
  ss_8_2: number;
  ss_8_3: number;
}

export interface Database_Procs_TeamActivity_Item {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  isPrimaryTeam: boolean;
  loginId: LoginId;
  timeOnTask: number;
  stickers1D: number;
  stickers2D: number;
  stickers3D: number;
  stickers4D: number;
  stickers5D: number;
  stickers6D: number;
  stickers7D: number;
  stickers1W: number;
  stickers2W: number;
  stickers3W: number;
  stickers4W: number;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
}

export interface Database_Procs_TeamBonusGames_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  isPrimaryTeam: boolean;
  ten_wheels: number;
  first_in_tens_add: number;
  first_in_tens_sub: number;
  mol: number;
  shape_shuffle: number;
  deep_seaquence: number;
  grand_slam_add_sub: number;
  first_to_twenty_add: number;
  first_to_twenty_sub: number;
  speed_shuffle: number;
  touchdown_100_add: number;
  touchdown_100_sub: number;
  factor_wheels: number;
  grand_slam_mul_div: number;
  skip_game: number;
  decimals_mol: number;
  xyz_shuffle: number;
  estimation: number;
  _24_wheels: number;
  monus_path: number;
  the_hex_factor: number;
  fractions_mol: number;
  pundis_puzzle: number;
  rps: number;
  equivalents: number;
  fraction_wheels: number;
  pattern_puzzle: number;
  monujis_path: number;
  pattern_power: number;
  grand_slam_integers: number;
  xtreme_algebra: number;
  algebra_mol: number;
  rps_master: number;
  into_the_vortex: number;
  grand_slam_frc_add_sub: number;
  grand_slam_frc_mul_div: number;
  grand_slam_frc_all: number;
  grand_slam_dec_add_sub: number;
  grand_slam_dec_mul_div: number;
  grand_slam_dec_all: number;
  equal_length: number;
  equal_length_1: number;
  equal_length_2: number;
  time_more_or_less: number;
  equal_time: number;
  passing_time: number;
  equal_pay: number;
  equal_pay_india: number;
  making_change: number;
  making_change_india: number;
  equal_weight: number;
  equal_weight_1: number;
  equal_weight_2: number;
  area_perimeter_square: number;
  area_perimeter_square_1: number;
  area_perimeter_square_2: number;
  area_perimeter_circle: number;
  area_perimeter_circle_1: number;
  area_perimeter_circle_2: number;
  area_perimeter_rectangle: number;
  area_perimeter_rectangle_1: number;
  area_perimeter_rectangle_2: number;
  area_perimeter_triangle: number;
  area_perimeter_triangle_1: number;
  area_perimeter_triangle_2: number;
  k2_rps: number;
  _3_to_9_add: number;
  _3_to_9_sub: number;
  k2_mol: number;
  k2_skip_game: number;
  k2_pundis_puzzle: number;
  see_3: number;
  rps_newb_ct: number;
  rps_ct: number;
  rps_master_ct: number;
  k2_how_many: number;
  pundis_puzzle_ct: number;
  misfits_newb: number;
  misfits: number;
  misfits_master: number;
  zero_sum: number;
  k2_five_at_a_time: number;
  misfits_num: number;
  misfits_frc: number;
  misfits_dec: number;
  grand_slam_alg: number;
  estimation_dec: number;
  k2_misfits: number;
  k2_misfits_num: number;
  misfits_37: number;
  misfits_37_num: number;
  jtf_k2_add: number;
  jtf_k2_sub: number;
  jtf_k2_mul: number;
  jtf_k2_div: number;
  k2_triplets: number;
  _3_moves_to_0: number;
  _3_moves_to_0_quantum: number;
  k2_undo: number;
  pk_three_at_a_time: number;
  k2_four_at_a_time: number;
  pk_how_many: number;
  k2_before_and_after: number;
  pk_before_and_after: number;
  pk_mol: number;
  pk_missing_icons: number;
  k2_missing_icons_ct: number;
  k2_pundis_puzzle_ct: number;
  k2_rps_ct: number;
  k2_misfits_num_ct: number;
  zero_sum_newb: number;
  k2_monus_path_ct: number;
  undo_fractions: number;
  factor_wheels_ct: number;
  k2_jennies_jewels: number;
  jennies_jewels: number;
  k2_what_belongs_ct: number;
  link_n_lock_as: number;
  link_n_lock_md: number;
  link_n_lock_frc: number;
  link_n_lock_mosaic: number;
  link_n_lock_jewels: number;
  gems_to_zero: number;
  jeweled_tiles: number;
  equivalent_fraction_tiles: number;
  algebra_tiles: number;
  decimal_tiles: number;
  vif_tiles: number;
  exponent_tiles: number;
  integer_tiles: number;
  order_of_operations_tiles: number;
  fraction_tiles: number;
  early_algebra_tiles: number;
  pk_memory_tiles: number;
  elementary_algebra_tiles: number;
  geometry_tiles: number;
  money_tiles: number;
  quantum_algebra: number;
  dii_fractions: number;
  abc: number;
  letter_memory: number;
  matching_letters: number;
  alphabet: number;
  high_fq_words: number;
  rhyme_time: number;
  misfits_spelling: number;
  missing_letters: number;
  verb_tenses: number;
  building_sentences: number;
  consonant_blends: number;
  math_words: number;
  cb_sounds: number;
  phonemes_alpha: number;
  phonemes_pi: number;
  sound_of_letters: number;
  change_one_letter: number;
  word_wheels: number;
  finding_words_4x4: number;
  ten_wheels_elite: number;
  write_a_sentence: number;
  number_circles: number;
  epic_circles: number;
}

export interface Database_Procs_TeamJTF_Item {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  loginId: LoginId;
  isPrimaryTeam: boolean;
  played: number;
  add_quad_pre: number;
  sub_quad_pre: number;
  mul_quad_pre: number;
  div_quad_pre: number;
  add_percent_pre: number;
  sub_percent_pre: number;
  mul_percent_pre: number;
  div_percent_pre: number;
  add_pre_date: Date;
  sub_pre_date: Date;
  mul_pre_date: Date;
  div_pre_date: Date;
  add_quad_post: number;
  sub_quad_post: number;
  mul_quad_post: number;
  div_quad_post: number;
  add_post_date: Date;
  sub_post_date: Date;
  mul_post_date: Date;
  div_post_date: Date;
  add_percent_post: number;
  sub_percent_post: number;
  mul_percent_post: number;
  div_percent_post: number;
  add_percent_best: number;
  sub_percent_best: number;
  mul_percent_best: number;
  div_percent_best: number;
}

export interface Database_Procs_TeamKnowAndShow_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  isPrimaryTeam: boolean;
  ks_1_1: number;
  ks_1_2: number;
  ks_1_3: number;
  ks_1_4: number;
  ks_2_1: number;
  ks_2_2: number;
  ks_2_3: number;
  ks_2_4: number;
  ks_3_1: number;
  ks_3_2: number;
  ks_3_3: number;
  ks_3_4: number;
  ks_3_5: number;
  ks_3_6: number;
  ks_3_7: number;
  ks_3_8: number;
  ks_3_9: number;
  ks_4_1: number;
  ks_4_2: number;
  ks_4_3: number;
  ks_4_4: number;
  ks_4_5: number;
  ks_4_6: number;
  ks_4_7: number;
  ks_4_8: number;
  ks_4_9: number;
  ks_5_1: number;
  ks_5_2: number;
  ks_5_3: number;
  ks_5_4: number;
  ks_5_5: number;
  ks_5_6: number;
  ks_5_7: number;
  ks_5_8: number;
  ks_5_9: number;
  ks_6_1: number;
  ks_6_2: number;
  ks_6_3: number;
  ks_6_4: number;
  ks_6_5: number;
  ks_6_6: number;
  ks_6_7: number;
  ks_6_8: number;
  ks_6_9: number;
  ks_7_1: number;
  ks_7_2: number;
  ks_7_3: number;
  ks_7_4: number;
  ks_7_5: number;
  ks_7_6: number;
  ks_7_7: number;
  ks_7_8: number;
  ks_7_9: number;
  ks_8_1: number;
  ks_8_2: number;
  ks_8_3: number;
  ks_8_4: number;
  ks_8_5: number;
  ks_8_6: number;
  ks_8_7: number;
  ks_8_8: number;
  ks_8_9: number;
}

export interface Database_Procs_TeamStickerSummary_Item {
  schoolId: SchoolId;
  schoolName: string | undefined;
  teamId: TeamId;
  teamName: string | undefined;
  className: string | undefined;
  year: string | undefined;
  grade: number;
  teamLeaderContact: string | undefined;
  teamLeaderEmail: string | undefined;
  mathCoord: string | undefined;
  mathCoordEmail: string | undefined;
  students: number;
  stickers: number;
  isImport: boolean;
  averageStickers: number;
  schoolStickers: number;
}

export interface Database_Procs_TeamTopPlayers_Item {
  userId: UserId | undefined;
  displayName: string | undefined;
  badgeIcon: number;
  badgeBackground: number;
  stickers: number;
  currentStickers: number;
}

export interface Database_Procs_TeamVIF_Item {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  isPrimaryTeam: boolean;
  vif_add: number;
  vif_sub: number;
  vif_mul: number;
  vif_div: number;
  vif_add_rules: number;
  vif_sub_rules: number;
  vif_mul_rules: number;
  vif_div_rules: number;
  vif_add_rules_1: number;
  vif_sub_rules_1: number;
  vif_mul_rules_1: number;
  vif_div_rules_1: number;
  vif_add_rules_2: number;
  vif_sub_rules_2: number;
  vif_mul_rules_2: number;
  vif_div_rules_2: number;
  vif_add_redo: number;
  vif_sub_redo: number;
  vif_add_redo_1: number;
  vif_sub_redo_1: number;
  vif_add_redo_2: number;
  vif_sub_redo_2: number;
  vif_add_rules_dd: number;
  vif_sub_rules_dd: number;
  vif_mul_rules_dd: number;
  vif_div_rules_dd: number;
  vif_add_rules_dd_1: number;
  vif_sub_rules_dd_1: number;
  vif_mul_rules_dd_1: number;
  vif_div_rules_dd_1: number;
  vif_add_1: number;
  vif_sub_1: number;
  vif_mul_rules_dd_2: number;
  vif_div_rules_dd_2: number;
  vif_sub_2: number;
  vif_mul_rules_dd_3: number;
  vif_div_rules_dd_3: number;
  vif_mul_1: number;
  vif_div_1: number;
  vif_mul_rules_dd_4: number;
  vif_div_rules_dd_4: number;
  vif_mul_rules_dd_5: number;
  vif_div_rules_dd_5: number;
  vif_add_time: number;
  vif_sub_time: number;
  vif_mul_time: number;
  vif_div_time: number;
  vif_add_rules_time: number;
  vif_sub_rules_time: number;
  vif_mul_rules_time: number;
  vif_div_rules_time: number;
  vif_add_rules_1_time: number;
  vif_sub_rules_1_time: number;
  vif_mul_rules_1_time: number;
  vif_div_rules_1_time: number;
  vif_add_rules_2_time: number;
  vif_sub_rules_2_time: number;
  vif_mul_rules_2_time: number;
  vif_div_rules_2_time: number;
  vif_add_redo_time: number;
  vif_sub_redo_time: number;
  vif_add_redo_1_time: number;
  vif_sub_redo_1_time: number;
  vif_add_redo_2_time: number;
  vif_sub_redo_2_time: number;
  vif_add_rules_dd_time: number;
  vif_sub_rules_dd_time: number;
  vif_mul_rules_dd_time: number;
  vif_div_rules_dd_time: number;
  vif_add_rules_dd_1_time: number;
  vif_sub_rules_dd_1_time: number;
  vif_mul_rules_dd_1_time: number;
  vif_div_rules_dd_1_time: number;
  vif_add_1_time: number;
  vif_sub_1_time: number;
  vif_mul_rules_dd_2_time: number;
  vif_div_rules_dd_2_time: number;
  vif_sub_2_time: number;
  vif_mul_rules_dd_3_time: number;
  vif_div_rules_dd_3_time: number;
  vif_mul_1_time: number;
  vif_div_1_time: number;
  vif_mul_rules_dd_4_time: number;
  vif_div_rules_dd_4_time: number;
  vif_mul_rules_dd_5_time: number;
  vif_div_rules_dd_5_time: number;
  vif_add_date: Date;
  vif_sub_date: Date;
  vif_mul_date: Date;
  vif_div_date: Date;
  vif_add_rules_date: Date;
  vif_sub_rules_date: Date;
  vif_mul_rules_date: Date;
  vif_div_rules_date: Date;
  vif_add_rules_1_date: Date;
  vif_sub_rules_1_date: Date;
  vif_mul_rules_1_date: Date;
  vif_div_rules_1_date: Date;
  vif_add_rules_2_date: Date;
  vif_sub_rules_2_date: Date;
  vif_mul_rules_2_date: Date;
  vif_div_rules_2_date: Date;
  vif_add_redo_date: Date;
  vif_sub_redo_date: Date;
  vif_add_redo_1_date: Date;
  vif_sub_redo_1_date: Date;
  vif_add_redo_2_date: Date;
  vif_sub_redo_2_date: Date;
  vif_add_rules_dd_date: Date;
  vif_sub_rules_dd_date: Date;
  vif_mul_rules_dd_date: Date;
  vif_div_rules_dd_date: Date;
  vif_add_rules_dd_1_date: Date;
  vif_sub_rules_dd_1_date: Date;
  vif_mul_rules_dd_1_date: Date;
  vif_div_rules_dd_1_date: Date;
  vif_add_1_date: Date;
  vif_sub_1_date: Date;
  vif_mul_rules_dd_2_date: Date;
  vif_div_rules_dd_2_date: Date;
  vif_sub_2_date: Date;
  vif_mul_rules_dd_3_date: Date;
  vif_div_rules_dd_3_date: Date;
  vif_mul_rules_dd_4_date: Date;
  vif_div_rules_dd_4_date: Date;
  vif_mul_rules_dd_5_date: Date;
  vif_div_rules_dd_5_date: Date;
  vif_mul_1_date: Date;
  vif_div_1_date: Date;
}

export interface Database_Procs_VIFAggregatedByLevel_Item {
  id: number;
  name: string | undefined;
  desc: string | undefined;
  grade: number;
  contactName: string | undefined;
  contactEmail: string | undefined;
  stickers: number;
  students: number;
  vif_add_completed_count: number;
  vif_add_rules_dd_completed_count: number;
  vif_add_1_completed_count: number;
  vif_sub_completed_count: number;
  vif_sub_rules_dd_completed_count: number;
  vif_sub_2_completed_count: number;
  vif_mul_rules_dd_2_completed_count: number;
  vif_mul_completed_count: number;
  vif_mul_1_completed_count: number;
  vif_div_completed_count: number;
  vif_div_rules_dd_completed_count: number;
  vif_div_1_completed_count: number;
}

export interface Database_Tables_Contact {
  id: number;
  bpCode: string | undefined;
  name: string | undefined;
  position: string | undefined;
  address: string | undefined;
  phone1: string | undefined;
  phone2: string | undefined;
  cell: string | undefined;
  fax: string | undefined;
  eMail: string | undefined;
  pager: string | undefined;
  notes1: string | undefined;
  notes2: string | undefined;
  birthday: Date | undefined;
  gender: string | undefined;
  title: string | undefined;
  personnelPIN: string | undefined;
  b1CntctCode: number | undefined;
  dontEmailMarketing: boolean;
  dontEmailTransactions: boolean;
  emailValidated: boolean;
  vendorId: string | undefined;
  vendorType: number;
  created: Date | undefined;
  lastModified: Date | undefined;
}

export interface Database_Tables_Login {
  id: number;
  contactId: number | undefined;
  siteId: number | undefined;
  type: number | undefined;
  displayName: string | undefined;
  userId: UserId | undefined;
  password: string | undefined;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  idNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  classificationGroup: string | undefined;
  active: boolean;
  leaderReg: string | undefined;
  vendorId: string | undefined;
  vendorType: number;
  overrideImport: boolean | undefined;
  created: Date | undefined;
  lastModified: Date | undefined;
  altCredsUniqueCheck: string | undefined;
  searchableText: string | undefined;
}

export interface Database_Tables_LoginGroup {
  id: number;
  schoolId: SchoolId;
  groupId: string | undefined;
  groupName: string | undefined;
}

export interface Database_Tables_ModuleTag {
  id: number;
  path: string | undefined;
  category: string | undefined;
  description: string | undefined;
  metaData: string | undefined;
  parentId: number | undefined;
  disabled: boolean;
}

export interface Database_Tables_Player {
  id: number;
  teamId: TeamId | undefined;
  loginId: LoginId;
  focusGroupId: number | undefined;
  masterLoginId: number | undefined;
  winnerCircleCount: number | undefined;
  currentStreak: number;
  bestStreak: number;
  stickers: number;
  stickers1D: number | undefined;
  stickers2D: number | undefined;
  stickers3D: number | undefined;
  stickers4D: number | undefined;
  stickers5D: number | undefined;
  stickers6D: number | undefined;
  stickers7D: number | undefined;
  stickers1W: number | undefined;
  stickers2W: number | undefined;
  stickers3W: number | undefined;
  stickers4W: number | undefined;
  stickers1M: number;
  stickers2M: number;
  stickers3M: number;
  stickers4M: number;
  stickers5M: number;
  isTeacher: boolean;
  isFamily: boolean;
  parentId: number;
  parentEntityLevel: number;
  grade: number;
  year: string | undefined;
  badgeIcon: number;
  badgeBackground: number;
  status: string | undefined;
  rowGUID: string;
  created: Date | undefined;
  lastModified: Date | undefined;
}

export interface Database_Tables_Team {
  id: number;
  schoolId: SchoolId;
  loginId: LoginId;
  focusGroupId: number | undefined;
  name: string | undefined;
  year: string | undefined;
  grade: number | undefined;
  className: string | undefined;
  sectionNumber: string | undefined;
  state: string | undefined;
  programBegins: Date | undefined;
  programEnds: Date | undefined;
  studentsPlaying: number | undefined;
  winnerCircleCount: number | undefined;
  stickers1D: number | undefined;
  stickers2D: number | undefined;
  stickers3D: number | undefined;
  stickers4D: number | undefined;
  stickers5D: number | undefined;
  stickers6D: number | undefined;
  stickers7D: number | undefined;
  stickers1W: number | undefined;
  stickers2W: number | undefined;
  stickers3W: number | undefined;
  stickers4W: number | undefined;
  stickers1M: number | undefined;
  stickers2M: number | undefined;
  stickers3M: number | undefined;
  stickers4M: number | undefined;
  stickers5M: number | undefined;
  poNumber: string | undefined;
  orderNumber: number | undefined;
  docEntry: number | undefined;
  excludeRankings: boolean;
  isImport: boolean | undefined;
  isPlaceHolder: boolean | undefined;
  vendorId: string | undefined;
  vendorType: number;
  status: string | undefined;
  rowGUID: string;
  created: Date | undefined;
  lastModified: Date | undefined;
}

export interface Database_Tables_WDYKTemplate {
  id: number;
  grade: number | undefined;
  topic: string | undefined;
  numberOfQuestions: number;
}

export interface Entities_Admin_AppFeedback_FeedbackDetail {
  id: number;
  loginId: LoginId;
  type: number;
  switchReason: Entities_Admin_AppFeedback_SwitchReason;
}

export interface Entities_Admin_AppFeedback_Response {
  responses: Entities_Admin_AppFeedback_FeedbackDetail[];
  totalCount: number;
}

export interface Entities_Admin_AppFeedback_SwitchReason {
  reasonTitle: string;
  reasonDescription: string;
}

export interface Entities_Admin_UserFeedback_Content {
  subject: string | undefined;
  message: string | undefined;
  images: Entities_Admin_UserFeedback_ImageDetail[] | undefined;
}

export interface Entities_Admin_UserFeedback_Details {
  id: number;
  loginId: LoginId;
  type: number;
  data: Entities_Admin_UserFeedback_Content;
}

export interface Entities_Admin_UserFeedback_ImageDetail {
  data: string;
  fileName: string;
}

export interface Entities_Admin_UserFeedback_Response {
  responses: Entities_Admin_UserFeedback_Details[];
  totalCount: number;
}

export interface Entities_Assessment_AlgebraGoalsByPlayer_Response {
  algebraGoalsMetricPlayers: Database_Procs_GetAlgebraGoalsMetricPlayers_Item[];
}

export interface Entities_Assessment_AlgebraGoalsMetric_Response {
  data: Database_Procs_GetAlgebraGoalsMetric_Item;
}

export interface Entities_Assessment_AllGames_AllGamesData {
  playerId: PlayerId;
  header: Database_Procs_GetPlayerDetails_Item;
  bonus: Database_Procs_GetBonusPercent_Item;
  gyms: Database_Procs_GymPercentAggregatedByLevel_Item;
  knowAndShow: Database_Procs_KASPercentAggregatedByLevel_Item;
  skillSet: Database_Procs_SkillSetPercentAggregatedByLevel_Item;
  skillSetDetails: Database_Procs_GetSkillSetHistory_Item[];
  jtf: Database_Procs_GetJTFPercent_Item;
  vif: Database_Procs_VIFAggregatedByLevel_Item;
}

export interface Entities_Assessment_AllGames_Response {
  allGames: Entities_Assessment_AllGames_AllGamesData[];
}

export interface Entities_Assessment_CertificateData_Response {
  dateCompleted: string;
  teacherName: string;
  studentName: string;
}

export interface Entities_Assessment_EntitySummaryByAggregateLevel_Response {
  entitySummaries: Database_Procs_EntitySummaryByAggregateLevel_Item[];
  contactName: string | undefined;
}

export interface Entities_Assessment_FluencyGames_FluencyGame {
  team: Entities_FluencyGamesResult_TeamResult;
  individualPlayer: Entities_FluencyGamesResult_PlayerResult;
}

export interface Entities_Assessment_FluencyGames_Response {
  fluencyGames: Entities_Assessment_FluencyGames_FluencyGame[];
}

export interface Entities_Assessment_GetWDYKTemplateHeadings_Response {
  headings: Database_Procs_GetWDYKTemplateHeadings_Item[];
}

export interface Entities_Assessment_GetWDYKTestAssessmentByBatch_Response {
  wdykTestAssessmentByBatches: Database_Procs_GetWDYKTestAssessmentByBatch_Item[];
}

export interface Entities_Assessment_GetWDYKTestBatchesByTeams_Response {
  wdykTestBatchesByTeams: Entities_Assessment_GetWDYKTestBatchesByTeams_WDYKTestBatchesByTeamInfo[];
}

export interface Entities_Assessment_GetWDYKTestBatchesByTeams_WDYKTestBatchesByTeamInfo {
  id: number;
  senderLoginId: LoginId;
  testTemplateId: number;
  created: string;
  grade: number;
  topic: string;
  numberOfQuestions: number;
}

export interface Entities_Assessment_GoalsAlgebraByTeam_Response {
  algebraGoalsMetricTeams: Database_Procs_GetAlgebraGoalsMetricTeams_Item[];
}

export interface Entities_Assessment_GoalsByTeam_Response {
  goalsIndexTeams: Database_Procs_GetGoalsIndexTeams_Item[];
}

export interface Entities_Assessment_GoalsIndexByPlayer_Response {
  goalsIndexByPlayers: Database_Procs_GetGoalsIndexPlayers_Item[];
}

export interface Entities_Assessment_GoalsIndex_Response {
  data: Database_Procs_GetGoalsIndex_Item;
}

export interface Entities_Assessment_GoalsInfoGyms_Response {
  id: number | undefined;
  level: EntityLevel;
  stickers: number | undefined;
  stickers1w: number | undefined;
  stickers2w: number | undefined;
  avgStickers: number | undefined;
  totalPlayers: number | undefined;
  winnerCircleCount: number | undefined;
  gyms: Gyms;
}

export interface Entities_Assessment_GoalsInfoKAS_Response {
  id: number;
  ks: Ks;
}

export interface Entities_Assessment_GoalsInfoSkillSet_Response {
  id: number | undefined;
  ss: { [key: string]: { [key: string]: number } };
}

export interface Entities_Assessment_GymsFactFluencyPerformanceAggregateByLevels_Response {
  data: Database_Procs_GymPercentAggregatedByLevel_Item[];
}

export interface Entities_Assessment_GymsFactFluencyTeam_GymFluencyDetail {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId;
  displayName: string;
  stickers: number;
  isPrimaryTeam: boolean;
  resultData: ResultData;
}

export interface Entities_Assessment_GymsFactFluencyTeam_Response {
  gymFluencyDetails: Entities_Assessment_GymsFactFluencyTeam_GymFluencyDetail[];
}

export interface Entities_Assessment_JustTheFactsAggregateByLevels_Response {
  data: Database_Procs_JTFAggregatedByLevel_Item[];
}

export interface Entities_Assessment_JustTheFactsSummary_Response {
  jtfGraphs: Database_Procs_JTFByEntity_Item[];
}

export interface Entities_Assessment_JustTheFactsTeam_Response {
  teamJTFs: Database_Procs_TeamJTF_Item[];
}

export interface Entities_Assessment_KnowAndShowPercentAggregateByLevels_Response {
  data: Database_Procs_KASPercentAggregatedByLevel_Item[];
}

export interface Entities_Assessment_KnowAndShowTeam_Response {
  teamKnowAndShows: Database_Procs_TeamKnowAndShow_Item[];
}

export interface Entities_Assessment_PlayerSummary_Response {
  id: number;
  loginId: LoginId;
  stickerCount: number;
  grade: number;
  year: string;
  teamId: TeamId;
  teamName: string;
  userId: UserId;
  userDisplayName: string;
  userFirstName: string;
  userLastName: string;
}

export interface Entities_Assessment_SchoolSummary_Response {
  schoolSummary: Database_Procs_SchoolSummaryByTeam_Item[];
}

export interface Entities_Assessment_SkillSetsPercentAggregateByLevel_Details {
  id: number | undefined;
  name: string;
  desc: string;
  grade: SpecialGradeLevel;
  contactName: string;
  contactEmail: string;
  stickers: number | undefined;
  students: number | undefined;
  ss: { [key: string]: number };
}

export interface Entities_Assessment_SkillSetsPercentAggregateByLevel_Response {
  data: Entities_Assessment_SkillSetsPercentAggregateByLevel_Details[];
}

export interface Entities_Assessment_SkillSetsTeam_Response {
  teamSkillSets: Entities_Assessment_SkillSetsTeam_TeamSkillSet[];
}

export interface Entities_Assessment_SkillSetsTeam_TeamSkillSet {
  playerId: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  stickers: number;
  loginId: LoginId;
  isPrimaryTeam: boolean;
  ss: { [key: string]: number };
}

export interface Entities_Assessment_StickerCountActivity_Response {
  activityAggregatedByLevel: Database_Procs_ActivityAggregatedByLevel_Item[];
}

export interface Entities_Assessment_TeamBonusGames_Response {
  teamBonusGames: Database_Procs_TeamBonusGames_Item[];
}

export interface Entities_Assessment_TeamStickerCountActivity_Response {
  teamStickerCountActivities: Database_Procs_TeamActivity_Item[];
}

export interface Entities_Assessment_TeamSummary_PlayerSummary {
  id: number;
  loginId: LoginId | undefined;
  stickers: number;
  grade: SpecialGradeLevel;
  year: string;
  teamId: TeamId;
  userId: UserId;
  displayName: string;
  userFirstName: string;
  userLastName: string;
  password: string;
  userIdNumber: string;
  estTimeOnTask: number;
  estProblemsSolved: number;
  lastActivity: string;
  group: string;
  isPrimaryTeam: boolean;
}

export interface Entities_Assessment_TeamSummary_Response {
  playerSummaries: Entities_Assessment_TeamSummary_PlayerSummary[];
}

export interface Entities_Assessment_VeryImportantFactsAggregatedByLevel_Response {
  vifAggregatedByLevels: Database_Procs_VIFAggregatedByLevel_Item[];
}

export interface Entities_Assessment_VeryImportantFactsTeam_Response {
  teamVeryImportantFacts: Database_Procs_TeamVIF_Item[];
}

export interface Entities_Authorization_Grant_Request {
  loginId: LoginId;
  entityId: number;
  entityLevel: EntityLevel;
}

export interface Entities_Authorization_Revoke_Request {
  loginId: LoginId;
  entityId: number;
  entityLevel: EntityLevel;
}

export interface Entities_Contact_Insert_Request {
  contact: Database_Tables_Contact;
}

export interface Entities_Contact_Insert_Response {
  contactId: number;
}

export interface Entities_Contact_TeamAssignmentChange_Request {
  contactId: number;
  teamId: TeamId;
  type: PermissionChangeType;
}

export interface Entities_Contact_UpdateEmail_Request {
  id: number;
  email: string;
}

export interface Entities_Contact_UpdateName_Request {
  id: number;
  name: string;
}

export interface Entities_Debug_Test_Response {
  grade: SpecialGradeLevel;
}

export interface Entities_Debug_Version_Response {
  build: string;
  commitHash: string;
  commitHashShort: string;
}

export interface Entities_FluencyGamesResult_PlayerResult {
  data: Database_Tables_Player;
  login: Database_Tables_Login;
  skillSetData: Database_Procs_PlayerSkillSet_Item;
  knowAndShowData: Database_Procs_PlayerKnowAndShow_Item;
  vifData: Database_Procs_PlayerVIF_Item;
  gymData: Entities_GymData[];
  jtfData: Database_Procs_PlayerJTF_Item[];
  gymModes: GymMode[];
  jtfModes: JtfMode[];
}

export interface Entities_FluencyGamesResult_TeamResult {
  stickerCount: number;
  stickerAverage: number;
  data: Database_Tables_Team;
  players: Entities_FluencyGamesResult_PlayerResult[];
  skillSetSummary: Database_Procs_SkillSetPercentAggregatedByLevel_Item;
  knowAndShowLevels: KnowAndShowLevel[];
  knowAndShowSummary: Database_Procs_KASPercentAggregatedByLevel_Item;
  vifSummary: Database_Procs_VIFAggregatedByLevel_Item;
  gymModes: GymMode[];
  gymSummary: Database_Procs_GymPercentAggregatedByLevel_Item;
  jtfModes: JtfMode[];
  jtfSummary: Entities_TeamJtfSummary[];
}

export interface Entities_FocusMode {
  gradeLevels: GradeLevel[];
}

export interface Entities_GymData {
  playerId: PlayerId;
  loginId: LoginId;
  userId: UserId;
  displayName: string;
  stickers: number;
  isPrimaryTeam: boolean;
  resultData: ResultData2;
}

export interface Entities_LoginGroup_Upsert_Request {
  schoolId: SchoolId;
  groupId: string;
  groupName: string;
}

export interface Entities_Login_ByToken_Request {
  loginToken: string;
}

export interface Entities_Login_ByToken_Response {
  message: string;
  token: string;
  status: boolean;
  userInfo: Entities_Login_ByUserIdAndPassword_UserInfo;
}

export interface Entities_Login_ByUserIdAndPassword_Request {
  userId: UserId;
  password: string;
}

export interface Entities_Login_ByUserIdAndPassword_Response {
  status: boolean;
  message: string;
  token: string;
  userInfo: Entities_Login_ByUserIdAndPassword_UserInfo;
}

export interface Entities_Login_ByUserIdAndPassword_UserInfo {
  loginType: LoginType;
  loginId: LoginId;
}

export interface Entities_Login_Consolidate_Request {
  oldLoginId: number;
  newLoginId: number;
}

export interface Entities_Login_CreateTeacher_Request {
  schoolId: SchoolId;
  fullName: string;
  email: string;
}

export interface Entities_Login_CreateTeacher_Response {
  loginId: LoginId;
  userId: UserId;
  password: string;
  contactId: number;
}

export interface Entities_Login_EncryptUserId_Response {
  encryptedUserId: string;
}

export interface Entities_Login_GetInfo_Request {
  userId: UserId;
  password: string;
}

export interface Entities_Login_GetInfo_Response {
  data: Database_Procs_LoginCheckBasic_Item;
}

export interface Entities_Login_IsCredentialInUseByAnyoneElse_Response {
  isCredentialInUse: boolean;
}

export interface Entities_Login_IsIdInUseByAnyoneElseInDistrict_Response {
  isIdInUse: boolean;
}

export interface Entities_Login_LoginMeta_Response {
  data: any;
}

export interface Entities_Login_Profile_Response {
  displayName: string | undefined;
  userId: UserId;
  password: string;
  email: string | undefined;
  contactName: string | undefined;
}

export interface Entities_Login_RefreshJwt_Response {
  jwt: string;
}

export interface Entities_Login_RegeneratePassword_Request {
  loginId: LoginId;
}

export interface Entities_Login_RegeneratePassword_Response {
  password: string;
}

export interface Entities_Login_RequestPasswordReset_Request {
  address: string;
}

export interface Entities_Login_RequestPasswordReset_Response {
  message: string;
}

export interface Entities_Login_StateInfo_Response {
  id: LoginId;
  loginType: LoginType;
  stateId: number;
  regionId: number;
  districtId: number;
  schoolId: SchoolId;
  teamId: TeamId;
  regionName: string;
  districtName: string;
  schoolName: string;
  year: string;
  entityId: number;
  gradeId: number;
  gradeName: string;
  displayName: string;
  userId: UserId;
  email: string;
  contactName: string;
  appFeedbackExists: boolean | undefined;
  entityLevel: EntityLevel;
  playerId: PlayerId;
  contactId: number | undefined;
  stateName: string | undefined;
}

export interface Entities_Login_UpdateDisplayName_Request {
  loginId: LoginId;
  displayName: string;
}

export interface Entities_Login_UpdateDisplayName_Response {
  message: string;
}

export interface Entities_Login_UpdateLoginGroup_Request {
  loginId: LoginId;
  group: string;
}

export interface Entities_Login_UpsertContact_Request {
  schoolId: SchoolId;
  loginId: LoginId;
  contactName: string;
  contactEmail: string;
}

export interface Entities_Login_UpsertContact_Response {
  contactId: number;
}

export interface Entities_Login_UpsertLoginMeta_Request {
  loginId: LoginId;
  metaKey: MetaKey;
  data: any;
}

export interface Entities_Modules_All_Response {
  modules: Entities_Modules_Module[];
}

export interface Entities_Modules_Assign_Player {
  id: number;
  name: string;
  userId: UserId;
  stickers: number;
}

export interface Entities_Modules_Assign_Response {
  players: Entities_Modules_Assign_Player[];
  wdykTemplates: Database_Tables_WDYKTemplate[];
}

export interface Entities_Modules_ById_Response {
  module: Entities_Modules_Module;
}

export interface Entities_Modules_CreateWdyk_Request {
  loginId: LoginId;
  templateId: number;
  timeAllowed: number;
  playerIds: number[];
}

export interface Entities_Modules_FimUrl {
  url: string;
  readonly hash: string;
  readonly urlPreview: string;
}

export interface Entities_Modules_Module {
  id: ModuleInfo;
  moduleArea: Entities_Modules_ModuleArea;
  slug: string;
  groupNumber: number;
  name: string;
  description: string;
  disabled: boolean;
  jsClass: string;
  helpText: string;
  subTitle: string;
  descriptionFull: string;
  ariaDescription: string;
  slugLink: Entities_Modules_SlugLink;
  hasBonus: boolean;
  isResponsive: boolean;
  gamesPerRound: number;
  allowProgressReset: boolean;
}

export interface Entities_Modules_ModuleArea {
  id: ModuleAreaId;
  slug: string;
  name: string;
}

export interface Entities_Modules_ModuleModuleTag {
  id: number;
  moduleId: number | undefined;
  moduleVariant: number;
  moduleTagId: number | undefined;
  locale: string | undefined;
  metaData: Entities_Modules_ModuleModuleTag_MetaDataClass;
}

export interface Entities_Modules_ModuleModuleTag_MetaDataClass {
  displayOrder: number | undefined;
  difficultyLevel: number | undefined;
}

export interface Entities_Modules_ModuleModuleTags_Response {
  items: Entities_Modules_ModuleModuleTag[];
}

export interface Entities_Modules_ModuleTags_Response {
  items: Database_Tables_ModuleTag[];
}

export interface Entities_Modules_SlugLink {
  slug: string;
  text: string;
  urlNew: Entities_Modules_FimUrl;
  urlClassic: Entities_Modules_FimUrl;
}

export interface Entities_Modules_SlugLinks_Response {
  items: Entities_Modules_SlugLink[];
}

export interface Entities_Modules_VifData_Response {
  vifData: VifData;
}

export interface Entities_Notification_Count_Response {
  count: number;
}

export interface Entities_Notification_Delete_Request {
  loginId: LoginId;
  notificationIds: number[];
}

export interface Entities_Notification_Get_NotificationData {
  senderDisplayName: string;
  senderUserId: string;
  replyHash: string;
  id: number;
  loginId: LoginId;
  senderLoginId: LoginId;
  moduleId: number | undefined;
  moduleVariant: number;
  unread: boolean | undefined;
  incentiveGiven: boolean;
  type: string;
  subject: string | undefined;
  message: string;
  created: Date;
  modified: Date | undefined;
  isDeleted: boolean;
  deleted: Date | undefined;
}

export interface Entities_Notification_Get_Response {
  allNotificationData: Entities_Notification_Get_NotificationData[];
  totalCount: number;
}

export interface Entities_Notification_InsertDirect_Request {
  entityId: number;
  receiverLoginId: number;
  receiverName: string | undefined;
  senderLoginId: LoginId;
  subject: string | undefined;
  message: string | undefined;
  hash: string | undefined;
  type: string;
}

export interface Entities_Notification_InsertTeam_Request {
  entityId: number;
  receiverLoginId: number;
  receiverName: string | undefined;
  senderLoginId: LoginId;
  subject: string | undefined;
  message: string | undefined;
  hash: string | undefined;
  type: string;
  playerIds: number[];
}

export interface Entities_Notification_InvalidateCache_Request {
  loginId: LoginId;
}

export interface Entities_Notification_MarkAsRead_Request {
  notificationId: number;
}

export interface Entities_Notification_Sent_Response {
  notifications: Entities_Notification_Sent_Response_NotificationItem[];
  totalCount: number;
}

export interface Entities_Notification_Sent_Response_NotificationItem {
  id: number;
  loginId: LoginId;
  senderLoginId: LoginId;
  moduleId: number | undefined;
  moduleVariant: number;
  unread: boolean | undefined;
  incentiveGiven: boolean;
  type: string | undefined;
  subject: string | undefined;
  message: string | undefined;
  created: Date;
  modified: Date | undefined;
  isDeleted: boolean;
  deleted: Date | undefined;
  receiverDisplayName: string;
}

export interface Entities_Pdf_GeneratePdf_Request {
  url: string;
  token: string;
  loginType: LoginType;
  loginId: LoginId;
  entityId: number;
  entityLevel: EntityLevel;
  name: string;
}

export interface Entities_Pdf_MembershipCardsPdf_Request {
  entityId: number;
  entityLevel: EntityLevel;
  cardType: MembershipCardType;
  name: string;
}

export interface Entities_Player_Achievements_Response {
  playerHubInfo: Database_Procs_GetPlayerHubInfo_Item;
}

export interface Entities_Player_ActivateFamilyLink_Request {
  playerId: PlayerId;
  loginId: LoginId;
}

export interface Entities_Player_ActivateFamilyLink_Response {
  familyLinkId: string;
  familyLinkUserName: string;
  familyLinkPassword: string;
}

export interface Entities_Player_Activity_GameActivity {
  name: string;
  timestamp: Date;
  moduleId: number;
  moduleAreaId: number;
  stickers: number;
}

export interface Entities_Player_Activity_Response {
  count: number;
  activityData: Entities_Player_Activity_GameActivity[];
}

export interface Entities_Player_AllQuests_Response {
  questItems: Database_Procs_GetAllQuest_Item[];
}

export interface Entities_Player_AssignGrade_Request {
  playerId: PlayerId;
  grade: SpecialGradeLevel;
}

export interface Entities_Player_AssignToSchool_Request {
  playerId: PlayerId;
  schoolId: SchoolId;
  grade: SpecialGradeLevel;
  year: string;
}

export interface Entities_Player_AssignToUnassignedTeam_Request {
  playerId: PlayerId;
  schoolId: SchoolId;
  grade: number;
}

export interface Entities_Player_Avatar_Response {
  stickers: number;
  playerBadgeIcon: number;
  playerBadgeBackground: number;
}

export interface Entities_Player_Badges_Response {
  badges: Database_Procs_GetPlayerBadge_Item[];
}

export interface Entities_Player_Contest_Response {
  contest: Database_Procs_GetContest_Item;
}

export interface Entities_Player_EvaluateQuestBadge_Request {
  playerId: PlayerId;
}

export interface Entities_Player_Focus_Response {
  teamFocusMode: Entities_FocusMode;
  playerFocusMode: Entities_FocusMode;
}

export interface Entities_Player_GymProgress_Response {
  completed: number;
}

export interface Entities_Player_Index_Response {
  playersOfDay: Database_Procs_GetTeamPotD_Item[];
  topPlayers: Database_Procs_TeamTopPlayers_Item[] | undefined;
  player: Database_Procs_GetPlayerStickersByPlayerId_Item;
  family: Database_Procs_GetPlayerFamily_Item;
  team: Database_Procs_TeamStickerSummary_Item;
  teamFocusMode: Entities_FocusMode;
  playerFocusMode: Entities_FocusMode;
  expiration: Database_Procs_GetIndividualSubscriptionExpiration_Item;
  teamLeaderLoginId: number;
  teamLeaderDisplayName: string | undefined;
}

export interface Entities_Player_JustTheFactsPlayerProgress_Response {
  factMatrix: number[][];
}

export interface Entities_Player_JustTheFactsProgress_Response {
  pretestFactString: string;
  posttestFactString: string;
  controlledFactString: string;
  correctPretest: number;
  correctPosttest: number;
  correctControlled: number;
  correctHighest: number;
  isControlled: boolean;
  quad: number;
}

export interface Entities_Player_KnowAndShowProgress_Response {
  round: number;
  currentScore: number;
  bestScore: number;
}

export interface Entities_Player_PlayerMeta_Response {
  playerId: PlayerId;
  intValue: number;
  textValue: string;
}

export interface Entities_Player_ProgressSummary_Response {
  vif: Entities_Player_ProgressSummary_Vif;
  stickers: number;
  stickers1W: number;
  stickers2W: number;
  currentStreak: number;
  bestStreak: number;
  winnerCircleCount: number;
  k2Enabled: boolean;
  bonusGoldCount: number;
  mwGoldCount: number;
  k2GoldCount: number;
  games: { [key: string]: number };
  ss: {
    [key: string]: { [key: string]: Entities_Player_ProgressSummary_StarInfo };
  };
  gyms: Gyms2;
  jtf: { [key: string]: Anonymous };
  ks: Ks2;
}

export interface Entities_Player_ProgressSummary_StarInfo {
  star: number;
  totalTime: number;
}

export interface Entities_Player_ProgressSummary_Vif {
  add: number;
  sub: number;
  mul: number;
  div: number;
}

export interface Entities_Player_Progress_Response {
  extendedData: string | undefined;
  round: number;
  game: number;
  finishedEarning: boolean;
}

export interface Entities_Player_Quests_Response {
  stickers: number | undefined;
  stickers1D: number | undefined;
  stickers1W: number | undefined;
  questItems: Database_Procs_GetPlayerQuest_Item[];
}

export interface Entities_Player_Reset_Request {
  playerId: PlayerId;
}

export interface Entities_Player_SkillSetProgress_Response {
  playerId: PlayerId;
  moduleId: ModuleInfo;
  round: number;
  level: number;
}

export interface Entities_Player_TimeOnTask_Request {
  playerId: PlayerId;
  moduleId: number;
  moduleVariant: number;
  progressType: TimeOnTaskProgressType;
  timeOnTask: number;
}

export interface Entities_Player_UpdateBadge_Request {
  playerId: PlayerId;
  icon: number;
  background: number;
}

export interface Entities_Player_UpdateContest_Request {
  playerId: PlayerId;
  salt: string;
  hash: string;
  contestId: number;
  round1Score: number;
  round2Score: number;
  round3Score: number;
  totalScore: number;
  round1Time: number;
  round2Time: number;
  round3Time: number;
  currentRound: number;
}

export interface Entities_Player_UpdateFocus_Request {
  teamId: TeamId;
  playerIds: number[];
  focusMode: Entities_FocusMode;
}

export interface Entities_Player_UpdateGymProgress_Request {
  playerId: PlayerId;
  moduleId: number;
  gameNumber: number;
  round: number;
  won: number;
  score: number;
  time: number;
}

export interface Entities_Player_UpdateJustTheFactsProgress_Request {
  playerId: PlayerId;
  moduleId: number;
  score: number;
  quad: number;
  gameData: string;
  timeOnTask: number;
  isControlled: number;
}

export interface Entities_Player_UpdateJustTheFactsProgress_Response {
  stickers: number;
}

export interface Entities_Player_UpdateKnowAndShowProgress_Request {
  playerId: PlayerId;
  moduleId: number;
  round: number;
  score: number;
  scoreIncrement: number;
}

export interface Entities_Player_UpdateMeta_Request {
  playerId: PlayerId;
  salt: string;
  hash: string;
  metaKey: string;
  intValue: number;
  textValue: string;
}

export interface Entities_Player_UpdatePrimaryTeam_Request {
  playerId: PlayerId;
  teamId: TeamId;
}

export interface Entities_Player_UpdateProgress_Request {
  playerId: PlayerId;
  salt: string;
  hash: string;
  moduleId: number;
  moduleVariant: number;
  round: number;
  game: number;
  advanceProgress: boolean;
  score: number;
  bonus: number;
  extendedData: string;
  timeOnTask: number;
}

export interface Entities_Player_UpdateProgress_Response {
  stickers: number;
}

export interface Entities_Player_UpdateSkillSetProgress_Request {
  playerId: PlayerId;
  salt: string;
  hash: string;
  moduleId: number;
  round: number;
  level: number;
  score: number;
  time: number;
}

export interface Entities_Player_UpdateSkillSetProgress_Response {
  result: number;
}

export interface Entities_Player_UpdateVIFStage_Request {
  playerId: PlayerId;
  operation: ArithmeticOperation;
  stage: number;
}

export interface Entities_Player_UpdateVIFStage_Response {
  stage: number;
}

export interface Entities_Player_UpdateWdykTestAnswers_Request {
  playerId: PlayerId;
  wdykTestId: number;
  answeredQuestionNumber: number;
  cumulativeQuestionNumber: number;
  time: number;
  isCorrect: boolean;
  answerGiven: number;
  isTimeSync: boolean;
}

export interface Entities_Player_VIFStage_Response {
  stage: number;
}

export interface Entities_Player_WDYKTemplateQuestions_Response {
  wdykQuestions: Entities_Player_WDYKTemplateQuestions_WDYKQuestion[];
}

export interface Entities_Player_WDYKTemplateQuestions_WDYKQuestion {
  questionNumber: number;
  ksId: number;
  skillLevel: number;
  category: number;
  ksProblemNumber: number;
  standardCorrelation: string;
  question: string;
  spokenQuestion: string;
  hasAudio: boolean;
  image: string;
  hint: string;
  spokenHint: string;
  hintImage: string;
  choices: string[];
  spokenChoices: string[];
  code: number;
}

export interface Entities_Player_WDYKTest_Response {
  wdykTest: Database_Procs_GetWDYKTest_Item;
}

export interface Entities_Player_WordProblems_Question {
  number: number;
  question: string;
  spokenQuestion: string;
  hasAudio: boolean;
  image: string;
  hint: string;
  spokenHint: string;
  hintImage: string;
  choices: string[];
  spokenChoices: string[];
  code: number;
}

export interface Entities_Player_WordProblems_Response {
  questions: Entities_Player_WordProblems_Question[];
}

export interface Entities_Rankings_CombinedFamilyDistrict_Response {
  combinedFamilyDistrictRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_CombinedFamilyNational_Response {
  combinedFamilyNationalRankings: Database_Procs_RankingsPlayerNation_Item[];
}

export interface Entities_Rankings_CombinedFamilySchool_Response {
  combinedFamilySchoolRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_CombinedFamilyState_Response {
  combinedFamilyStateRankings: Database_Procs_RankingsPlayerState_Item[];
}

export interface Entities_Rankings_CombinedFamilySystem_Response {
  combinedFamilySystemRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_EducatorDistrict_Response {
  educatorDistrictRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_EducatorNational_Response {
  educatorNationalRankings: Database_Procs_RankingsPlayerNation_Item[];
}

export interface Entities_Rankings_EducatorSchool_Response {
  educatorSchoolRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_EducatorState_Response {
  educatorStateRankings: Database_Procs_RankingsPlayerState_Item[];
}

export interface Entities_Rankings_EducatorSystem_Response {
  educatorSystemRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_FamilyDistrict_Response {
  familyDistrictRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_FamilyNational_Response {
  familyNationalRankings: Database_Procs_RankingsPlayerNation_Item[];
}

export interface Entities_Rankings_FamilySchool_Response {
  familySchoolRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_FamilyState_Response {
  familyStateRankings: Database_Procs_RankingsPlayerState_Item[];
}

export interface Entities_Rankings_FamilySystem_Response {
  familySystemRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_PlayerDistrict_Response {
  playerDistrictRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_PlayerInternational_Response {
  playerInternationalRankings: Database_Procs_RankingsPlayerInternational_Item[];
}

export interface Entities_Rankings_PlayerNational_Response {
  playerNationalRankings: Database_Procs_RankingsPlayerNation_Item[];
}

export interface Entities_Rankings_PlayerSchool_Response {
  playerSchoolRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_PlayerState_Response {
  playerStateRankings: Database_Procs_RankingsPlayerState_Item[];
}

export interface Entities_Rankings_PlayerSystem_Response {
  playerSystemRankings: Database_Procs_RankingsPlayerLocal_Item[];
}

export interface Entities_Rankings_SchoolDistrict_Response {
  schoolDistrictRankings: Database_Procs_RankingsSchoolLocal_Item[];
}

export interface Entities_Rankings_SchoolInternational_Response {
  schoolInternationalRankings: Database_Procs_RankingsSchoolInternational_Item[];
}

export interface Entities_Rankings_SchoolNational_Response {
  schoolNationalRankings: Database_Procs_RankingsSchoolNation_Item[];
}

export interface Entities_Rankings_SchoolState_Response {
  schoolStatesRankings: Database_Procs_RankingsSchoolState_Item[];
}

export interface Entities_Rankings_SchoolSystem_Response {
  schoolSystemRankings: Database_Procs_RankingsSchoolLocal_Item[];
}

export interface Entities_Rankings_TeamDistrict_Response {
  teamDistrictRankings: Database_Procs_RankingsTeamLocal_Item[];
}

export interface Entities_Rankings_TeamInternational_Response {
  teamInternationalRankings: Database_Procs_RankingsTeamInternational_Item[];
}

export interface Entities_Rankings_TeamNational_Response {
  teamNationalRankings: Database_Procs_RankingsTeamNation_Item[];
}

export interface Entities_Rankings_TeamSchool_Response {
  teamSchoolRankings: Database_Procs_RankingsTeamLocal_Item[];
}

export interface Entities_Rankings_TeamState_Response {
  teamStateRankings: Database_Procs_RankingsTeamState_Item[];
}

export interface Entities_Rankings_TeamSystem_Response {
  teamSystemRankings: Database_Procs_RankingsTeamLocal_Item[];
}

export interface Entities_Response_Team_Player {
  playerId: PlayerId;
  loginId: LoginId;
  idNumber: string;
  displayName: string;
  firstName: string;
  lastName: string;
  userId: UserId;
  password: string;
  altUser: UserId;
  altPassword: string;
  classificationGroup: string;
  stickers: number;
  isPrimaryTeam: boolean;
}

export interface Entities_Response_Team_School {
  id: number;
  name: string;
}

export interface Entities_Response_Team_Teacher {
  userId: UserId | undefined;
  loginId: LoginId;
  name: string | undefined;
}

export interface Entities_Savings_Index_Response {
  stickers: number;
  numberofLicenses: number;
  numberOfPlayers: number;
  averageStickers: number;
  mathProblemsSolved: number;
  worksheetsSaved: number;
  worksheetsSavedAmount: number;
  teacherHoursSaved: number;
  teacherHoursSavedAmount: number;
  totalSavedDollars: number;
}

export interface Entities_School_AssignTeachers_Join {
  teacherLoginId: number;
  teamId: TeamId;
}

export interface Entities_School_AssignTeachers_Response {
  teams: Entities_School_AssignTeachers_Team[];
  teachers: Entities_School_AssignTeachers_Teacher[];
  joins: Entities_School_AssignTeachers_Join[];
}

export interface Entities_School_AssignTeachers_Teacher {
  loginId: LoginId;
  userId: UserId;
  displayName: string;
  contactId: number;
  contactEmail: string;
}

export interface Entities_School_AssignTeachers_Team {
  id: number;
  name: string;
  grade: number;
  className: string;
  loginId: LoginId;
  loginContactId: number | undefined;
}

export interface Entities_School_Edit_Response {
  school: Database_Procs_GetSchoolInfoWithContact_Item;
  contacts: Database_Procs_GetSchoolContacts_Item[];
}

export interface Entities_School_Index_Response {
  adminName: string;
  principalName: string;
  averageStickers: number;
  problemsSolved: number;
  teamOfTheMonth: Database_Procs_GetTeamMonth_Item;
  teamOfTheWeek: Database_Procs_GetTeamWeek_Item;
  playerOfTheWeek: Database_Procs_GetPlayerWeek_Item;
  schoolStats: Database_Procs_GetSchoolStats_Item;
  linkedSchools: Database_Procs_GetLinkedSchools_Item[];
  linkedTeams: Database_Procs_GetLinkedTeams_Item[];
}

export interface Entities_School_MetaItem {
  intValue: number | undefined;
  textValue: string;
}

export interface Entities_School_Meta_Response {
  metaItems: Entities_School_MetaItem[];
}

export interface Entities_School_MovePlayers_Player {
  id: number;
  userId: UserId;
  displayName: string;
  idNumber: string;
  loginId: LoginId;
  firstName: string;
  lastName: string;
  altUser: UserId;
}

export interface Entities_School_MovePlayers_Response {
  teams: Entities_School_MovePlayers_Team[];
}

export interface Entities_School_MovePlayers_Team {
  id: TeamId;
  name: string;
  grade: number;
  className: string;
  teacherName: string;
  players: Entities_School_MovePlayers_Player[];
  isPlaceholder: boolean;
  isPlaceholderSchool: boolean;
}

export interface Entities_School_Players_Response {
  groups: Database_Tables_LoginGroup[];
  players: Database_Procs_ExportSchool_Item[];
}

export interface Entities_School_SchoolHistory_Response {
  schoolHistory: Database_Procs_GetSchoolHistory_Item;
}

export interface Entities_School_Staff_Contact {
  id: number;
  name: string;
  email: string;
  refCountTeam: number;
  refCountSchool: number;
  isAdminOfSpecifiedSchool: boolean;
  userId: UserId;
  password: string;
  loginId: LoginId;
  loginType: number;
  entityLevel: number;
  latestLogin: Date | undefined;
  teams: Entities_School_Staff_Team[];
}

export interface Entities_School_Staff_Response {
  contacts: Entities_School_Staff_Contact[];
}

export interface Entities_School_Staff_Team {
  id: number;
  name: string;
}

export interface Entities_School_Summary_Response {
  summary: Database_Procs_SchoolSummaryByTeam_Item[];
}

export interface Entities_School_Teachers_Response {
  teachers: Entities_School_Teachers_Teacher[];
}

export interface Entities_School_Teachers_Teacher {
  name: string;
  email: string;
}

export interface Entities_School_Teams_Contact {
  id: number;
  loginId: LoginId;
  name: string;
  displayName: string;
  userId: UserId;
  password: string;
}

export interface Entities_School_Teams_Join {
  teacherLoginId: number;
  teamId: TeamId;
}

export interface Entities_School_Teams_Response {
  teams: Database_Procs_AdminMoveGetSchoolTeams_Item[];
  contacts: Entities_School_Teams_Contact[];
  joins: Entities_School_Teams_Join[];
}

export interface Entities_School_Top_Grade {
  gradeName: string;
  teamOfTheMonth: Database_Procs_GetTeamMonth_Item;
  playerOfTheMonth: Database_Procs_GetPlayerMonth_Item;
  teamOfTheWeek: Database_Procs_GetTeamWeek_Item;
  playerOfTheWeek: Database_Procs_GetPlayerWeek_Item;
  topTeams: Database_Procs_GetTopTeams_Item[];
  topPlayers: Database_Procs_GetTopPlayers_Item[];
  playersPotD: Database_Procs_SchoolPlayersPotD_Item[];
}

export interface Entities_School_Top_Response {
  grades: Entities_School_Top_Grade[];
}

export interface Entities_School_UpdateContact_Request {
  schoolId: SchoolId;
  contactId: number;
}

export interface Entities_School_Update_Request {
  schoolId: SchoolId;
  password: string;
}

export interface Entities_School_WallOfFame_LevelData {
  level: number;
  header: string;
  schoolPlayers: Database_Procs_GetSchoolPlayers_Item[];
}

export interface Entities_School_WallOfFame_Response {
  levelsData: Entities_School_WallOfFame_LevelData[];
}

export interface Entities_Speech_GetSpeechToken_Response {
  token: string;
  region: string;
  expiresOn: Date;
}

export interface Entities_TeamJtfSummary {
  justTheFactsMode: JtfMode;
  arithmeticOp: ArithmeticOperation;
  jtfByEntityAllOps: Database_Procs_JTFByEntityAllOps_Item;
}

export interface Entities_Team_AddAppFeedback_Request {
  loginId: LoginId;
  data: Entities_Team_AddAppFeedback_SwitchReason;
}

export interface Entities_Team_AddAppFeedback_SwitchReason {
  reasonTitle: string;
  reasonDescription: string;
}

export interface Entities_Team_AddUserFeedback_FeedbackDetails {
  subject: string | undefined;
  message: string | undefined;
  images: Entities_Team_AddUserFeedback_ImageDetail[] | undefined;
}

export interface Entities_Team_AddUserFeedback_ImageDetail {
  data: string;
  fileName: string;
}

export interface Entities_Team_AddUserFeedback_Request {
  loginId: LoginId;
  feedbackDetails: Entities_Team_AddUserFeedback_FeedbackDetails;
}

export interface Entities_Team_CreateMultiplePlayers_PlayerCreationResult {
  player: Entities_Team_CreateMultiplePlayers_PlayerDetail;
  loginId: LoginId;
  playerId: PlayerId;
  userId: UserId;
  password: string;
}

export interface Entities_Team_CreateMultiplePlayers_PlayerDetail {
  teamId: TeamId;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  classificationGroup: string | undefined;
}

export interface Entities_Team_CreateMultiplePlayers_Request {
  players: Entities_Team_CreateMultiplePlayers_PlayerDetail[];
}

export interface Entities_Team_CreateMultiplePlayers_Response {
  results: Entities_Team_CreateMultiplePlayers_PlayerCreationResult[];
}

export interface Entities_Team_EnsureTeacherPlayer_Request {
  loginId: LoginId;
  teamId: TeamId;
}

export interface Entities_Team_EnsureTeacherPlayer_Response {
  playerId: PlayerId;
}

export interface Entities_Team_Focus_Player {
  id: number;
  userId: UserId;
  name: string;
  stickerCount: number;
  focusMode: Entities_FocusMode;
  isPrimaryTeam: boolean;
}

export interface Entities_Team_Focus_Response {
  entityId: number;
  entityLevel: EntityLevel;
  team: Database_Tables_Team;
  focusMode: Entities_FocusMode;
  players: Entities_Team_Focus_Player[];
}

export interface Entities_Team_GenerateNewUserId_Request {
  loginId: LoginId;
}

export interface Entities_Team_GenerateNewUserId_Response {
  userId: UserId;
  familyLink: boolean;
}

export interface Entities_Team_GetLinkedTeams_MyTeams {
  id: TeamId;
  name: string | undefined;
  className: string | undefined;
  teacher: Entities_Response_Team_Teacher;
  coTeachers: Entities_Response_Team_Teacher[] | undefined;
}

export interface Entities_Team_GetTeamPlayerOfTheDay_PlayerOftheDay {
  userId: UserId | undefined;
  playerId: PlayerId;
  loginId: LoginId;
  displayName: string | undefined;
  badgeIcon: number;
  badgeBg: number;
  stickers: number;
  stickerDelta: number;
  notificationSent: number;
  hash: string | undefined;
}

export interface Entities_Team_Index_IndexData {
  topPlayers: Database_Procs_TeamTopPlayers_Item[];
  playersOfDay: Entities_Team_GetTeamPlayerOfTheDay_PlayerOftheDay[];
  mySchools: Entities_Response_Team_School[];
  myTeams: Entities_Team_GetLinkedTeams_MyTeams[];
}

export interface Entities_Team_Index_Response {
  data: Entities_Team_Index_IndexData[];
}

export interface Entities_Team_MembershipCards_Response {
  membershipCards: Database_Procs_PrintMembershipCards_Item[];
}

export interface Entities_Team_MovePlayer_Request {
  fromTeamId: number;
  toTeamId: number;
  userId: UserId;
  loginId: LoginId;
}

export interface Entities_Team_MovePlayer_Response {
  userId: UserId;
  familyLink: boolean;
}

export interface Entities_Team_MovePlayers_Player {
  id: PlayerId;
  userId: UserId | undefined;
  displayName: string | undefined;
  idNumber: string | undefined;
  loginId: LoginId;
  firstName: string | undefined;
  lastName: string | undefined;
  altUser: UserId | undefined;
}

export interface Entities_Team_MovePlayers_Response {
  entityLevel: EntityLevel;
  schoolId: SchoolId;
  team: Entities_Team_MovePlayers_Team[];
}

export interface Entities_Team_MovePlayers_Team {
  id: TeamId;
  name: string;
  grade: SpecialGradeLevel;
  className: string;
  teacherName: string;
  players: Entities_Team_MovePlayers_Player[] | undefined;
  isPlaceholder: boolean;
  isPlaceholderSchool: boolean;
}

export interface Entities_Team_RecentActivity_Response {
  recentActivityByTeams: Database_Procs_GetRecentActivityByTeam_Item[];
}

export interface Entities_Team_Roster_Response {
  totalLicenses: number;
  remainingLicenses: number;
  groups: Database_Tables_LoginGroup[];
  details: Database_Procs_TeamStickerSummary_Item;
  players: Entities_Response_Team_Player[];
}

export interface Entities_Team_Teachers_Response {
  teachers: Entities_Team_Teachers_TeacherData[];
}

export interface Entities_Team_Teachers_TeacherData {
  teacher: Entities_Response_Team_Teacher;
  coTeachers: Entities_Response_Team_Teacher[];
}

export interface Entities_Team_TeamHistory_Response {
  teamHistory: Database_Procs_GetTeamHistory_Item;
}

export interface Entities_Team_TeamInformation_Response {
  team: Entities_Team_TeamInformation_Team;
}

export interface Entities_Team_TeamInformation_Team {
  id: TeamId;
  name: string | undefined;
  className: string | undefined;
  grade: SpecialGradeLevel;
  year: string | undefined;
  bestPhase: GoalsIndexPhase;
}

export interface Entities_Team_Team_Response {
  info: Database_Procs_GetTeamInfo_Item;
  contactId: number;
  coTeachers: string[];
}

export interface Entities_Team_UpdateContact_Request {
  teamId: TeamId;
  contactId: number;
}

export interface Entities_Team_UpdateFocus_Request {
  teamId: TeamId;
  focusMode: Entities_FocusMode;
}

export interface Entities_Team_UpdateInfo_Request {
  teamId: TeamId;
  schoolId: SchoolId;
  displayName: string;
  className: string;
  excludeRankings: boolean;
  grade: SpecialGradeLevel;
}

export interface Entities_Team_UpdatePlayer_Request {
  loginId: LoginId;
  displayName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  idNumber: string | undefined;
  altUser: UserId | undefined;
  altPassword: string | undefined;
  classificationGroup: string | undefined;
}

export interface Entities_Team_UpdatePlayer_Response {
  result: number;
  message: string;
}

export interface Entities_Team_UploadFile_Request {
  data: string;
  fileName: string;
}

export interface Entities_Team_UploadFile_Response {
  data: Entities_Team_UploadFile_StudentInfo[];
}

export interface Entities_Team_UploadFile_StudentInfo {
  displayName: string;
  firstName: string;
  lastName: string;
  id: string;
  altLogin: string;
  altPassword: string;
}

export interface Entities_Team_ValidateMultiplePlayers_EntityResult {
  playerDetails: Entities_Team_ValidateMultiplePlayers_PlayerDetails;
  messages: string[];
  status: boolean;
}

export interface Entities_Team_ValidateMultiplePlayers_PlayerDetails {
  displayName: string;
  firstName: string | undefined;
  lastName: string | undefined;
  id: string;
  altLogin: string;
  altPassword: string;
}

export interface Entities_Team_ValidateMultiplePlayers_Request {
  loginId: LoginId;
  allPlayerDetails: Entities_Team_ValidateMultiplePlayers_PlayerDetails[];
}

export interface Entities_Team_ValidateMultiplePlayers_Response {
  data: Entities_Team_ValidateMultiplePlayers_EntityResult[];
}

export interface Entities_WebFlow_HomeConnectionFamilyLink_GroupedCategoryResponse {
  name: string;
  'categories-subtext': string;
  subcategory: Entities_WebFlow_HomeConnectionFamilyLink_SubCategoryResponse[];
}

export interface Entities_WebFlow_HomeConnectionFamilyLink_Response {
  categories: Entities_WebFlow_HomeConnectionFamilyLink_GroupedCategoryResponse[];
}

export interface Entities_WebFlow_HomeConnectionFamilyLink_SubCategoryResponse {
  name: string;
  link: string;
}

export interface Entities_WebFlow_HomeConnectionInfo_InfoForParentsFieldData {
  'title-link': string;
  'title-sub-text': string;
  name: string;
}

export interface Entities_WebFlow_HomeConnectionInfo_Response {
  titleInfoFieldData: Entities_WebFlow_HomeConnectionInfo_TitleInfoFieldData[];
  infoForParentsFieldData: Entities_WebFlow_HomeConnectionInfo_InfoForParentsFieldData[];
}

export interface Entities_WebFlow_HomeConnectionInfo_TitleInfoFieldData {
  'parents-descriptions': string;
  name: string;
}

export interface Entities_WebFlow_Recognition_Icon {
  url: string;
  alt: string;
}

export interface Entities_WebFlow_Recognition_InfoFieldDataResponse {
  'youtube-video-link': string;
  'recognition-description': string;
  name: string;
}

export interface Entities_WebFlow_Recognition_Response {
  toolsFieldData: Entities_WebFlow_Recognition_ToolsFieldData[];
  infoFieldData: Entities_WebFlow_Recognition_InfoFieldDataResponse;
}

export interface Entities_WebFlow_Recognition_ToolsFieldData {
  'view-detail-link': string;
  name: string;
  icon: Entities_WebFlow_Recognition_Icon;
}

export interface Entities_WebFlow_Resources_ResourceItem {
  name: string;
  pdfLink: string;
}

export interface Entities_WebFlow_TutorialsAdditionalLinks_LinkItems {
  name: string;
  link: string;
  'friendly-name': string;
  'media-id': string;
}

export interface Entities_WebFlow_TutorialsAdditionalLinks_Response {
  links: Entities_WebFlow_TutorialsAdditionalLinks_LinkItems[];
}

export interface Entities_WebFlow_TutorialsGameExamples_Game {
  'game-link': string;
  'sub-text': string;
  name: string;
  'friendly-name': string;
  'media-id': string;
}

export interface Entities_WebFlow_TutorialsGameExamples_GameExample {
  'link-for-list-of-games': string;
  'list-of-game-lable': string;
  name: string;
  'section-order': string;
  subCategories: Entities_WebFlow_TutorialsGameExamples_SubCategory[];
}

export interface Entities_WebFlow_TutorialsGameExamples_Response {
  gameExamples: Entities_WebFlow_TutorialsGameExamples_GameExample[];
}

export interface Entities_WebFlow_TutorialsGameExamples_SubCategory {
  name: string;
  games: Entities_WebFlow_TutorialsGameExamples_Game[];
}

export interface Entities_WebFlow_TutorialsLearningTools_CategoryItem {
  name: string;
  'sub-title': string;
  'friendly-name': string;
  'media-id': string;
  'subtitle-link': string;
  tutorials: Entities_WebFlow_TutorialsLearningTools_TutorialsItem[];
}

export interface Entities_WebFlow_TutorialsLearningTools_Response {
  categories: Entities_WebFlow_TutorialsLearningTools_CategoryItem[];
}

export interface Entities_WebFlow_TutorialsLearningTools_TutorialsIcon {
  fileId: string;
  url: string;
  alt: string;
}

export interface Entities_WebFlow_TutorialsLearningTools_TutorialsItem {
  'view-details-link': string;
  'tutorials-details': string;
  name: string;
  'tutorials-icon': Entities_WebFlow_TutorialsLearningTools_TutorialsIcon;
  'friendly-name': string;
  'media-id': string;
}

export interface Entities_WebFlow_TutorialsVPD_Response {
  items: Entities_WebFlow_TutorialsVPD_VPDItems[];
}

export interface Entities_WebFlow_TutorialsVPD_VPDItems {
  'video-link': string;
  name: string;
  'getting-started-label': string;
  'getting-started-link': string;
  'getting-started-title': string;
  'tour-item-link': string;
  'tour-label': string;
  'tour-title': string;
  'tutorial-intro': string;
  'friendly-name': string;
  'media-id': string;
}

export interface Models_Api_Admin_DistrictsByRegion_Response {
  items: Database_Procs_AdminGetDistricts_Item[];
}

export interface Models_Api_Admin_Districts_District {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  regionId: number;
  regionName: string;
  city: string;
  state: string;
  bpcCode: string;
  pid: string;
}

export interface Models_Api_Admin_Districts_Response {
  count: number;
  items: Models_Api_Admin_Districts_District[];
}

export interface Models_Api_Admin_Players_Player {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  teamId: TeamId;
  teamName: string;
  altUserId: string;
  altPassword: string;
  idNumber: string;
  firstName: string;
  lastName: string;
}

export interface Models_Api_Admin_Players_Response {
  count: number;
  items: Models_Api_Admin_Players_Player[];
}

export interface Models_Api_Admin_RegionsByState_Response {
  items: Database_Procs_AdminGetRegions_Item[];
}

export interface Models_Api_Admin_Regions_Region {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  stateName: string;
  city: string;
  state: string;
  bpcCode: string;
  pid: string;
}

export interface Models_Api_Admin_Regions_Response {
  count: number;
  items: Models_Api_Admin_Regions_Region[];
}

export interface Models_Api_Admin_SchoolsByDistrict_Response {
  items: Database_Procs_AdminGetSchools_Item[];
}

export interface Models_Api_Admin_Schools_Response {
  count: number;
  items: Models_Api_Admin_Schools_School[];
}

export interface Models_Api_Admin_Schools_School {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  districtId: number;
  districtName: string;
  city: string;
  state: string;
  bpcCode: string;
  pid: string;
}

export interface Models_Api_Admin_StatesByLogin_Response {
  states: Database_Procs_AdminGetStates_Item[];
}

export interface Models_Api_Admin_States_Response {
  count: number;
  items: Models_Api_Admin_States_State[];
}

export interface Models_Api_Admin_States_State {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  code: string;
}

export interface Models_Api_Admin_TeamsBySchool_Response {
  items: Database_Procs_AdminGetTeams_Item[];
}

export interface Models_Api_Admin_Teams_Contact {
  name: string;
}

export interface Models_Api_Admin_Teams_Response {
  count: number;
  items: Models_Api_Admin_Teams_Team[];
}

export interface Models_Api_Admin_Teams_Team {
  stateId: number;
  id: number;
  name: string;
  loginId: LoginId;
  userId: UserId;
  password: string;
  schoolId: SchoolId;
  schoolName: string;
  grade: number;
  year: string;
  className: string;
  orderNumber: number | undefined;
  poNumber: string;
  contacts: Models_Api_Admin_Teams_Contact[];
}

export interface Gyms {
  num: Num;
  frc: Frc;
  dec: Dec;
  int: Int;
  k2: K2;
}

export interface Ks {
  '1': { [key: string]: number };
  '2': { [key: string]: number };
  '3': { [key: string]: number };
  '4': { [key: string]: number };
  '5': { [key: string]: number };
  '6': { [key: string]: number };
  '7': { [key: string]: number };
  '8': { [key: string]: number };
}

export interface ResultData {
  add: { [key: string]: boolean };
  sub: { [key: string]: boolean };
  mul: { [key: string]: boolean };
  div: { [key: string]: boolean };
}

export interface ResultData2 {
  add: { [key: string]: boolean };
  sub: { [key: string]: boolean };
  mul: { [key: string]: boolean };
  div: { [key: string]: boolean };
}

export interface VifData {
  add: Common_VifModule[];
  sub: Common_VifModule[];
  mul: Common_VifModule[];
  div: Common_VifModule[];
}

export interface Gyms2 {
  num: Num2;
  frc: Frc2;
  dec: Dec2;
  int: Int2;
  k2: K22;
}

export interface Anonymous {
  num: Num3;
  frc: Frc3;
  dec: Dec3;
  int: Int3;
}

export interface Ks2 {
  '1': { [key: string]: number };
  '2': { [key: string]: number };
  '3': { [key: string]: number };
  '4': { [key: string]: number };
  '5': { [key: string]: number };
  '6': { [key: string]: number };
  '7': { [key: string]: number };
  '8': { [key: string]: number };
}

export interface Num {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Frc {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Dec {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Int {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface K2 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Num2 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Frc2 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Dec2 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Int2 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface K22 {
  add: { [key: string]: number };
  sub: { [key: string]: number };
  mul: { [key: string]: number };
  div: { [key: string]: number };
}

export interface Num3 {
  add: number;
  sub: number;
  mul: number;
  div: number;
}

export interface Frc3 {
  add: number;
  sub: number;
  mul: number;
  div: number;
}

export interface Dec3 {
  add: number;
  sub: number;
  mul: number;
  div: number;
}

export interface Int3 {
  add: number;
  sub: number;
  mul: number;
  div: number;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
